const carrierNames = [
  '1-888-OHIOCOMP',
  '1199 National Benefit Fund',
  '1st Auto & Casualty (Auto)',
  '21st Century Insurance',
  '3P ADMIN',
  '7-Eleven',
  'A & I BENEFIT PLAN ADMINISTRATORS',
  'A Plus Staffing (ALL States) (Auto Only)',
  'A Plus Staffing (ALL States) (WC Only)',
  'A-1 Services & Mobile Home Repair (ALL) AUTO ONLY',
  'A-1 Truck And Trailer Repair (ALL) AUTO ONLY',
  'A-1 Truck And Trailer Repair (ALL) WC ONLY',
  'A.B.F Freight (Fontana, CA) (ALL) AUTO ONLY',
  'A.B.F Freight (Fontana, CA) (ALL) WC ONLY',
  'A.B.F Freight (Fontana, CA) (CA ONLY) [WC, Auto]',
  'A.B.F FREIGHT (PICO RIVERA, CA) (ALL) AUTO ONLY',
  'A.W. Holdings LLC Dba Benchmark (Auto)',
  'AAA Automobile  (Auto Only)  (MN Only)',
  'AAG-American Administrative Group (Formerly Icon Benefit Admin)',
  'AARP FOUNDATION (WC Only)',
  'AARP Medicare Supplement/Fixed Indemnity by UnitedHealthcare',
  'AblePay Health',
  'ABMG Claims & Encounters',
  'Abrazo Advantage Health Plan',
  'Access Administrators',
  'Access Health (MI Only)',
  'Access Medical Group',
  'Accident Fund Insurance Co of America',
  'Accident Fund Insurance of America',
  'Acclaim',
  'Acclamation Insurance (WC Only) (All States)',
  'Accountable Anthem Beverly POD',
  'Accountable HealthCare IPA (MPM)',
  'Accountable IPA',
  'Accuride Corporation (TX, MN) WC ONLY',
  'ACCURIDE CORPORATION (WC Only) (TX,MN Only)',
  'ACE USA',
  'ACM - Blue Shield of California (Home Infusion)',
  'ACM - TUFTS (Home Infusion & Specialty Pharmacy Medical Benefit)',
  'ACS Benefit Services',
  'ACS Benefit Services, Inc.',
  'ACTIN Care Groups/Clifton Health Systems',
  'Activa Benefit Services, LLC',
  'ActivHealthCare',
  'Acuity, A Mutual Insurance Company (ALL States)(WC Only)',
  'Acuity, A Mutual Insurance Company (w/Attachments) (ALL States)(WC Only)',
  'AD- COMP (Auto)',
  'AD- COMP (WC only)',
  'ADAP State of New York Dept of Health Uninsured Primary Care Reimbursement Program',
  'Adelanto Correctional Facility (CA)',
  'Administaff (WC Only) (ALL States)',
  'Administrative Claim Service, Inc',
  'Administrative Claim Service,Inc.',
  'Administrative Concepts, Inc',
  'Administrative Services, Inc',
  'AdminOne',
  'Adminsure (Auto)',
  'Adminsure (WC)',
  'ADP Total Source Inc. (ALL States)(WC Only)',
  'Adult Day Health Care [.ADC] - Medicaid Louisiana',
  'Advance America Cash Advance Centers (WC ONLY)',
  'Advance Auto Parts (MN, TX) [Auto Only]',
  'Advanced Medical Management',
  'Advanced Medical Optics (MN, TX) [WC ONLY]',
  'Advanced Services, Inc. (Auto Only)',
  'Advanced Services, Inc. (WC Only)',
  'Advantage by Bridgeway Health Solutions',
  'Advantage Care IPA',
  'Advantage Health Solutions',
  'Adventist Health System West - Roseville, CA',
  'AdvoCare Incorporated (WC)',
  'Advocate Health Centers',
  'Advocate Health Partners',
  'Advocate Security Health',
  'Aegis Administrative Services',
  'Aegis Security Insurance Company',
  'Aegis Senior Living (MN, TX) [WC ONLY]',
  'Aetna',
  'Aetna (Subrogation Claims Only)',
  'AETNA (WC Only)',
  'Aetna Affordable Health Choices (SM) - SRC',
  'Aetna Better Health - IL Medicaid',
  'Aetna Better Health - PA',
  'AETNA BETTER HEALTH LOUISIANA (EFFECTIVE 2/1/2015)',
  'Aetna Better Health of California',
  'Aetna Better Health of Florida',
  'Aetna Better Health of Kentucky',
  'Aetna Better Health of Michigan',
  'Aetna Better Health of Nevada',
  'Aetna Better Health of New Jersey',
  'Aetna Better Health of New York',
  'Aetna Better Health of Ohio',
  'Aetna Better Health of Virginia',
  'Aetna Better Health of West Virginia',
  'Aetna Encounters Only',
  'AETNA GLOBAL BENEFITS (MN, TX Only) (WC Only)',
  'Aetna Medicare Advantage',
  'Aetna TX Medicaid & CHIP',
  'Affiliated Doctors of Orange County',
  'Affiliated Foods, Inc. (Auto)',
  'Affiliated Physicians Group',
  'Affiliated Physicians IPA',
  'Affinity Essentials (DOS 12/31/17 and Prior)',
  'AFFINITY MEDICAL GROUP',
  'Affordable Benefit Administrators, Inc.',
  'AG Facilities Operations, LLC (WC)',
  'Agate Resources Inc (LIPA) (DOS prior to 06/01/16)',
  'AgeRight Advantage',
  'AgeWell New York',
  'AGIA, Inc.',
  'Agilent Technologies, Inc.',
  'Agua Caliente',
  'AHPO (Cleveland, OH)',
  'AIG CLAIM SERVICES (MEDRISK CONTRACTED PROVIDERS ONLY) (WC ONLY) (ALL STATES)',
  'Air Liquide USA LLC (WC Only) (All States)',
  'Akamai Advantage',
  'AKM Medical Group (CA)',
  'Alameda Alliance for Health',
  'Alamitos IPA',
  "Alaska Children's Services, Inc. Group Number P68",
  'Alaska National Insurance (Auto Only) (All States)',
  'Alaska National Insurance (AUTO)',
  'Alaska National Insurance (WC)',
  'Albuquerque Public Schools',
  'Alcoa Fasteners Systems (ALL States)',
  'Aliera Healthcare',
  'Align Networks',
  'Alignment Health Care (Fee For Service)',
  'AllCare CCO - Medicaid',
  'ALLCARE HEALTHPLAN',
  'AllCare IPA',
  'AllCare PEBB',
  'Allegheny Technologies (ALL States)(WC Only)',
  'Allegian Choice',
  'Allegian Health Plans',
  'Allegiance Benefit Plan Management, Inc.',
  'Allegiance Health Management',
  'Allen Canning',
  'Alliance - Alpha Care Gold',
  'Alliance Coal Health Plan',
  'Alliance Physicians-High Desert',
  'Alliant Energy (Auto Only)(TX and MN only)',
  'Alliant Energy (WC Only)',
  'Alliant Health Plans of Georgia',
  'Allianz (WC Only) (CA Only)',
  'Allied Benefit Systems',
  'Allied Construction (MN,TX,WI) (WC ONLY)',
  'Allied Health Systems Chiropractic',
  'Allied Insurance Companies (TX,MN,CA and LA)',
  'Allina Health Aetna',
  'Allmerica Financial Benefits Insurance Company (Auto ONLY)',
  'Allmerica Financial Benefits Insurance Company (WC ONLY)',
  'Allstate Insurance Company - All states except NJ (Auto Only)',
  'AlohaCare Medicare and Medicaid',
  'Alpha Care Medical Group',
  'AlphaCare of NY',
  'Alta Bates Medical Group (ABMG) - Claims (DOS on or after 07/01/2010)',
  'Alta Med Health Services',
  'Alternative Opportunities',
  'Alternative Paper - CLIA',
  'Alternative Service Concepts (ASC) (Auto Only)',
  'Alternative Service Concepts (ASC) (WC Only)',
  'Alvey Systems (AON Risk) (MN, TX) [WC, Auto]',
  'Alvey Systems (AON Risk) (MN, TX) AUTO ONLY',
  'Alvey Systems (AON Risk) (MN, TX) WC ONLY',
  'ALWAYS VISION',
  'AMA Insurance Agency',
  'Amalgamated Life',
  'AMBAY HEALTH NETWORK',
  'Ambulance Transportation [.TRA] - Medicaid Louisiana',
  'AMCO',
  'AmeraPlan',
  'AmeriBen Solutions, Inc.',
  "America's PPO/America's TPA",
  'Americaid/Amerigroup-for providers located in Houston',
  'American All Risk Insurnace Co (AARIS) (ALL) WC ONLY',
  'AMERICAN BEHAVIOR',
  'American Benefits Management (North Canton OH)',
  'American Casino & Entertainment Properties LLC',
  'American Chiropractic Network',
  'American Chiropractic Network IPA of New York',
  'American Claims Management (ACM) (ALL) AUTO ONLY',
  'American Claims Management ACM ED (WC ONLY)',
  'American Coin Merchandising, Inc (MN, TX) WC ONLY',
  'American Commercial Claim Admin (ALL) (ACCA) WC ONLY',
  'American Cyanamid (MN, TX) WC ONLY',
  'American Express',
  'American Family Insurance (Auto Only)',
  'AMERICAN FAMILY INSURANCE COMPANY',
  'American Family Mutual Insurance Company (AUTO ONLY)',
  'American Family Mutual Insurance Company (WC ONLY)',
  'American Fidelity Assurance Company',
  'American First (WC Only)',
  'American Founders Life Insurance Company (NFL Plans Only)',
  'American General',
  'AMERICAN HEALTH MEDICARE',
  'AMERICAN HOME ASSURANCE',
  'American Home Craft (All States) WC ONLY',
  'American Honda Motor Co., Inc. (MN, TX) [WC ONLY]',
  'American Insurance Company of Texas',
  'American Interstate -TX only WC ONLY',
  'American Life Care',
  'AMERICAN MANUFACTURERS MUTUAL INS (ALL) [WC, Auto]',
  'American Medical Life Insurance',
  'American Medical Security, Inc.',
  'American Mining Insurance Group (WC ONLY)',
  'American National Insurance Co (ANICO)',
  'American National Property & Casualty Ins (Auto Only)(CA,MN,TX)',
  'American National Property and Casualty Co (Auto Only) (MN Only)',
  'American National Property and Casualty Co (MN)',
  'American Postal Workers Union (APWU) (DOS 1/1/18 and After)',
  'American Postal Workers Union (APWU) (DOS 12/31/17 and prior)',
  'American Sentinel Insurance Company',
  'AMERICAN SPECIALTY COMPANIES (CA, MN, TX ONLY) AUTO ONLY',
  'AMERICAN SPECIALTY COMPANIES (CA, MN, TX ONLY) WC ONLY',
  'American Specialty Companies (CA, MN, TX) [WC, Auto]',
  'American Specialty Health',
  'American Specialty Ins. / MIB (CA, MN, TX) [WC, Auto]',
  'American Specialty Ins. / MIB (TX, MN)',
  'AMERICAN SPECIALTY INS. / MIB (WC Only) (TX,MN Only)',
  'American Therapy Administrators',
  'American Worker Health Plan Family',
  'AMERICAN ZURICH (WC Only)(CA, TX, & MN ONLY)',
  'Americas Choice HealthPlans/NMA',
  'AmeriChoice San Diego County Physician Emergency Services',
  'Americhoice Tenncare',
  'Amerigroup',
  'Amerigroup (Encounters Only)',
  'AMERIGROUP CORPORATION',
  'AmeriHealth Administrators & Inter-County - TPA Suffix',
  'AmeriHealth Caritas Delaware',
  'AmeriHealth Caritas Iowa',
  'AmeriHealth Caritas Louisiana',
  'AmeriHealth Caritas Pennsylvania',
  'AmeriHealth Caritas VIP Care',
  'AmeriHealth Caritas VIP Care Plus (Michigan)',
  'Amerihealth D.C. (for claims on or after May 1, 2013)',
  'Amerihealth DE - PPO - Q2B Prefix',
  'AmeriHealth HMO',
  'Amerihealth HMO New Jersey and Delaware  DOS prior to 08/01/2013',
  'AmeriHealth NorthEast',
  'Amerihealth PPO (NJ)',
  'Ameriprise Auto & Home Ins. (Auto Only)',
  'Ameriprise Auto & Home Insurance (Auto Only) (MN Only)',
  'Amerisure',
  'Amerisure Insurance (WC Only)',
  'Amerisure Mutual Insurance (WC Only) (TX,MN Only)',
  'Amerisure Mutual Insurance [WC ONLY]',
  'AmFirst Insurance Company',
  'AmGuard Insurance Company - Guard DBA',
  'Amica Mutual Insurance Company (Auto Only) (MN Only)',
  'Amida Care Medicare',
  'AMTRUST INSURANCE CO OF KANSAS - Rochdale Ins Co (MN,TX,CA Only) (WC Only)',
  'Amtrust North America (CA, MN, TX Only)',
  'Anchor Benefits',
  'Anchor Claims Management',
  'Anchor Glass Container Corporation (Auto Only)',
  'Anchor Glass Container Corporation (WC Only)',
  'Ancillary Benefit Systems/AZ Foundation for Med Cr',
  'Anheuser Busch (Auto only)',
  'Anheuser-Busch (Carson, CA) (ALL) WC ONLY',
  'Antares Management Solutions Westlake OH',
  'Anthem Health Keepers Plus',
  'Anthem HealthKeepers Medicare Advantage',
  'Aon Risk Service (Irvine, CA)',
  'Apex Benefit Services',
  'APEX BULK  (MN, TX) WC Only',
  'Apogee Enterprises Inc. (MN, TX,CA Only) [WC ONLY]',
  'Apollo Healthcare IPA',
  'Apostrophe',
  'Applied Underwriters',
  'Apria Healthcare (Oxnard, CA) (ALL) AUTO ONLY',
  'APS HEALTHCARE OF PUERTO RICO',
  'AR-CMI Wal-Mart TX',
  'Arakelian Enterprises (CA only) (WC Only)',
  'Arakelian Enterprises,Inc (All States except CA)',
  'Aramark',
  'ARAZ',
  'ARC Administrators',
  'Arcadian Management Services Inc',
  'Archer Daniels Midland Company (Auto only)',
  'Areas USA, Inc. (Auto only)',
  'Areas USA, Inc. (WC only)',
  'Argent',
  'Argent (Subsidiary of West Bend but this route is Argent only)',
  'Argent (WC Only)',
  'ARGONAUT INSURANCE CO (TX, MN,CA,LA Only) (WC Only)',
  'Argonaut Northwest Insurance Company (WC Only)',
  'Argus',
  'Arise Health Plan',
  'Arizona Physicians IPA (UHC) Community Plan',
  'Arizona Pipe Trades',
  'ARM, Ltd',
  'Arrowpoint',
  'Arta Health Network',
  'ASAGEHA',
  'Asian American Medical Group',
  'ASPEN INSURANCE',
  'Aspire Health Plan',
  'Aspirus Arise',
  'Asr Constructors (MN, TX) [WC ONLY]',
  'ASR Health Benefits',
  'ASRM LLC',
  'Assigned Risk Solutions (WC Only)',
  'Associated Benefits Corp DOS Prior to 1/1/2014',
  'Associated Health Professionals Inc (MN, TX) [WC ONLY]',
  'Associated Hispanic Physicians IPA',
  'Associated Third Party Administration (ATPA)',
  'Associates for Health Care Inc (AHC)',
  'Association Casualty Insurance Company (ALL States)',
  'Association County Commissioners Of Georgia (ACCG) (WC Only) (All States)',
  'Assurance Company of America (Commercial Only)',
  'Assurant Health Self Funded',
  'Assured Benefits Administrators',
  'Asuris Northwest Health',
  'AT&T WORLDWIDE CUSTOMER SERVICE (CA, TX)  WC ONLY',
  'Athens',
  'Atlantic Medical Insurance',
  'Atlantic Mutual',
  'Atlantis Eye Care',
  'Atlas Life Insurance Co (NFIC Plan Only)',
  'Atrio Health Plans',
  'Audionet - National Elevator',
  'Audionet - UAW Ford retirees/GM employees',
  'Audionet - UAW GM retirees/Chrysler emps & retirees',
  'AudioNet America',
  'AultCare',
  'Aultra Administrative Group',
  'Austin Resolutions (All states) (WC Only)',
  'Auto Owners Life Insurance Company (CA,MN,TX) (Auto Only)',
  'Auto Owners Life Insurance Company (CA,MN,TX) (WC Only)',
  'Auto-Owners / Home-Owners Insurance Company (Auto Only)',
  'Auto-Owners / Owners Insurance Company',
  'Auto-Owners Insurance Company (WC Only) (TX/MN/CA Only)',
  'Automated Benefit Services',
  'Automated Group Administrators',
  'Autozone, Inc (WC Only) (TX Only)',
  'Auxiant',
  'Avante Health',
  'Avectus Healthcare Solutions',
  'Avera Health Plans',
  'Averde Health',
  'AvMed',
  'AvMed (Encounters Only)',
  'Axminster Medical Group',
  'AYERS TRUCKING (CA, MN, TX ONLY) WC ONLY',
  'AZ Phoenix Health Plans',
  'Bakersfield Family Medical Center',
  'Bakery And Confectionery',
  'BANCINSURE INC (ALL) [WC ONLY]',
  'Bank of America (Auto only)',
  'Bank Of America (MN & TX) [Auto]',
  'BANK OF AMERICA (TX & MN) WC ONLY',
  'Bank of America (WC only)',
  'BANKERS STANDARD INSURANCE COMPANY (Auto Only)',
  'Banner Health',
  'Banner Health and Aetna Health Insurance Company',
  'Banner Health AZ',
  'Banner Health Systems',
  'Banner Healthcare (MN, TX) WC ONLY',
  'Banner- University Family Care (UNIVERSITY OF ARIZONA HEALTH PLANS)',
  'Baptist Health Plan Medicare Advantage',
  'Barnes',
  'Barrett Business Services Inc BBSI (Auto only)',
  'Barrett Business Services Inc, (BBSI) WC ONLY (ANY STATE)',
  'Bass Pro Group, LLC (Auto only)',
  'Bass Pro Group, LLC (WC only)',
  'Bay District Schools (Auto only)',
  'Baycare Life Management',
  'BB&T Corporation (Branch Banking & Trust)(Auto only)',
  'BB&T Corporation (Branch Banking & Trust)(WC only)',
  'BCBS of Georgia (Telemedicine)',
  'BCBS of Indiana (Telemed)',
  'BCBS of Minnesota (Telemedicine)',
  'BCBS of Virginia (Telemed)',
  'BCBS of Virginia -Anthem formerly known as Trigon',
  'BCBS Texas Medicaid (DOS on or after 12/01/15)',
  'BCBS Western New York Medicaid/CHP',
  'BE Aerospace, Inc. (MN, TX) [WC ONLY]',
  'Beacon Health Strategies',
  "BEALL'S INC / MIDWEST EMPLOYERS",
  "Beall's Inc / Midwest Employers (MN, TX) WC ONLY",
  'Beaumont Unified School District (TX ONLY) [WC ONLY]',
  'Beaver Medical Group',
  'Beech Street Corporation',
  'Behavior Health (Riverside, CA)',
  'Behavioral Health Systems',
  'Behavioral Healthcare, Inc.',
  'Bella Vista Landscape (MN, TX) [WC ONLY]',
  'Bella Vista Med Grp',
  'BELLSOUTH CORPORATION WC ALL STATES',
  'BENCHMARK (ALL) [WC, Auto]',
  'Benchmark Insurance (ALL States)',
  'Benefit & Risk Management',
  'Benefit Administrative Systems ( Fairview Heights IL)',
  'Benefit Coordinators Corporation',
  'Benefit Management Group-NV',
  'Benefit Management LLC/VBA',
  'BENEFIT MANAGEMENT SERVICES',
  'Benefit Management Systems Inc',
  'Benefit Plan Administrators (BPA)',
  'Benefit Plan Administrators (Eau Claire WI)',
  'Benefit Plan Administrators Inc (Roanoke, VA)',
  'Benefit Services, Inc. (Akron, OH)',
  'Benefit Systems & Services Inc (BSSI)',
  'Benefits Inc',
  'Benefits Source, Inc',
  'Benesight',
  'Benesys/Benesys, inc//Benesys - LHP',
  'Benmark',
  'Bennett Landscaping (MN, TX) [WC, Auto]',
  'Berkley Agribusiness Risk Specialists (Auto Only)',
  'Berkley Agribusiness Risk Specialists (WC Only)',
  'Berkley National Insurance Company (Auto Only)',
  'Berkley National Insurance Company (WC Only)',
  'Berkley Net Underwriters, LLC',
  'Berkley Regional Insurance Company (Auto Only)',
  'Berkley Regional Insurance Company (WC Only)',
  'Berkley Risk Administrators Company, LLC',
  'Berkley Risk Administrators Company, LLC (WC Only) (All States)',
  'Berkley Specialty Underwriters (MN, TX) WC ONLY',
  'BERKLEY SPECIALTY UNDERWRITERS WC ONLY ANY STATE',
  'Berkshire Hathaway Homestate Companies (BHHC) (WC Only) (CA, LA, MN, TX, OR Only)',
  'Berkshire Insurance - (WC ONLY)',
  'Berkshire Intergroup',
  'BERKSHIRE LEHIGH PARTNERS',
  'Berwind Corporation (MN, TX) WC ONLY',
  'BHM',
  'BHP-Unity',
  'BHSF International',
  'BIENVIVIR SENIOR HEALTH PLAN',
  'Big 5 Corp (Auto only)',
  'Big 5 Corp (WC only)',
  'Bind (PreferredOne)',
  'BITCO General Insurance Corp.',
  'BITCO National Insurance Co',
  'Bituminous Insurance Company - (AUTO ONLY)',
  'Bituminous Insurance Company - (WC ONLY)',
  "BJ's Restaurant (La Mesa, CA)",
  'Block Vision, Inc.',
  'Blue Advantage Sharp (Paper Claims Only)',
  'Blue Bonnet Administrators',
  'Blue Care Network of Michigan (Institutional Claims)',
  'Blue Care Network of Michigan HMO',
  'Blue Choice Health Plan of South Carolina',
  'Blue Choice Medicaid Managed Care',
  'Blue Cross and Blue Shield of North Dakota (ND)',
  'Blue Cross Blue Shield of Arizona Advantage',
  'Blue Cross Community Centennial BCBS of NM',
  'Blue Cross Community Option/66005',
  'Blue Cross of Alaska and Washington - Premera',
  'Blue Cross of Alaska and Washington - Premera (Subrogation Claims Only)',
  'Blue Cross of California',
  'Blue Cross of California (Telemed)',
  'Blue Cross of Idaho (BC)',
  'Blue Cross of Northeastern Pennsylvania',
  'Blue Cross of Pennsylvania CAIC - Capital (BC)',
  'Blue Cross of Washington Health Plus - Premera',
  'Blue Cross of Washington MSC - Premera',
  'Blue Cross of Washington NCAS - Premera',
  'Blue Cross/Blue Shield Indiana - Anthem - HIP - Home Infusion/Specialty Only',
  'Blue Cross/Blue Shield Indiana - Anthem - HMO PPO - Home Infusion/Specialty Only',
  'Blue Cross/Blue Shield Indiana - Anthem - Traditional - Home Infusion/Specialty Only',
  'Blue Cross/Blue Shield Missouri - Anthem - HMO Home Infusion/Specialty Only',
  'Blue Cross/Blue Shield Missouri - Anthem - Regular Home Infusion/Specialty Only',
  'Blue Cross/Blue Shield of Alabama',
  'Blue Cross/Blue Shield of Arizona',
  'Blue Cross/Blue Shield of Arkansas',
  'Blue Cross/Blue Shield of Colorado',
  'Blue Cross/Blue Shield of Colorado (Telemed)',
  'Blue Cross/Blue Shield of Connecticut (Telemed)',
  'Blue Cross/Blue Shield of Connecticut - Anthem',
  'Blue Cross/Blue Shield of DC and National Capital Area',
  'Blue Cross/Blue Shield of Delaware',
  'Blue Cross/Blue Shield of Florida',
  'Blue Cross/Blue Shield of Georgia Columbus',
  'Blue Cross/Blue Shield of Georgia Columbus (Subrogation Claims Only)',
  'Blue Cross/Blue Shield of Illinois',
  'Blue Cross/Blue Shield of Illinois (Subrogation Claims Only)',
  'Blue Cross/Blue Shield of Indiana',
  'Blue Cross/Blue Shield of Indiana (Telemed)',
  'Blue Cross/Blue Shield of Iowa - Wellmark',
  'Blue Cross/Blue Shield of Kansas',
  'Blue Cross/Blue Shield of Kansas City',
  'Blue Cross/Blue Shield of Kansas City (Workers Comp)',
  'Blue Cross/Blue Shield of Kentucky',
  'Blue Cross/Blue Shield of Kentucky (Medicaid)',
  'Blue Cross/Blue Shield of Kentucky (Telemed)',
  'Blue Cross/Blue Shield of Louisiana',
  'Blue Cross/Blue Shield of Maine',
  'Blue Cross/Blue Shield of Maine (Telemed)',
  'Blue Cross/Blue Shield of Massachusetts',
  'Blue Cross/Blue Shield of Michigan',
  'Blue Cross/Blue Shield of Minnesota',
  'Blue Cross/Blue Shield of Minnesota HMO',
  'Blue Cross/Blue Shield of Mississippi',
  'Blue Cross/Blue Shield of Mississippi - State Employee',
  'Blue Cross/Blue Shield of Missouri',
  'Blue Cross/Blue Shield of Missouri (Telemed)',
  'Blue Cross/Blue Shield of Nebraska',
  'Blue Cross/Blue Shield of Nevada',
  'Blue Cross/Blue Shield of Nevada (Telemed)',
  'Blue Cross/Blue Shield of New Hampshire',
  'Blue Cross/Blue Shield of New Hampshire (Telemed)',
  'Blue Cross/Blue Shield of New Jersey',
  'Blue Cross/Blue Shield of New Mexico',
  'Blue Cross/Blue Shield of New York Central Syracuse',
  'Blue Cross/Blue Shield of New York Empire',
  'Blue Cross/Blue Shield of New York Northeastern',
  'Blue Cross/Blue Shield of New York Rochester',
  'Blue Cross/Blue Shield of New York Utica-Watertown',
  'Blue Cross/Blue Shield of New York Western',
  'Blue Cross/Blue Shield of North Carolina',
  'Blue Cross/Blue Shield of North Dakota',
  'Blue Cross/Blue Shield of Ohio',
  'Blue Cross/Blue Shield of Ohio (Telemed)',
  'Blue Cross/Blue Shield of Oklahoma',
  'Blue Cross/Blue Shield of Pennsylvania - Highmark',
  'Blue Cross/Blue Shield of Rhode Island',
  'Blue Cross/Blue Shield of South Carolina',
  'Blue Cross/Blue Shield of South Dakota',
  'Blue Cross/Blue Shield of Tennessee Chattanooga',
  'Blue Cross/Blue Shield of Tennessee Chattanooga HMO',
  'Blue Cross/Blue Shield of Tennessee Memphis',
  'Blue Cross/Blue Shield of Texas',
  'Blue Cross/Blue Shield of Utah - Regence',
  'Blue Cross/Blue Shield of Vermont',
  'Blue Cross/Blue Shield of Washington - Regence',
  'Blue Cross/Blue Shield of West Virginia - Mountain State',
  'Blue Cross/Blue Shield of Wyoming',
  'Blue Cross/Blue Shield Ohio - Anthem - Home Infusion/Specialty Only',
  'Blue Cross/Blue Shield Pennsylvania - Highmark Western',
  'Blue Cross/Blue Shield United of Wisconsin',
  'Blue Cross/Blue Shield United of Wisconsin (Telemed)',
  'Blue Grass Family Health/SRRIPA',
  'Blue Shield HMO (encounters only)- CA',
  'BLUE SHIELD IA - MEDICARE CROSSOVER',
  'Blue Shield of California',
  'Blue Shield of Idaho (BS)',
  'Blue Shield of Montana (BS)',
  'BLUE SHIELD PUERTO RICO - MEDICARE ADV',
  'Bluegrass Family Health',
  'BMW Manufacturing Corp. (ALL States)(WC Only)',
  'BMW North America (ALL States)',
  'Bob Evans',
  'Boise Cascade Company',
  'Bollinger, INC.',
  'Boncura Health Solutions',
  'Boon-Chapman Benefit Administrators Inc',
  'Boston Medical Center Healthnet',
  'BP America',
  'Bragg & Assoc (Stockton, CA) (CA ONLY) [WC ONLY]',
  'Bragg & Assoc (Walnut Creek, CA) (CA ONLY) [WC ONLY]',
  'Bravo Health (effective 8/1/07)',
  'BREAST AND CERVICAL CANCER CONTROL PROGRAM',
  'Breathco - PCA Family Health Plans',
  'Breathco - PCA Health Plan',
  'Breathco - Prucare',
  'Brentwood Services Administrators, Inc.',
  'Brickstreet (WC ONLY)',
  'Bridgefield Employers Insurance Company (ALL) WC ONLY',
  'BridgeSpan',
  'BRIDGESTONE - FIRESTONE (ALHAMBRA, CA) (WC Only)',
  'Bridgestone - Firestone (Carson, CA) (CA ONLY) [WC ONLY]',
  'Bridgestone - Firestone (Chula Vista, CA) (CA ONLY) [WC ONLY]',
  'BRIDGESTONE - FIRESTONE (SAN FRAN, CA) (WC Only)',
  'Bridgestone - Firestone (Santa Ana, CA) (CA ONLY) [WC ONLY]',
  'Bridgestone - Firestone (Santa Clara, CA) (CA ONLY) [WC ONLY]',
  'Bridgeway Arizona',
  'Bright Health Medicare Advantage',
  'Bright Health Physicians',
  'Bright Horizons Family Solutions (CA, MN, TX) [WC ONLY]',
  'Bristol Park Medical (MN, TX) [WC, Auto]',
  'Bristol West',
  'BritCay',
  'BRITISH AMERICAN INSURANCE COMPANY (Auto Only)',
  'BROADSPIRE (ALL states) (Auto Only)',
  'BROADSPIRE (ALL states) (WC Only)',
  'BROADSPIRE (ALL states) [WC]',
  'Broadspire (Auto Only)',
  'Broadspire Auto',
  'Broadspire-Lewisville',
  'Brokerage Concepts Inc',
  'Brookshire IPA',
  'Brotherhood Mutual Insurance',
  'Brotherhood Mutual Insurance (WC Only) (TX/MN/CA/NC/NM Only)',
  'BROWARD INSURANCE GROUP (WC ONLY) TX, MN',
  'Brown & Toland Medical Group',
  'Brown & Toland Sutter',
  'Brown and Toland Health Services',
  'Brownyard Group Inc. (Arch Insurance) (WC Only)',
  'Brownyard Group Inc. (Arch Insurance) (WC Only) (TX, MN Only)',
  'Brunswick Corporation (MN, TX) WC ONLY',
  'BRUNSWICK CORPORATION (WC Only) (TX,MN Only)',
  'Bryan Independent School District',
  'Buffets Inc (WC Only) (All States)',
  'Builders Insurance Group (GA only)',
  'Builders Mutual Insurance (AUTO ONLY)',
  'Builders Mutual Insurance - (WC ONLY)',
  'BUNCH & ASSOC. INC (WC Only) (All States)',
  'Bunch & Associates - Lowes (Limited)',
  'Bunch and Associates',
  'Burlington Coat Factory Wareho (MN, TX) WC ONLY',
  'Butler Benefit',
  'Cal-Optima Direct',
  'Calhoun County (Tristar Risk Management)',
  'Caliber Holdings Corporation (Auto only)',
  'Caliber Holdings Corporation (WC only)',
  'California Care (Humboldt Del Norte)',
  "California Children's Services (CCS)",
  'California Health & Wellness',
  'California IPA (Capital MSO)',
  'California Pacific Medical Center',
  'California Pacific Medical Foundation',
  'California Water Services',
  'CAMBRIDGE (CARROLTON, TX) (WC Only)',
  'CAMBRIDGE (PORTLAND, OR) (CA,MN,TX) (WC Only)',
  'Cambridge (Sacramento, CA) (MN, TX) [WC ONLY]',
  'Cambridge (San Diego, CA) (MN, TX) [WC ONLY]',
  'Cambridge Integra-Carrlloton (TX ONLY) [WC ONLY]',
  'Cambridge Integra-Houston (WC Only)',
  'CAMBRIDGE INTEGRA-SAN ANTONIO (WC Only)',
  'Cambridge Integrated Services',
  'Cambridge Integrated Services Group (ALL) (WC Only)',
  'Cameron & Associates',
  'Camp Lejeune Family Member Program',
  'Cannon Cochran Management Services, Inc.',
  'CAP Management Systems',
  'Capaz Construction (MN, TX) [WC ONLY]',
  'Capistrano Unified School District (CA)(Auto only)',
  'Capistrano Unified School District (CA)(WC only)',
  "Capital Distric Physician's Health Plan",
  "Capital District Physician's Health Plan (CDPHP)",
  'Capital Health Claims',
  'Capital International Management Services - Tampa, FL',
  'Capitol Administrators',
  'Capitol Indemnity (ALL States)',
  'Capitol Insurance Companies',
  'Cardinal Innovations',
  'CardioVascular Care Providers',
  'CARDON OUTREACH',
  'Care Access PSN',
  'Care Around the Clock',
  'Care Oregon',
  'Care Plus ( Target/ Dayton Hudson Corp)',
  'Care Source (OH)',
  'Care to Care',
  'Carecentrix',
  'Carecore National',
  'CareCore National / WellCare of NY Radiology',
  'CARECORE NATIONAL, LLC - HEALTH NET NEW, JERSEY- WAPPINGERS FALL, NY',
  "CareFirst Administators - Maryland (Formerly Willse')",
  'CareFirst Administrators/NCAS - Charlotte',
  'CareFirst Administrators/NCAS - Fairfax, VA',
  'Carefirst Blue Cross/Blue Shield NCA Region',
  'CareFirst DelMarva Health Plan of Maryland',
  'Caremore',
  'Careplus',
  'CarePlus Health Plan',
  'Carepoint Health Plans',
  'Caresource Georgia',
  'CARESOURCE HEALTH PLAN OF OREGON',
  'CareSource Indiana Inc',
  'Caresource KY (Humana)',
  'Caresource West Virginia',
  'CareWorks (ALL) AUTO ONLY',
  'CareWorks (Ohio BWC)',
  'CareWorks Consultants, Inc. (aka CareWorks USA and CCI) - OH ONLY (WC only)',
  'Carhartt (Auto only)',
  'Carhartt (WC only)',
  'Carmax (CA, MN, TX) [WC ONLY]',
  'Carmona Staffing (MN, TX) [WC ONLY]',
  'Carolina Behavioral Health',
  'Carolina Benefit Administrators',
  'Carolina Summit Healthcare Inc',
  'Carpenters Health and Welfare Fund of Philadelphia',
  'Cascade Comprehensive Care (DOS 01/01/18 and after)',
  'Cascade Comprehensive Care (DOS Prior to 12/31/17)',
  'Cascade East Health Plans',
  'Casitas Municipal Water District (CA)(Auto only)',
  'Casitas Municipal Water District (CA)(WC only)',
  'CATHOLIC CHARITIES (SCC) (MN,TX) (WC Only)',
  'Catholic Mutual (MN, TX) [WC ONLY]',
  'CBA Blue/Blue Benefit Administrators',
  'CBHNP - HealthChoices',
  'CC-Development Group, Inc. (Auto only)',
  'CCAI',
  'CCEA Welfare Benefit Trust',
  'CCMSI',
  'CCMSI (TX, MN) (WC Only)',
  'CCMSI-Xcel Energy (WC Only)',
  'CCN Managed Care',
  'CCSI/Lutheran Preferred',
  'CCSTPA',
  'CDS Group Health',
  'CEDAR HILL INSURANCE (WC Only)',
  'CEDAR SINAI MEDICAL CENTER',
  'Cedar Valley Community Healthcare (CVCH)',
  'Cedars Sinai Medical Center',
  'Cedars-Sinai Medical Network Services (Claims)',
  'Cedars-Sinai Medical Network Services (Encounters)',
  'Celtic Insurance',
  'CeltiCare',
  'CENDANT CORPORATION (CA, MN, TX ONLY) WC ONLY',
  'Cenpatico',
  'Cenpatico Behavioral Health',
  'CENTENE (CENPATICO)',
  'Center for Elders Independence',
  'Center IPA',
  'CenterLight Healthcare',
  'Centers Plan For Healthy Living',
  'Centinela Valley IPA',
  'Centracare',
  'Central California Alliance for Health',
  'CENTRAL CALIFORNIA WOMENS HEALTH',
  'Central Companies (ALL States)',
  'Central Contra Costa Transit Authority (Auto only)',
  'Central Contra Costa Transit Authority (WC only)',
  'Central Garden and Pet Company',
  'Central Garden and Pet Company (Auto)',
  'Central Health Medicare Plan',
  'Central Hockey League (MN, TX) WC ONLY',
  'Central Ohio Primary Care Senior Care Advantage',
  'CENTRAL SENIOR CARE',
  'Central States Health & Welfare Funds',
  'Central Transport (Warren) (MN, TX) [WC ONLY]',
  'Central Valley Medical Group',
  'Century Indemnity (Auto Only)',
  'CENTURYPHO',
  'Chaffey Joint Union H. S. District (CA)(Auto only)',
  'Chaffey Joint Union H. S. District (CA)(WC only)',
  'Chaffey Medical Group',
  'Champ, Inc. (MN, TX) [WC ONLY]',
  'CHAMPVA/VA-HAC',
  'Charming Shoppes, Inc. (MN, TX)  WC ONLY',
  'CHARTIS',
  'CHARTIS CASUALTY CO (Auto Only)',
  'CHARTIS CASUALTY CO (WC Only)',
  'Chartis Property Casualty Co. (WC Only) (All States)',
  'Chartis Select Ins Co. (WC Only)',
  'Chautauqua County',
  'Chesapeake Insurance',
  'Chesterfield Resources, Inc.',
  'Chesterfield Serv-Uniontown',
  'Chesterfield Services, Inc.',
  'Chevron (Citrus Heights) (WC Only)',
  'Chick-fil-A',
  'Child Health and Disability Prevention Program',
  "Children's Community Health Plan",
  "Children's First Healthcare Network",
  "Children's Hospital of Orange County Health Alliance (CHOC) Orange CA",
  "Children's Medical Center Health Plan",
  'Childrens Hospital Orange County (CHOC) Health Alliance',
  'CHILDRENS PHYSICIANS MEDICAL GROUP',
  'Chinese Community Health Plan',
  'ChiroCare',
  'CHIROMETRICS',
  'Chiropractic Health Plan',
  'Choice Medical Group',
  'Choice Physicians Net First Choice',
  'Choice Physicians Network',
  'Choice Physicians Network (Antelope Valley Medical Group)',
  'ChoiceOne IPA',
  'Christian Brothers Services',
  'Christie Student Helath Plan',
  'Christus Health NM HIX',
  'Chubb & Son (TX, MN, CA)',
  'Chubb & Sons - Chubb Idemnity (Auto Only)',
  'CHUBB INDEMNITY INSURANCE COMPANY (WC Only)',
  'Chubb Services (WC Only) (MN/TX/CA Only)',
  'Church (WC ONLY) (ALL States)',
  'CHURCH MUTUAL INSURANCE COMPANY  (MN,TX) (AUTO Only)',
  'Church Mutual Insurance Company (ALL States)',
  'CHURCH MUTUAL INSURANCE COMPANY (MN,TX) (WC Only)',
  'Church Mutual Insurance Company - LIAB ONLY',
  'CIGA (WC Only) (CA Only)',
  'CIGNA (Connecticut General, Equicor, Equitable)',
  'CIGNA (Connecticut General, Equicor, Equitable) (Subrogation Claims Only)',
  'CIGNA (MN, TX,CA Only) (WC Only)',
  'CIGNA Behavioral Health',
  'CIGNA ENCOUNTERS (CA & TX encounters for Cigna Commercial (HMO & HMO/POS) business only)',
  'CIGNA HealthCare for Seniors - AZ Medicare',
  'Cincinnati Financial Corporation',
  'Cincinnati Insurance (WC Only) (All States)',
  'Cintas (Sacramento) (CA ONLY) [WC, Auto]',
  'Citizens Insurance Company of America (Auto only)',
  'Citizens Insurance Company of America (WC only)',
  'Citrus Health',
  'Citrus Valley Health Partners (Auto only)',
  'Citrus Valley Health Partners (WC only)',
  'Citrus World, Inc. (Auto only)',
  'Citrus World, Inc. (WC only)',
  'City & County of San Francisco (WC Only)',
  'City and County of San Francisco (CCSF)',
  'City Of Arlington (TX ONLY) [WC ONLY]',
  'City of Arlington (WC Only) (TX,MN,CA Only)',
  'City of Banning (CA)',
  'City of Barstow (CA)',
  'City of Blythe (CA)',
  'City of Dallas (WC ONLY)',
  'City of Desert Hot Springs (CA)',
  'City Of El Paso (WC Only) (TX, MN,CA Only)',
  'City of Fountain Valley (CA) (Auto only)',
  'City of Fountain Valley (CA) (WC only)',
  'City of Gardena (CA) (Auto only)',
  'City of Gardena (CA) (WC only)',
  'City of Glendale (AZ)',
  'City of Houston (WC ONLY)',
  'City of Jacksonville',
  'City of La Mesa 11 (CA)(Auto only)',
  'City of La Mesa 11 (CA)(WC only)',
  'City of Laguna Hills (CA)(Auto only)',
  'City of Laguna Hills (CA)(WC only)',
  'City Of Lake Charles (Auto only)',
  'City Of Lake Charles (WC only)',
  'City of Lakeland (FL)',
  'CITY OF LOS ANGELES (ALL) WC ONLY',
  'City of Los Angeles/Work Comp Div. (CA ONLY) [WC ONLY]',
  'City of Miami Beach (FL)(Auto only)',
  'City of Miami Beach (FL)(WC only)',
  'City of Minneapolis (ALL States)',
  'City of Murieta (CA)',
  'City of Norfolk (VA)',
  'City of Odessa (Odessa TX)',
  'City of Omaha (NE)(Auto only)',
  'City of Omaha (NE)(WC only)',
  'City of Perris (CA)',
  'City of Plano (CA, TX, MN) WC ONLY',
  'City of Pompano Beach (FL)(Auto only)',
  'City of Pompano Beach (FL)(WC only)',
  'City of Redding (CA)(Auto only)',
  'City of Redding (CA)(WC only)',
  'City of Rialto, CA (Auto only)',
  'City of Salinas (CA)',
  'City of San Angelo (MN, TX) [WC ONLY]',
  'City of San Diego (WC Only)',
  'City of San Diego-Wc (CA ONLY) [WC ONLY]',
  'City of San Jacinto (CA)',
  'City of San Jose',
  'City of San Jose Work Comp Dept.',
  'City of San Mateo (CA)(Auto only)',
  'City of San Mateo (CA)(WC only)',
  'City of St. Paul (MN)',
  'City of Stanton (CA)(Auto only)',
  'City of Stanton (CA)(WC only)',
  'City of Stockton (CA)(Auto only)',
  'City of Stockton (CA)(WC only)',
  'City of Topeka (KS)(Auto only)',
  'City of Topeka (KS)(WC only)',
  'City Of Tucson (Auto only)',
  'City Of Tucson (WC only)',
  'City of Upland (CA)(Auto only)',
  'City of Upland (CA)(WC only)',
  'City of West Palm Beach (FL)(Auto only)',
  'City of West Palm Beach (FL)(WC only)',
  'City of West Sacramento/Fire Dept.',
  'City of Yorba Linda (CA) (Auto only)',
  'City of Yorba Linda (CA) (WC only)',
  'CL Frates',
  'Clackamas County Mental Health',
  'Claim Quest (was Centurion) (WC Only)',
  'CLAIMETRICS (MN, TX) (WC Only)',
  'Claims Administrative Services (CAS) (WC Only)',
  'Claims Development Corporation',
  'Claimsbridge High Performance Network',
  'Classic Residence By Hyatt (MN, TX) WC ONLY',
  'Clayton County Health Benefit Plan',
  'Clear Point Resources/Norwalk',
  'Clearchoice Health Plan/COIHS (Bend OR)',
  'Clinical Resource Group (DOS prior to 01/01/2018)',
  'CLINICAL SPECIALITIES, INC',
  'CLINICAS DEL CAMINO REAL',
  'Clougherty Packing, LLC (Auto only)',
  'CMCS ADVANTAGE HEALTH SOLUTIONS MEDICARE ADVANTAGE',
  'CNA Insurance (WC Only) (ALL States)',
  'Coach USA (ALL States) (WC Only)',
  'Coachella Valley Physicians PrimeCare',
  'Coachella Valley Water District (CA) (Auto only)',
  'Coastal Care Services Inc',
  'Coastal Communities Physician Network',
  'Coastal Community Physicians Network(CA)',
  'Coca-Cola Enterprises (Auto Only) (MN,TX Only)',
  'COCA-COLA ENTERPRISES (TX, MN,CA Only) WC ONLY',
  'Cochran Canon Management Service,Inc. (CCMSI) (Concord,CA) (WC Only) (MN, TX)',
  'Cochran Canon Management Service,Inc. (CCMSI) (Minnetonka)',
  'Cofinity',
  'Cole Vocational (MN, TX) [WC, Auto]',
  'Cole Vocational (WC Only)',
  'Colen & Lee (MN, TX) [WC ONLY]',
  'College Health IPA',
  'Colonial Medical',
  'Colorado Access (Denver, CO)',
  'Colorado Blue Cross HMO',
  'Colorado Casualty (WC Only) (All States)',
  'Colorado Choice Health Plan',
  'Colorado Community Health Alliance',
  'Colorado Health Insurance Cooperative Inc.',
  'COLUMBIA SUSSEX CORPORATION (TX, MN) (WC Only)',
  'Columbine Health Plan',
  'Comcast Cable Services',
  'Comfort Keepers/San Diego (MN, TX) [WC ONLY]',
  'COMMERCIAL INSURANCE CO. (WC Only)',
  'Commercial Travelers/PHX',
  'Common Ground Healthcare Cooperative',
  'CommonWealth Administrative Group',
  'Commonwealth Care Alliance',
  'Commonwealth Health Alliance (CHA)',
  'Communicare (MN, TX) [WC ONLY]',
  'Community Care Associates',
  'Community Care BHO',
  'Community Care Managed Health Care Plans of Oklahoma',
  'Community Care of Oregon DOS Prior to 1/1/2015',
  'Community Care Organization',
  'Community Care Plus (71079) (Dates of Service 6/30/2012 and Prior)',
  'Community Choice of Michigan',
  'Community Claims Administration',
  'Community Development Commission (CA)(Auto only)',
  'Community Development Commission (CA)(WC only)',
  'Community Eye Care',
  'Community First',
  'Community First Health',
  'Community Health Alliance',
  'Community Health Alliance TN',
  'Community Health Choice',
  'Community Health Group',
  'COMMUNITY HEALTH GROUP (ENCOUNTERS ONLY)',
  'Community Health Plan of WA',
  'Community Health Plan of Washington',
  'Community Health Plan, Inc.',
  'Community IPA',
  'Community Medical Group of the West Valley',
  'Community Mental Health of Ottawa County',
  'Community Premier Plus',
  'Comp West',
  'Comp West (MN, TX) [WC, Auto]',
  'Compass Group Usa, Inc. (MN, TX) [WC ONLY]',
  'COMPASS GROUP USA, INC. (TX, MN) (WC Only)',
  'COMPASS GROUP USA, INC. (WC ONLY) ANY STATE',
  'Compcare (TX ONLY) [WC ONLY]',
  'Complementary HealthCare Plans',
  'Complete Temp Labor (ALL States)',
  'CompManagement Health',
  'Comprehensive Care Management Corp.',
  'Comprehensive Medical and Dental Program',
  'ComPsych',
  'Compusys Inc',
  'Con-Way Inc. (Auto only)',
  'Con-Way Inc. (WC only)',
  'Con-Way Western/Lf (TX ONLY) [WC ONLY]',
  'Concentra Integrated (ALL) [WC ONLY]',
  'Concentrix Insurance Solutions',
  'Concordia Care Incorporated',
  'Connecticare - Medicare',
  'ConnectiCare Inc',
  'Connecticut BlueCare Family Plan',
  'Connecticut BlueCare Family Plan (Medicaid)',
  'Connecticut Carpenters Health Fund',
  'Connecticut Federal Employee Health Benefits (FEHB, Health Care Payers Coalition-Toledo OH)',
  'Connecticut Medicare Blue',
  'Consociate Group',
  'Consolidated Associates Railroad',
  'Consolidated Group/HPS',
  'Consolidated Health Plans',
  'CONSTITUTION STATE - TRAVELERS',
  'Constitution States (St. Paul Travelers) WC ONLY',
  'Consumers Choice Health SC',
  'Container Graphics Corporation',
  'CONTECH CONSTRUCTION PRODUCTS (TX, MN) (WC Only)',
  'Contessa Health - Security Health Plan',
  'CONTINENTAL AIRLINES (TX, MN) (WC Only)',
  'Continental General Insurance Company - Medicare Supplement',
  'CONTINENTAL INSURANCE COMPANY (AUTO Only)',
  'CONTINENTAL INSURANCE COMPANY (WC Only)',
  'CONTINENTAL NATIONAL INSURANCE (MN, TX) [WC, Auto]',
  'CONTINENTAL WESTERN INS CO (MN, CA, LA & TX) (WC Only)',
  'Continental Western Ins Co (MN, TX) [WC ONLY]',
  'Contra Coastal County Schools Insurance Group (CCCSIG) (WC Only) (All States)',
  'Contract Claims Services (CCS)(City of Fort Worth Only) (TX Only) (WC Only)',
  'Convergys Corporation (TX, MN)',
  "Cook Children's Health Plan",
  "Cook Children's Star Plan",
  'Cook Group Health Plan',
  'Cook Group Solutions',
  'Cooperative Managed Care',
  'Cooperative Mutual (All States)',
  'COPC - Senior Care Advantage',
  'Copperpoint Mutual Insurance Company (Auto)',
  'Copperpoint Mutual Insurance Company (WC)',
  'Core Management Resources Group Inc',
  'CoreSource (Little Rock)',
  'CoreSource (OH)',
  'CoreSource (PA, MD, IL, NC, IN, AZ, MN)',
  'Corestaff (Sacramento)(ANY STATE)[WC ONLY]',
  'Corinthian Colleges',
  'Cornerstone Benefit Administrators',
  'Cornerstone Preferred Resources',
  'Corporate Plan Management Inc.',
  'Corporate Services (ALL States)',
  'Correct Care Integrated Health',
  'CORRECTCARE (GEORGIA CORRECTIONAL HEALTHCARE ADULT HEALTH)',
  'Correction Health Partners',
  'CORRECTIONAL MANAGEMENT SERVICE (TX, MN) (WC Only)',
  'CORRECTIONAL MANAGEMENT SERVICE (WC Only) (TX,MN Only)',
  'Correctional Medical Services',
  'CORRECTIONS CORP OF AMERICA (TX, MN) (WC Only)',
  'CORRECTIONS CORP OF AMERICA (WC Only) (TX,MN Only)',
  'Corrections Corporation of America (CCA) (Auto only)',
  'Corrections Corporation of America (CCA) (WC only)',
  'CorSolutions',
  'Cottingham & Butler Claim Services, Inc.',
  'Cottingham & Butler Claim Services, Inc. (WC Only)',
  'Cottingham and Butler (Equian)',
  'Country Casualty Insurance Company (Auto only)',
  'Country Casualty Insurance Company (WC only)',
  'Country Mutual Insurance Company (Auto only)',
  'Country Mutual Insurance Company (WC  only)',
  'Country Preferred Insurance Company (WC only)',
  'County Care - Behavioral',
  'County Care - Medical DOS Prior 04/01/2016',
  'County Medical Services Program (CMSP)',
  'County of Humboldt (Auto only)',
  'County of Humboldt (WC only)',
  'County of Kern',
  'County of Los Angeles (1000) (Auto only) (Claims starting with 1000)',
  'County of Los Angeles (1000) (WC only) (Claims starting with 1000)',
  'County of Los Angeles (2000) (Auto only) (Claims starting with 2000)',
  'County of Los Angeles (2000) (WC only) (Claims starting with 2000)',
  'County of Los Angeles (3000) (Auto only) (Claims starting with 3000)',
  'County of Los Angeles (3000) (WC only) (Claims starting with 3000)',
  'County of Los Angeles (4000/5000) (Auto only)',
  'County of Los Angeles (4000/5000) (WC only)',
  'County of Los Angeles (CA)',
  'County Of Orange',
  'County of San Diego',
  'County Of San Diego (CA ONLY) [WC ONLY]',
  'County of Santa Barbara EWC (Auto only)',
  'County Of Santa Clara',
  'County of Shasta (CA) (Auto only)',
  'County of Shasta (CA) (WC only)',
  'County of Tulare (CA) (Auto only)',
  'County of Tulare (CA) (WC only)',
  'Covenant Administrators, INC. (Atlanta GA)',
  'Covenant Mgmt Systems Employee Benefit Plan',
  'Covenant Transport (CA, MN, TX) [WC ONLY]',
  'Coventry Health Care',
  'Coventry Health Care (Subrogation Claims Only)',
  'Coventry Health Care National Network (First Health Direct)',
  'Coventry Health Care of Louisiana Inc (Eligibility Only)',
  'COWORX STAFFING, LLC (TX, MN)(WC Only)',
  'Cox Health System',
  'Cpc Logistics/Oakland',
  'CPL-Minute Man (ALL States)',
  'Cracker Barrel (ALL States)(AUTO ONLY)',
  'Crawford Insurance (MN, TX) [WC ONLY]',
  'CREATE',
  'Creative Medical Systems',
  'Creative Plan Administrators',
  'Creative Risk Solutions (WC Only)',
  'Crescent Crown Distributing (Auto only)',
  'Crescent Health Solutions',
  'Crescent Health Solutions (Subrogation Claims Only)',
  'Crescent Village',
  'Crestwood Center',
  'Crete Township (ALL States)',
  'CROSSLAND COOL RISK (ALL) AUTO ONLY',
  'CROSSLAND COOL RISK (ALL) WC ONLY',
  'Crown City Medical Group (CCMG)',
  'CRUM & FORSTER INDEMNITY (TX, MN) (WC Only)',
  'Crum & Forster Indemnity Co (WC Only) (TX/MN/CA/LA Only)',
  'Crum & Forster Indemnity,United States Fire Insurance Company (WC Only) (TX,MN,CA,LA Only)',
  'Crum & Forster-Morristown (AUTO ONLY) (CA, MN, LA, & TX)',
  'Crystal Run Health Plans (DOS 01/01/18 & After)',
  'Crystal Run Health Plans (DOS Prior to 01/01/18)',
  'CSI Network Services',
  'CSI OF MICHIGAN',
  'CTI ADMINISTRATORS INC.',
  'Cuna Mutual',
  'Custody Medical Services',
  'Custom Benefit Administrators(LaCrosse, WI)',
  'Custome Design Benefits Inc.',
  'CVS PHARMACY (CAREMARK) (Auto Only)',
  'CVS PHARMACY (CAREMARK) (WC Only)',
  'CVS PHARMACY (WC Only)',
  'CVS/Caremark/Minute Clinic',
  'Cypress Insurance (Pasadena, CA)',
  'Cypress Insurance (San Francisco, CA) (CA ONLY) [WC ONLY]',
  'Cypress Security (WC Only) (WX381W)',
  'Daimler Trucks North America WC (WC Only) (TX,MN Only)',
  'Dakotacare',
  'Dallas County Schools (ALL)',
  'Dallas Independent School District (WC Only) (TX Only)',
  'Dameron Hospital Association',
  'DANAHER CORPORATION',
  'DANAHER CORPORATION (TX, MN)(WC Only)',
  'Darigold',
  'Dart Member Care',
  'Davis Vision',
  'De Bartolos, Inc (TX, MN) (WC Only)',
  'Dean Health Plan',
  'Del Taco, LLC (Auto only)',
  'Del Taco, LLC (WC only)',
  'DelawareCare (CHC of Delaware Medicaid)',
  "Dell Children's Health Plan",
  'Dell, Inc. (Auto only)',
  'Dell, Inc. (WC only)',
  'Delta Health Systems',
  'Denver Health - Indigent',
  'Denver Health Medicaid Choice',
  'Denver Health Medical Plan',
  'Denver Health Medical Plan, Inc. - Medicare Choice',
  'Department of Energy (WC Only) (All States)',
  'Department of Labor (WC Only)  (All States)',
  'Department of Labor Black Lung (WC Only)',
  'Department of Labor FECA',
  'Department of Labor-Black Lung',
  'Department of Water and Power of the City of Los Angeles (LADWP) (WC Only)(CA Only)',
  'Dept. Of Corrections/Parole+Comm (CA ONLY) [WC ONLY]',
  'Dept. Of Justice/State Of Calif (CA ONLY) [WC ONLY]',
  'Deseret Industries/Sacramento (CA ONLY) [WC ONLY]',
  'Desert Medical Group',
  'Devon Health',
  'Dhr, Inc. (CA, MN, TX) [WC ONLY]',
  'Diagnostic Laboratory/All (MN, TX) [WC ONLY]',
  'Diamond Logistics (MN, TX) [WC ONLY]',
  'Dignity Global',
  'Dignity HCLA',
  'Dignity Health Medical Foundation for Mercy Medical Group or Woodland Clinic Medical Group',
  'Dignity Health Medical Foundation for Sequoia Physicians Network',
  'Dillard Departmen-Little Rock',
  "Dillard's Store Services",
  'Dimension Benefit Management',
  'Direct Care Administration',
  'Direct Construction Co./Compton (CA, MN, TX) [WC ONLY]',
  'Directors Guild of America',
  'Directory Distributing Assoc. (TX, MN) (WC Only)',
  'Discount Tire (Auto only)',
  'Discount Tire (WC only)',
  'Discover Re (Burger King) (TX, MN) (WC Only)',
  'Discovery Insurance (ALL)',
  'Disneyland Resorts (Bunch)',
  'Diversified Administration',
  'Diversified Group Administrators',
  'DMBA (Deseret Mutual Benefit Administrators - [SX105])',
  'DME MAC A',
  'DME MAC B',
  'DME MAC C',
  'DME MAC D',
  'DMENSION BENEFIT MANAGEMENT',
  'DOL OWCP (FECA plan ONLY)',
  'Dollar Tree (ALL) [WC ONLY]',
  'Dolton Medical Group',
  'DoubleBee (ALL)',
  'Dragon Esp Ltd. (MN, TX) [WC ONLY]',
  'Dreyer Medical Group',
  'Driscoll Childrens Health Plan',
  'Drivetime/Ventura (MN, TX) [WC ONLY]',
  'Dunn and Associates Benefits Administrators, Inc.',
  'Dunn-Edwards Corporation (MN, TX) (WC Only)',
  'DUNN-EDWARDS CORPORATION (WC Only) (TX,MN Only)',
  'Durable Medical Equipment [.DME] - Medicaid Louisiana',
  'Durham Alliance Behavioral Health',
  'Durham County, Nc (Auto only)',
  'Durham County, Nc (WC only)',
  'Dustrol (MN,TX,WI) (WC ONLY)',
  'Dynamex, Inc. (TX, MN)(WC Only)',
  'E S I S-Irving (CA, MN, TX) [WC ONLY]',
  'E3 Health Inc',
  'Eagle Claims - (WC ONLY)',
  'eAppeal Solutions',
  'Early Intervention Central Billing',
  'East Bay Medical Network',
  'East Boston Neighborhood Health Center',
  'East Carolina Behavioral Health',
  'East LA Doctors Hospital (Medpoint)',
  'Eastern Alliance (EA)',
  'Eastern Iowa Community Healthcare (EICH)',
  'Eastland Medical Group IPA',
  'Eastman Kodak Company (Auto only)',
  'Eastpointe Behavioral Health (NC Medicaid MCO)',
  'Easy Care MSO LLC',
  'EASY CHOICE HEALTH PLAN',
  'Eaton Corporation (MN, TX) (Auto Only)',
  'Eaton Corporation (MN, TX,CA Only ) [WC ONLY]',
  'Eberle Vivian',
  'Ecmd, Inc. (MN, TX) [WC ONLY]',
  'EDIC (ALL) (WC Only)',
  'EDS Admin Services (DOS Prior to 01/01/18)',
  'Edwards Claims Administration',
  'Eighth District Electrical Benefit Fund',
  'El Paso Community College (Tx Jur) [WC ONLY] (TX,MN,CA Only)',
  'El Paso First - CHIP',
  'El Paso Water Util Tx Jur (TX, MN) [WC ONLY]',
  'El Pollo Loco (Auto only)',
  'El Pollo Loco (WC only)',
  'El Proyecto De Barrio',
  'Elder Service Plan Of The North Shore',
  'Elderplan',
  'Electric Insurance Company (MN, TX) [WC ONLY]',
  'Electric Insurance/General Electric (Auto Only)',
  'Electrical Welfare Trust Fund (EWTF)',
  'Electrical Workers Insurance Fund Local 5800',
  'Elite Labor Services (ALL)',
  'Elite Labor Services - SELF (ALL)',
  'Elks Lodge',
  'EMC',
  'EMC - Total Care NY',
  'EMC Property and Casualty (Auto Only) (MN Only)',
  'EMCASCO Insurance Co (MN, TX) [WC, Auto]',
  'EMCASCO Insurance Co (TX, MN) (WC Only)',
  'Emerald Health Network Inc (All PPO Business)',
  'Emergency Medical Services Fund',
  'Emeritus Corporation',
  'EMERSON ELECTRIC COMPANY',
  'EMHS EMPLOYEE HEALTH PLAN',
  'EMI-KP Ambulance Claims for Kaiser Permanente Members',
  'EMIA (Educators Mutual Insurance Association)',
  'Empire Physicians Medical Group',
  'Employ America (ALL)',
  'Employee Benefit Concepts (Farmington Hills, MI)',
  'Employee Benefit Concepts, Inc.',
  'Employee Benefit Consultants',
  'Employee Benefit Logistics',
  'Employee Benefit Management Corp',
  'Employee Benefit Management Corp. (EBMC)',
  'Employee Benefit Mgmt Corp (EBMC)',
  'Employee Benefit Services ( San Antonio only)',
  'Employee Benefit Services Inc (DBA Key Benefit Administrators)',
  'Employee Benefit Services of Louisiana (EBS)',
  'Employee Benefit Services, Inc. (EBSI)',
  'EMPLOYEE BENEFIT SYSTEM',
  'Employee Benefits Administration and Management Corp.',
  'Employee Benefits Services',
  'Employee Plans LLC',
  'Employee Resource Management TPA: Kempton Group',
  'Employer Direct Healthcare',
  'Employer Insurance Group (EIG) (WC Only)(ALL States)',
  'Employer Plan Services',
  "EMPLOYER'S CLAIM SERVICE, INC - City of Naperville",
  "Employer's Direct Health - Employee Plan",
  "Employer's Direct Health - FL",
  "Employer's Direct Health - SF",
  'Employers Assurance Company (WC Only)(ALL States)',
  'Employers Direct Insurance Co. (MN, TX) [WC ONLY]',
  'Employers General Insurance Group (Auto Only) (All States)',
  'Employers Insurance (BUNCH) (CA Only)',
  'Employers Insurance (Reno) (ALL) [WC ONLY]',
  'Employers Insurance Corp (Henderson) (MN, TX, CA, LA) [WC ONLY]',
  'Employers Mutual Inc (FL)',
  'Employers Mutual Of Des Moines (TX ONLY) [WC ONLY]',
  'Employers Resource/State Fund (MN, TX) [WC ONLY]',
  'Employment Solutions (All) (MN, TX) [WC ONLY]',
  'EMS Equipment (MN, TX) [WC ONLY]',
  'Encompass Insurance Brand (Auto Only) (All States)',
  'Encore Unlimited (ALL)',
  'England/Corsair (MN, TX) [WC, Auto]',
  'ENH Medical Group IPA',
  'Entrust',
  'Envirosource (TX, MN) (WC Only)',
  'Eon Health',
  'Equitable Plan Services',
  'Equity Resid (Irvine, CA)',
  'Ergon, Inc. (Auto only)',
  'Ergon, Inc. (WC only)',
  'Erie Insurance (WC Only)',
  'Erie Insurance (WC Only) (All States)',
  'ERIE INSURANCE (WC ONLY) ANY STATE',
  'Erin Group Administrators (EGA)',
  'ERISA Administrative Services',
  'ERMC (TX, MN) (WC Only)',
  'ES Beveridge and Associates',
  'ESIS (ALL) (WC Only)',
  'Esis (Arkansas) (AL ONLY) [WC ONLY]',
  'Esis (Colorado) (AZ ONLY) [WC ONLY]',
  'Esis (Connecticut) (WC Only)',
  'Esis (Delaware) (CA ONLY) [WC ONLY]',
  'Esis (First American Insurance Co) (MN,TX) (WC Only)',
  'Esis (Kansas)',
  'Esis (Louisisana)',
  'Esis (Maine)',
  'Esis (Missouri)',
  'Esis (New Mexico)',
  'Esis (New York)',
  'Esis (North Dakota)',
  'ESIS (OKLAHOMA) (WC Only)',
  'Esis (Oregon)',
  'Esis (South Carolina)',
  'Esis (Tennessee)',
  'ESIS (TX, MN) (First American Insurance Co)',
  'ESIS Insurance',
  'Essence Healthcare',
  'Essential Health Large Deductible (Auto Only)',
  'Esurance Insurance Company (Auto Only) (MN Only)',
  'ESURANCE INSURANCE COMPANY (MN & TX) (Auto Only)',
  'ESURANCE INSURANCE COMPANY (MN & TX) (WC Only)',
  'Eurostar / Warehouse Shoe Sale (WSS) (MN, TX) [WC ONLY]',
  'Everence',
  'Everest National Insurance (ALL) [WC ONLY]',
  'Everest National Insurance (Fresno) (MN, TX) [WC ONLY]',
  'Everest National Insurance (SF) (MN, TX) [WC ONLY]',
  'Evolution Insurance Company',
  'Evolution Insurance Company (TX, MN)',
  'Evolution Insurance Company, Ltd. (MN, TX) [WC, Auto]',
  'Evolution Staffing (ALL States)',
  'Evolutions Healthcare Systems (New Port Richey FL)',
  'Exceedent LLC',
  'Exclusive Care',
  'Exel, Inc (MN, TX) [WC ONLY]',
  'Express Linen Co. (CA, TX) [WC ONLY]',
  'Express, LLC',
  'Express, LLC (Auto)',
  'ExxonMobil Corporation (Auto only)',
  'ExxonMobil Corporation (WC only)',
  'Eye Specialist of AZ',
  'Eyecare 2020',
  'EyeMed',
  'EyeQuest',
  'F. A. Richard & Associates (FARA) (TX Only) (WC Only)',
  'FABOH (Fond Du Lac Area Bus on HLTH)',
  'Facey Medical Foundation (Mission Hills CA)',
  'Factory 2 U (MN, TX) WC ONLY',
  'Fairchild Fasteners (Auto only)',
  'Fairchild Fasteners (WC Only)',
  'Fairfax County Government (VA)',
  'Fairview Health Services',
  'Falling Colors (BHSD STAR)',
  'Family /Seniors Med Group, Inc. (Labs Only) - IPA',
  'Family Care',
  'Family Care CCO',
  'Family Care CCO (DOS 08/01/12 and later)',
  'Family Care Medicaid (DOS 08/01/12 and later)',
  'Family Care Medicaid Mental Health',
  'Family Care Medicare (DOS 01/01/13 and later)',
  'Family Care Medicare (DOS prior to 01/01/2013)',
  'Family Care Specialists (FCS)',
  'Family Care Specialists IPA',
  'FAMILY DOLLAR STORES, INC. (MN,TX,CA Only) WC ONLY',
  'Family Medical Network ( Chicago IL)',
  'FAMILYCARE (MEDICAID HMO)',
  'FAMSA, Inc.',
  'Farm Bureau Mutual Insurance Company (MN Only) (Auto Only)',
  'Farm Family(Albany NY)',
  'Farmers / Civic Property and Casualty Company (Auto only)',
  'Farmers / Civic Property and Casualty Company (WC only)',
  'Farmers / Exact Property and Casualty Company (Auto only)',
  'Farmers / Exact Property and Casualty Company (WC only)',
  'Farmers / Fire Insurance Exchange (Auto only)',
  'Farmers / Fire Insurance Exchange (WC only)',
  'Farmers / Mid-Century Insurance Company (Auto only)',
  'Farmers / Mid-Century Insurance Company (WC only)',
  'Farmers / Neighborhood Spirit Property and Casualty Company (Auto only)',
  'Farmers / Neighborhood Spirit Property and Casualty Company (WC only)',
  'Farmers / Truck Insurance Exchange (Auto only)',
  'Farmers / Truck Insurance Exchange (WC only)',
  'Farmers Ins./Merced (MN Only) (Auto Only)',
  'Farmers Ins./Merced (MN, TX) (WC Only)',
  'FARMERS INSURANCE (Auto Only)',
  'Farmers Insurance (Auto Only) (MN Only)',
  'FARMERS INSURANCE (MED RISK PROVIDERS ONLY) (ALL) WC ONLY',
  'Farmers Insurance (NEWPORT BEACH) (Auto Only)',
  'Farmers Insurance (NEWPORT BEACH) (WC Only)',
  'FARMERS INSURANCE (PLEASANTON) (ALL) WC ONLY',
  'Farmers Insurance Commercial (Commercial Only) (Auto Only) (MN Only)',
  'Farmers Insurance Exchange (WC Only)',
  'Farmland Mutual Ins Co',
  'FARMLAND MUTUAL INSURANCE CO (WC) (ANY STATE)',
  'FARMLAND MUTUAL INSURANCE COMPANY (WC ONLY) TX, MN, LA & CA ONL',
  'FCE Benefit Administrators, Inc',
  'Federal Chubb Group (WC Only)',
  'Federal Employee Plan of South Carolina',
  'FEDERAL INSURANCE CO (WC) ANY STATE',
  "Federated Claims Service Corp (Macy's)",
  'Federated Claims Service Corp. (ALL) (WC Only)',
  'Federated Mutual Insurance Company (WC Only) (All States)',
  'Federated Mutual Insurance of Owatonna, MN',
  'Federated Rural Electric Ins. Co. (TX, MN) (WC Only)',
  'FEDERATED SERVICES INSURANCE COMPANY (MN, TX) WC ONLY',
  'Federated Services Insurance Company (WC Only) (All States)',
  'FedEx National LTL, Inc. (TX ONLY) [WC ONLY]',
  'Fenix Medical Group',
  'FFVA Mutual Insurance (Auto Only)',
  'FFVA Mutual Insurance (WC Only)',
  'Fidelis Care New York',
  'FIDELITY & CASUALTY CO OF NY (MN, TX) [WC, Auto]',
  'FIDELITY NATIONAL FINANCIAL INC. (AUTO ONLY) (TX,MN Only)',
  'Fidelity National Information Services (MN, TX) [Auto Only]',
  'Fire Department City of New York World Trade Center Health',
  "Fireman's Fund Insurance (Novato, CA)",
  "Fireman's Fund Insurance Company (MN Only)(Auto Only)",
  "Fireman's Fund Insurance Company (TX, MN) (WC Only)",
  "FIREMAN'S INSURANCE COMPANY (Auto Only)",
  "FIREMAN'S INSURANCE COMPANY (WC Only)",
  "Firemen's Insurance Company",
  'Firestone #2262/Sb',
  'First American Corp S.A. (CA ONLY) [WC ONLY]',
  'First Care Preferred',
  'First Choice Health Network (aka Sound Health)',
  'First Choice Medical Group',
  'First Choice of Midwest (PPO)',
  'First Choice Staffing (CA, MN, TX) [WC ONLY]',
  'First Choice VIP Care Plus',
  'FIRST MEDICAL HEALTH PLAN (REFORM)',
  'First Medical Network (MRN)',
  'First Solutions',
  'First Staff Services (All)',
  'FIRSTCARE',
  'FirstCare Star Medicaid',
  'Firstcomp  (WC Only)',
  'Firstcomp (WC Only) (All States)',
  'FirstNation Health',
  'FKI INDUSTRIES, INC. (TX, MN) (WC Only)',
  'FL MCO PHC/PHP',
  'Florida Fruit and Vegetable Association (WC Only)',
  'Florida Health Administrators TPA: The Assistance Fund',
  'Florida Healthcare Plan',
  'Florida Hospital Waterman',
  'Florida NetPass',
  'FLORIDA PACE CENTERS',
  'Florist Mutual Insurance (ALL)',
  'Flying Food Group (MN, TX) [WC ONLY]',
  'FMH Benefit Services Inc',
  'Foremost (Auto Only) (MN/CA Only)',
  'Forest County Potawatomi Insurance',
  'Forge Industrial Staffing',
  'Forte, Inc. (MN, TX) [WC ONLY]',
  'Forte, Inc. (WC Only)',
  'Foster Farms (WC Only)',
  'Foundation Benefit Administrators',
  'Foundation for Medical Care of Tulare & Kings County',
  'Foundation Health - HMO',
  'Fountain Valley',
  'Fountain Valley Regional Medical Center (TENET)',
  'Fox Valley Medicine',
  'Fox-Everett Inc',
  'Franciscan Alliance (Auto only)',
  'Franciscan Alliance (WC only)',
  'Frank Gates / Attenta (MN, TX) [WC ONLY]',
  'FRANK GATES SERVICE COMPANY (MN, TX) (WC Only)',
  'Frankenmuth Mutual',
  'Freedom Health Plan',
  'Freedom Life Insurance Co',
  'Fresenius Health Partners',
  'Fresno PACE',
  'Fresno Police Officers Association',
  'FRESNO POLICE OFFICERS ASSOCIATION (WC Only)',
  'Friedkin Companies, Inc (Auto only)',
  'Friedkin Companies, Inc (WC only)',
  'Friendly Franchisees Corportion (FFC) (MN, TX) [WC ONLY]',
  'Fringe Benefits Coordinators',
  'Frito Lay/Modesto/Injuries (MN, TX) [WC ONLY]',
  'Frontier Logistics Services/Torranc (MN, TX) [WC ONLY]',
  'FrontPath Health Coalition',
  'Fullerton Union High School District (CA) (Auto only)',
  'Fullerton Union High School District (CA) (WC  only)',
  'Future Care IPA',
  'Future Care Medical Associates',
  'Future Packaging (MN, TX) [WC ONLY]',
  'GAB Robbins, Inc. (CA, MN, TX) (Auto Only)',
  'GAB Robbins, Inc. (CA, MN, TX) (WC Only)',
  'GAB Robbins, Inc. (TX, MN)',
  'GAB ROBINS (FOR VAN TUYL COMPANIES ONLY) (WC Only)',
  'Galderma Laboratories, LLC',
  'Gallade Chemical, Inc./Oc (CA, TX) [WC ONLY]',
  'Gallagher Bassett',
  'Gallagher Bassett (ALL) (WC Only)',
  'Gallagher Bassett (Sacramento) (WC Only)',
  'Galveston County Indigent Health Care',
  'Garden Grove Unified School District',
  'Gary Community Schools (ALL)',
  'Gategourmet #836 (ALL) (WC Only)',
  'Gates Corp Dba Gates Rubber Co (TX, MN) (WC Only)',
  'Gates Mcdonald & Company',
  'GATES MCDONALD (WC Only)',
  'Gateway Health Plan - Medicare Assured',
  'Gateway Health Plan Medicaid PA',
  'Gateway Health Plan Ohio-Medicare Assured (Pittsburg PA)',
  'Gateway IPA (Pinnacle Health Resources) (Prospect Medical Group)',
  'Gateway PA',
  'Gateway to Better Health - FFS',
  'GE Auto',
  'GEICO (MN & TX) (Work Comp Only)',
  'Geico (MN Only) (Auto Only)',
  'Geisinger Health Plan',
  'Gemcare Health Plan',
  "GENERAL CASUALTY - FARMERS' UNION (ALL) [WC ONLY]",
  'GENERAL CASUALTY CO OF WISCONSIN (AUTO Only)',
  'GENERAL CASUALTY CO OF WISCONSIN (WC Only)',
  'GENERAL CASUALTY-FREEPORT (MN, TX) [WC ONLY]',
  'GENERAL CASUALTY-WEST DES MOINES (ALL) AUTO ONLY',
  'General Electric/Romoland (MN, TX) [WC ONLY]',
  'General Motors Corporation (MN, TX,CA Only) [WC ONLY]',
  'General Parts International (Auto only)',
  'General Parts International (WC only)',
  'Generations Healthcare',
  'Genesis Healthcare (EMG)',
  'GENEX (AUTO) (ALL STATES)',
  'GENEX (WC Only) (TX & MN Only)',
  'Genex Care for Ohio',
  'Genex Services (Orange County)',
  'Genex Services (Sacramento)',
  'Genex Services (Schaumburg, IL)',
  'Gentiva Health Service (TX Only) (Auto Only)',
  'Gentiva Health Service (TX Only)(WC Only)',
  'GEO',
  'Georgia Casualty & Surety Co (ALL) (WC Only)',
  'Georgia Health Plus',
  'Georgia Power Medical Benefits Plan',
  'Georgia-Pacific Liability',
  'Georgia-Pacific LLC Liability (CA Only) [WC ONLY]',
  'GHI HMO',
  "Gillette Children's Specialty Healthcare",
  'Global Care Inc.',
  'Global Care Medical Group IPA',
  'Global Excel Management',
  'GMAC Insurance Management Corporation (AUTO ONLY) (MN ONLY)',
  'GMP Employers Retiree Trust',
  'GMS',
  'Golden Corral Corporation (MN, TX) [WC, Auto]',
  'GOLDEN CORRAL CORPORATION (TX, MN) (WC Only)',
  'Golden Eagle Insurance Co.',
  'Golden Shore Medical Group (GSMG)',
  'Golden State Supply  (ALL) (WC Only)',
  'GOLDEN TRIANGLE PHYSICIAN ASSOCIATES',
  'Good Samaritan MedicalPractice Association',
  'Good Samaritan MPA',
  'GOOD SHEPHERD HOSPICE INC',
  'Goodrich',
  'Goodwill Industries (San Diego)',
  'Goodwill Industries (San Diego) (WC Only)',
  'Goodyear Just Tires/Mo Val #4835 (CA, MN, TX) [WC ONLY]',
  'Government Employees Health Association (GEHA) DOS PRIOR TO 2016 ONLY',
  'Government Employees Health Association (MO) DOS PRIOR TO 2016 ONLY',
  'Government Employees Hospital Association (GEHA) (Not VA)',
  'Grand River Insurance (AUTO Only)',
  'Grand River Insurance (WC Only)',
  'Grand Valley Health Plan',
  'Grange Mutual Casualty Company (MN Only) (Auto Only)',
  'GRANGE MUTUAL CASUALTY COMPANY (WC Only) (All States)',
  'Grange WC (WC Only) (All States)',
  'Grant Physicians Practice Association',
  'Graphic Arts Mutual (TX, MN, CA, LA Only) (WC Only)',
  'Graphic Arts Mutual (WC Only) (TX/MN/CA/LA Only)',
  'Graphic Communications Union Local 8-M & 96B Health & Welfare Fund',
  'Graphics Art Mutual (MN, TX) [WC ONLY]',
  'Gray Insurance Co. (MN, TX) WC ONLY',
  'Great America, Inc./Natl Market Div (MN, TX) [WC ONLY]',
  'Great American Alliance Ins Co. (TX, MN,CA/NC/NM Only) (WC Only)',
  'Great American Assurance Co. (TX, MN,CA/NC/NM Only) (WC Only)',
  'Great American Assurance Co. (WC Only) (MN,TX,CA Only)',
  'Great American Ins. Co. (TX, MN,CA/NC/NM Only) (WC Only)',
  'Great American Ins. Co. of N.Y. (TX, MN,CA,NM,NC Only) (WC Only)',
  'Great American Ins. Co. of N.Y. (WC Only) (TX,MN,CA Only)',
  'Great Central (ALL)',
  'Great Divide Insurance (ALL STATES) [WC ONLY]',
  'Great Health ( St Louis)',
  'Great Lakes PACE',
  'Great Plains Medicare Advantage (ND)',
  'Great Plains Medicare Advantage (NE)',
  'Great Plains Medicare Advantage (SD)',
  'Great River Insurance Co (MN, TX) WC ONLY',
  'Great West Casualty',
  'Great West HealthCare',
  'Great West Healthcare (formerly ONE HEALTH PLAN OF CA)',
  'Great Western Litho',
  'Greater Covina Medical Group',
  'Greater Newport Physicians',
  'Greater Oregon Behavioral Health',
  'Greek Catholic Union',
  'Green Diamond WA (Auto only)',
  'Green Diamond WA (WC only)',
  'Greentree Administrators',
  'Grinnell (TX and MN only)',
  'Group Administrators  (in Schaumburg, Illinois)',
  'Group and Pension Administrators',
  'GROUP BENEFIT SERVICES',
  'Group Health Cooperative - West',
  'Group Health Cooperative of Eau Claire - Commercial Claims',
  'Group Health Cooperative of Eau Claire - Medicaid Claims',
  'Group Health Cooperative of South Central Wisconsin',
  'Group Health Cooperative of South Central Wisconsin-Encounters',
  'Group Health Insurance (GHI) of NY',
  'Group Health Managers',
  'Group Insurance Service Center (Pembroke MA)',
  'Group Resources',
  'Gse Lining Technology, Inc. (TX, MN) (WC Only)',
  'Guard Insurance Group (WC ONLY) ANY STATE',
  'Guardian Life Insurance Company of America',
  'GuideOne Elite Insurance - (AUTO ONLY)',
  'GuideOne Elite Insurance - (WC ONLY)',
  'GuideOne Mutual Insurance (AUTO ONLY)',
  'GuideOne Mutual Insurance (WC ONLY)',
  'GuildNet',
  'GUILDNET (DOS Prior to 06/01/18)',
  'Gulf South Risk Services',
  'Gulf South Risk Services (A1)',
  'Gulf Stream-General Dynamics',
  'Gulfquest Rennaissance',
  'Gundersen Lutheran Health Plan',
  'GUT Management - CAC United',
  'GUT Management - Care Florida',
  'GUT Management - CIGNA',
  'GUT Management - Health Options',
  'GUT Management - HIP of Florida',
  'GUT Management - PCA Family Health Plans',
  'GUT Management - PCA Health Plan',
  'H & H Specialties (CA, MN, TX) [WC ONLY]',
  'H & R Block (Auto Only)',
  'H & R Block (WC Only)',
  'H.E.R.E.I.U. Welfare Pension Funds',
  'HAA Preferred partners',
  'Halcyon Behavioral Health',
  'Hallmark Managment Insurance (MN, TX) [WC ONLY]',
  'Hammerman & Gainer',
  'Hammond & Masing General Contractor (WC Only)',
  'Hannaford (WC Only) (All States)',
  'HANOVER INSURANCE CO (TX, MN & CA) (WC Only)',
  'Hanover Insurance Company (Auto Only)',
  'Hanover Insurance Company (WC Only)',
  'HAP Midwest Health Plan - MI',
  'Harbor Advantage (Abrazo Health Care)',
  'Harbor Distributing/East Edinger (MN, TX) [WC ONLY]',
  'Harken Health',
  'Harley Davidson/Rocklin (TX ONLY) [WC ONLY]',
  'Harleysville Insurance Company (Auto Only)',
  'Harleysville Insurance Company (WC only)',
  'Harmony Health Plan',
  'Harmony Health Plan of Indiana',
  'Harmony Health Plans of Illinois',
  'Harpeth IPA - Amerivantage',
  'Harrington Health Non-EPO',
  'Hartford Accident and Indemnity Company',
  'Hartford Casualty Insurance Company',
  'Hartford Fire Insurance Company',
  'Hartford Insurance Company of the Midwest',
  'Hartford Insurance Company of the Midwest (ALL) (Advanced Disposal Services ONLY)',
  'Hartford Insurance Company of the Midwest (ALL) (Alliant Tech Systems ONLY)',
  'Hartford Insurance Company of the Midwest (ALL) (Americold Logistics ONLY) (WC Only)',
  'Hartford Insurance Company of the Midwest (ALL) (Knowledge Learning Corporation ONLY) (WC Only)',
  'Hartford Insurance Company of the Midwest (ALL) (Scottsdale Healthcare Corp ONLY)',
  'Hartford Insurance Company of the Midwest (Pfizer, Inc. ONLY) (ALL) (WC Only)',
  'Hartford Insurance Company of the Midwest (Publix ONLY) (ALL)',
  'Hartford Insurance Company of the Midwest (QCS ONLY) (ALL) (WC Only)',
  'Hartford Insurance Company of the Midwest (Ruby Tuesday ONLY) (ALL States) (WC Only)',
  'Hartford Insurance Company of the Midwest (Stericycle ONLY) (ALL States) (WC Only)',
  'Hartford Insurance Company of the Midwest (Wells Fargo ONLY) (ALL States) (WC ONLY)',
  'Hartford Insurance Company of the Midwest (Wendys Arbys Group ONLY) (WC Only)',
  'Hartford Life and Accident Insurance Company',
  'Hartford Life and Annuity Insurance Company',
  'Hartford Life Insurance Company',
  'HARTFORD MEDICAL MGMT (MN,TX) (WC Only)',
  'Hartford Underwriters Insurance Company',
  'HARTFORD-GENERAL LIABILITY CLAIMS (WC Only)',
  'Harvard Community Health Plan',
  'Harvard Pilgrim Health Care',
  'Hawaii Medical Services Association',
  'Hawkeye (WC Only)',
  'HCA-Hosptial Corporation of America',
  'HCHA-Albq, NM Self Funded',
  'HCMedNet/PHC',
  'Health Alliance Medical Plans of Illinois',
  'Health Alliance Plan of Michigan',
  'Health Care LA IPA',
  'Health Care Network of Wisconsin (HCN)',
  'Health Care Partners',
  'Health Care Partners- AZ',
  "Health Care Payer's Coalition (Toledo OH)",
  'Health Choice Insurance Co',
  'Health Choice Integrated Care (only DOS 10-1-15 and after)',
  'Health Claims Service',
  'Health Cost Solutions',
  'Health Design Plus (Hudson, OH)',
  'Health Economic Livelihood Partnership (HELP)',
  'Health First Health Plans - National',
  'Health Future LLC',
  'Health Insurance Plan NY Anesthesia',
  'Health Insurance Plan of Greater NY (HIP)',
  'Health Management Administrators (HMA)',
  'Health Net - California (Institutional Encounters)',
  'Health Net - VA Patient Centered Community Care Program',
  'Health Net of Arizona',
  'HEALTH NET OF CALIFORNIA (ENCOUNTERS ONLY)',
  'Health Net of California (Encounters)',
  'Health Net of California and Oregon',
  'HEALTH NET, INC. (WC Only) (TX,MN,CA Only)',
  'Health Network America',
  'Health Network of Colorado Springs, Inc.',
  'Health Network One',
  'Health One Alliance',
  'Health Options of Florida HMO',
  'HEALTH PARTNERS (MN, TX) (Auto Only)',
  'Health Partners - Jackson TN',
  'Health Partners - Minnesota',
  'Health Partners, PA',
  'Health Plan of Michigan',
  'Health Plan of San Joaquin',
  'Health Plan of San Mateo',
  'Health Plan of San Mateo (CA Medicaid MCO)',
  'Health Plans Inc',
  'Health Plans of San Mateo',
  'Health Services Consulting Group Inc.',
  'Health Services for Children with Special Needs',
  'Health Services Management  HSM',
  'HEALTH SMART-LUBBOCK (MN, TX) (WC Only)',
  'HEALTH SPECIAL RISK INCORPORATED',
  'Health Spring, Inc',
  'Health Texas Medical Group',
  'Healthcare District Palm Beach County',
  'Healthcare Highways',
  'Healthcare Management Admin (HMA)',
  'Healthcare Management Administrators',
  'HealthCare Options',
  'Healthcare Partners /Heritage New York Medical Group',
  'HealthCare Partners of Nevada',
  'Healthcare Resources NW',
  'Healthcare Resources, Inc',
  'Healthcare Services Group (MN, TX) [WC, Auto]',
  'Healthcare Services Group (WC Only)',
  'Healthcare Solutions Group (Muskogee OK)',
  'Healthchoice Generations',
  'Healthchoice of AZ',
  'HealthChoice Oklahoma (DOS on or after 01/01/18)',
  'HealthEase',
  'HealthEdge Administrators (Bakersfield, CA)',
  'HealthEOS',
  'Healthfirst - Tyler, TX',
  'HealthFirst of New York',
  'Healthfirst TPA',
  'Healthgram Inc (formerly known as Primary PhysicianCare Inc)',
  'HealthGroup Limited',
  'Healthlink HMO',
  'Healthlink Medi-Van/Corp (MN, TX) [WC ONLY]',
  'Healthlink PPO/National Capital Preferred Provider Organization (NCPPO)',
  'Healthmark Plus/ Healthpoint',
  'HealthNow NY [55204]',
  'HealthPartners (TX, MN) (WC Only)',
  'Healthscope Benefits - EHC Repricing',
  'HealthSCOPE Benefits Inc',
  'Healthsmart (WC Only) (TX Only)',
  'Healthsmart Accel',
  'HealthSmart Benefit Solutions (Wells Fargo)',
  'Healthsmart Benefit Solutions, Inc.',
  'Healthsmart Preferred Care',
  'HealthSmart Preferred Care, Inc.',
  'Healthsource CMHC',
  'Healthsource Provident (CIGNA)',
  'Healthsource, GA (CIGNA)',
  'Healthsource, KY',
  'Healthsource, ME',
  'Healthsource, NC (CIGNA)',
  'Healthsource, NH',
  'Healthsource, OH',
  'Healthsource, TN (CIGNA)',
  'Healthsouth/Tustin (CA ONLY) [WC, Auto]',
  'Healthsun',
  'Healthy Blue Louisiana',
  'Healthy Indiana Plan (HIP)',
  'Healthy Palm Beaches',
  'Healthy Texas',
  'HEALTHY YORK NETWORK',
  'Heartland Express (Auto only)',
  'Heartland Express (WC only)',
  'Heartland Express AUTO ONLY (ANY STATE)',
  'HEARTLAND EXPRESS WC ONLY ANYSTATE',
  'Heartland Hospice #4685 (MN, TX) [WC ONLY]',
  'Heartland Hospice #4687',
  'Heartland Hospice #4687 (MN, TX) [WC ONLY]',
  'Heavy & General Laborers Welfare Fund',
  'Helmsman Management Services (Auto Only)',
  'Helmsman Management Services (MN, TX) [WC, Auto]',
  'Help At Home Holdings (WC Only)',
  'Hemet Community Medical Group',
  'Hercules/Vernon (MN, TX) [WC ONLY]',
  'Heritage Consultants',
  'Heritage Group (CA, MN, TX) [WC, Auto]',
  'Heritage Group (TX, MN)',
  'HERITAGE PHYSICIAN NETWORK',
  'Heritage Victor Valley Medical Group',
  'Hertz Rent A Car (All States) [WC ONLY]',
  'Hetrick-Drake Associates (ALL States)',
  'Hewlett Packard Company (WC Only) (TX,MN,CA Only)',
  'HEWLETT PACKARD COMPANY WC ONLY (TX,MN & CA)',
  'HFN Inc',
  'HHH Choices Gold (NY Medicaid MCO)',
  'HHS (Hospital Housekeeping Systems)',
  'High Desert Medical Group',
  'Highline Medical Service Organization-Molina (HMSO)',
  'Highmark BCBSD Health Options Inc.',
  'Highmark Casualty Insurance Auto',
  'Highmark Casualty Insurance WC',
  'Highmark Senior Health Company',
  'Hih America /Care America (TX ONLY) [WC, Auto]',
  'Hill Physicians Blue Shield PPO',
  'Hill Physicians Health Net PPO',
  'Hill Physicians Medical Group - Aetna',
  'Hill Physicians United Healthcare PPO',
  'Hillshire Brands (Auto only)',
  'Hillshire Brands (WC only)',
  'HILMAR CHEESE COMPANY (WC ONLY) ALL STATES',
  'Hines Nurseries/Fallbrook (MN, TX) [WC ONLY]',
  'Hinsdale Medicare Advantage',
  'Hipp Temporary Skills (All States)',
  'HISPANIC PHYSICIAN IPA',
  'HISPANIC PHYSICIANS IPA',
  'HMA Hawaii',
  'HMC HealthWorks',
  'HMO Louisiana Inc',
  'Hockenberg Equipment',
  'Holly Farms Corp. (TX, MN) (WC Only)',
  'Hollywood Pres GLOBAL',
  'Hollywood Presbyterian Medical Center - Preferred (HPMC - PMG)',
  "Hollywood Presbyterian Medical Center - St. Vincent's IPA (HPMC - SVI)",
  'Home Health - Medicare Region IV Gulf Coast and Midwest',
  'Home Health [.HOM] - Medicaid Louisiana',
  'Home Health and Hospice Missouri Medicare Part A',
  'Homeland Security',
  'HOMELINK',
  'Homelink HealthPartners',
  'Hometown Buffet/Westchester (CA, MN, TX) [WC ONLY]',
  'Hometown Health Plan Nevada',
  'Hopkins Health Advantage',
  'Horizon Mercy',
  'Horizon Valley Medical Group',
  'Hortica Florist Mutual Insurance (TX, MN,CA,NM,NC Only) (WC Only)',
  'Hospital Benefits, Inc',
  'Hospital Housekeeping Systems (HHS)',
  'Hospital IP/OP [.UB9] - Medicaid Louisiana',
  'Household Merch NNI (TX, MN) (WC Only)',
  'Housing Authority El Paso (WC ONLY) (TX,MN,CA Only)',
  'Houston Hunter Patrol, Inc (TX, MN) (WC Only)',
  'Howard County Government (MD)(Auto only)',
  'Howard County Government (MD)(WC only)',
  'HSBS Memphis',
  'HSBS Oklahoma City',
  'HSBS World Trade Center Health Program',
  'HSHS Medical Group IPA',
  'Hughes Resources (All States)',
  'Hughes Tool Company (TX, MN) (WC Only)',
  'Human Behavior Institute',
  'Humana (and subsidiaries) claims',
  'Humana (Puerto Rico)',
  'Humana encounters (no payment)',
  'Humana, Inc. (WC Only)',
  'HURON VALLEY PACE',
  'Hussmann Corp. (MN, TX) [WC ONLY]',
  'Hutchinson Technology (TX and MN) (Auto only)',
  'Hutchinson Technology (TX and MN) (WC only)',
  'Hylton Payroll (Benefit Plan Administrators)',
  'I E Shaffer (West Trenton NJ)',
  "I'Mcare",
  'I.E. SHAFFER',
  'IBA Self Funded Group',
  'IBEW Local 347',
  'IBEW Local 481',
  'IBEW LOCAL ONE HEALTH AND WELFARE (MENTAL HEALTH)',
  'ICare Health Options (FL Optometric Phys)',
  'iCircle of New York',
  'ICW (Insurance Co of the West)  (WC ONLY)',
  'ICW Group (NV Only)',
  'IDS Property Casualty Insurance Company (MN Only) (Auto Only)',
  'IEC Group - AmeriBen',
  'IFCO Systems (Auto Only)',
  'IL Fornaio (America) Corp (ALL States) (WC Only)',
  'Illinois Casualty (TX, MN)(WC Only)',
  'ILLINOIS HEALTH PARTNERS',
  'ILLINOIS PHYSICIANS ALLIANCE IPA',
  'IMA INC',
  'Imagine Health',
  'Impac Companies (MN, TX) [WC ONLY]',
  'Imperial Care Center',
  'Imperial Health Holdings Medical Group',
  'IMX Easy',
  'Independence Administrators',
  'Independence American Insurance Company',
  'Independence Blue Cross Personal Choice/Blue Card',
  'Independence Medical Group',
  'Independence Medical Group - Kern Cnty',
  'Independence Medical Group - Tulare Cnty',
  'Independent Care Health Plan',
  'Independent Health',
  'Independent Health Services, Inc.',
  'Independent Lifestyles Inc. (MN, TX) [WC ONLY]',
  'Independent Living Systems',
  'Indian Health Services',
  "Indiana Department of Health - Children's Health",
  'Indiana Insurance (WC Only)',
  'Indiana Lumbermen (Indianapolis) (ALL States) (WC Only)',
  'Indiana ProHealth Network',
  'Indiana University Health Plan (Medicare)',
  'Informed LLC',
  'Ingalls Provider Group (Dates of Service on or after 05/01/2015)',
  'Ingham Health Plan Corporation',
  'Ingles Markets',
  'Inland Empire Health Plan (DOS Prior to 4/01/2018)',
  'Inland Faculty Medical Group',
  'Inland Faculty Medical Group - Encounters',
  'Inland Health Organization (IHO)',
  'Inland Nighthawk Security (MN, TX) [WC ONLY]',
  'Innovative Claim Solutions (ICS) - Rancho Cordova (Auto only)',
  'Innovative Claim Solutions (ICS) - Rancho Cordova (WC only)',
  'Innovative Claim Solutions (ICS) - San Ramon (Auto only)',
  'Innovative Claim Solutions (ICS) - San Ramon (WC only)',
  'Innovative Physician Associates',
  'INS Health Services (Washington DC)',
  'Inservco Insurance Services (WC Only) (All States)',
  'Insilco Corp (TX, MN) (WC Only)',
  'Insurance Collision Center (TX ONLY) [WC ONLY]',
  'Insurance Company of the West (ICW) (WC Only) (All States)',
  'Insurance Company State of Pennsylvania (ALL States)',
  'Insurance Management Services (IMS) of Texas',
  'INSURANCE SYSTEMS',
  'INSURANCES SERVICES OF LUBBOCK',
  'Insurdata/Insurnational',
  "Insurer's Administrative Corporation",
  'Insurers Administrative Corporation',
  'Integra Administrative Group (DE)',
  'Integra Group - CHA',
  'Integra MLTC, Inc.',
  'Integrated Claims Administrators (ICA) (MN, TX) [WC ONLY]',
  'INTEGRATED HEALTH PARTNERS (IHP)',
  'Integrated Medical Solutions',
  'Integrated Mental Health Services',
  'Integrity Administrators (Champion Chevrolet)',
  'INTEGRITY MUTUAL INSURANCE COMPANY  (WC Only) (All States)',
  'INTER AMERICAS INSURANCE CORPORATION INCORPORATED',
  'Inter Valley Health Plan (Fee-For-Service Only)',
  'Interactive Medical Systems',
  'Interamerican Motor/Canoga Park (MN, TX) [WC ONLY]',
  'Intercare (WC Only) (All States)',
  'Intercare Insurance Services (CA, NV, TX, WA) (WC Only)',
  'INTERCARE INSURANCE SERVICES (TX ONLY) [WC, Auto]',
  'INTERCARE INSURANCE SERVICES (WC Only)',
  'Intercommunity Health Net',
  'Interface EAP (IEAP)',
  'Intergroup Services Corporation',
  'Interinsurance Exchange of the Automobile Club',
  'Interlock (Metal Sales) (ALL States)',
  'Intermountain Healthcare (Auto)',
  'Intermountain Healthcare (WC)',
  'International Benefit Administration',
  'International Casing Group (ALL States)',
  'International Funding, LTD',
  'International Medical Card',
  'International Medical Group',
  'International Paper/Modesto',
  'International Security Service (MN, TX) [WC ONLY]',
  'International Union of Operators Engineers Local 15, 15A, 15C, & 15D AFL-CIO',
  'InterWest Health',
  'InTotal Health (For DOS on or after July 1, 2016)',
  'Iowa Holdings (ALL States)',
  'Iowa Screening Program',
  'IPMG Claims Management Services (Insurance Program Managers Group)',
  'Irex Corporation (TX, MN) (WC Only)',
  'IRONWORKING CONTRACT I.P.  (WC Only) (TX,MN Only)',
  'Ironworking Contract I.P. (TX, MN) (WC Only)',
  'iSurity',
  'Itt Hartford (MN, TX) [WC ONLY]',
  'J B Hunt Transport Inc. (MN, TX, CA Only) WC ONLY',
  'J. Fletcher Creamer & Son Corp (MN, TX) [WC ONLY]',
  'Jackson Care Connect',
  'JAI Medical Systems',
  'Jencare Medical',
  'Jenkins & Associates',
  'Jenny Craig (TX,MN,CA ONLY) [WC ONLY]',
  'Jensen Industries (MN, TX) [WC ONLY]',
  'JI SPECIALTY SERVICES (TX Only) (WC Only)',
  'JI Specialty Services (TX, MN)',
  'Jobsmart (ALL States)',
  'John Morrell Company Co. - AHPBA',
  'JOHN MUIR TRAUMA PHYSICIANS',
  'John Muir/Tapestry',
  'Jones Truck Lines,Inc. (TX, MN) (WC Only)',
  'Joplin Claims',
  'JP Farley Corporation',
  'JPS CONNECTION',
  'JSL Administrators',
  'Jt2',
  'Juvenile Jail Facility Management (TX, MN) (WC Only)',
  'JVHL - AETNA BETTER HEALTH PREMIER PLAN',
  'JVHL - Aetna U.S. Healthcare (LAB CLAIMS ONLY)',
  'JVHL - BCBS MI Medicare Plus Blue',
  'JVHL - Beaumont Employee Health Plan (LAB CLAIMS ONLY)',
  'JVHL - Blue Care Network (BCN Comm. Labs ) (LAB CLAIMS ONLY)',
  'JVHL - Blue Care Network (JVHL Network) (LAB CLAIMS ONLY)',
  'JVHL - CIGNA (NON-HAP MEMBERS) (JVHL Network) (LAB CLAIMS ONLY)',
  'JVHL - DMC Care (LAB CLAIMS ONLY) (all contracts w/DOS <= 5/31/05)',
  'JVHL - DMC Care (LAB CLAIMS ONLY) (all contracts w/DOS >= 05/31/05)',
  'JVHL - Genesee County Health Plan (LAB CLAIMS ONLY)',
  'JVHL - GOLDEN RULE (JVHL Network) (LAB CLAIMS ONLY)',
  'JVHL - Great Lakes Health Plan (LAB CLAIMS ONLY)',
  'JVHL - HAP MIDWEST HEALTH PLAN (FFS) (JVHL Network) (LAB CLAIMS ONLY)',
  'JVHL - Health Alliance Plan (Capitated Contracts) (LAB CLAIMS ONLY)',
  'JVHL - HEALTH ALLIANCE PLAN (FEE for SERVICE, LAB Claims Only)',
  'JVHL - HEALTH PARTNERS (JVHL Network) (LAB CLAIMS ONLY)',
  'JVHL - Health Plan of Michigan (LAB CLAIMS ONLY)',
  'JVHL - Healthchoice (LAB CLAIMS ONLY)',
  'JVHL - HEALTHPLUS OF MICHIGAN (JVHL Network) (LAB CLAIMS ONLY)',
  'JVHL - HUMANA (JVHL Network) (LAB CLAIMS ONLY)',
  'JVHL - HUMANA HMO-X (JVHL Network) (LAB CLAIMS ONLY)',
  'JVHL - MCLAREN HEALTH PLAN (JVHL Network) (LAB CLAIMS ONLY)',
  'JVHL - Midwest Health Plan (LAB CLAIMS ONLY)',
  'JVHL - Molina Healthcare of Michigan (LAB CLAIMS ONLY)',
  'JVHL - Omnicare Health Plan (LAB CLAIMS ONLY)',
  'JVHL - Priority Health (LAB CLAIMS ONLY)',
  'JVHL - The Wellness Plan (LAB CLAIMS ONLY)',
  'JVHL - TOTAL HEALTH Care (JVHL Network) (LAB CLAIMS ONLY)',
  'JVHL - United Healthcare (LAB CLAIMS ONLY)',
  'Kaiser - Self Funded',
  'Kaiser Electronics (MN, TX) [WC ONLY]',
  'KAISER FOUNDATION HEALTH PLAN (MN,TX,CA) (WC Only)',
  'Kaiser Foundation Health Plan of Colorado',
  'Kaiser Foundation Health Plan of Georgia',
  'Kaiser Foundation Health Plan of Hawaii',
  'Kaiser Foundation Health Plan of Northern CA Region',
  'Kaiser Foundation Health Plan of Southern CA Region',
  'Kaiser Foundation Health Plan of the Mid-Atlantic States, Inc.',
  'Kaiser Foundation Healthplan of the Northwest',
  'Kaiser Foundation of the Northwest (Oregon and Washington claims only)',
  'Kaiser Permanente ( Northern CA)',
  'Kaiser Permanente ( Southern CA)',
  'KAISER PERMANENTE KPIC',
  'Kane County IPA',
  'Kansas Superior Select',
  'KATY MEDICAL GROUP',
  'Kaweah Delta Medicare Advantage',
  'KCI Holdings USA (TX, MN) (WC Only)',
  'Keenan & Associates',
  'Keenan & Associates (CA ONLY) [WC, Auto]',
  'Keenan & Associates Torrance (Auto Only)',
  'Keenan and Associates (excluding City of Pasadena)',
  'Kellogg Companies',
  'Kelly Services #1571/Wellsfargo (CA, MN, TX) [WC ONLY]',
  'Kelly Services (ESIS) (WC Only)',
  'Kelsey-Seybold',
  'Kemper Benefits',
  'Kemper UniTrin Safeguard Ins Company (WC Only)',
  'Kempton Company',
  'KEMPTON GROUP ADMINISTRATORS (USC)',
  'Ken Davis Industries Inc. (TX, MN) (WC Only)',
  'Kenosha County (WMMIC) (ALL States)',
  'Kent County Health Plan',
  'Kentucky Health Administrators, Inc.',
  'Kentucky National (ALL States)',
  'Kern County CDCR',
  'Kern Health Care Network',
  'Kern Health Systems',
  'Kern Legacy Health Plan',
  'Key Benefit Administrators (Indianapolis, IN)',
  'Key Health Medical Solutions, Inc',
  'Key Medical Group',
  'Key Risk Management Services LLC',
  'Key Select',
  'Key Solution',
  'Keystone First VIP Choice',
  'Keystone Health Plan Central',
  'Keystone Health Plan East',
  'Keystone Mercy Health Plan',
  'KG Administrative Services',
  'KINDRED HEALTHCARE (WC Only) (TX,MN,CA Only)',
  'Kindred Hospital (Santa Ana) (CA ONLY) [WC ONLY]',
  "Kirkland's Inc",
  'Klais and Company aka Health Smart',
  'Koch Foods, Inc (Auto only)',
  'Koch Foods, Inc (WC only)',
  'Kroger Co.  [WC ONLY] (TX,MN,CA Only)',
  'KUSPUK SCHOOL DISTRICT',
  'L.A. County Dept 250/Childrens Med',
  'L.A. Fire Dept. (CA ONLY) [WC ONLY]',
  'LA Care Health Plan (Los Angeles Care Health Plan)',
  'Labor Finders/Sd',
  'LACH HealthNet by MedPOINT',
  'Lafayette Consolidated Government',
  'Laidlaw (#816) (CA, MN, TX) [WC, Auto]',
  'Lakes Area Community Healthplan (LACH)',
  'Lakeside Comprehensive Healthcare',
  'Lakeside Health Services',
  'Lakeside Medical Group',
  'Lakewood IPA',
  'Lancaster General Hospital',
  'Landmark Healthcare',
  "Landry's (Auto only)",
  "Landry's (WC only)",
  'Landstar Bco Wc Program (TX, MN)',
  'Lane County (Or) (Auto only)',
  'Lane County (Or) (WC only)',
  'LaSalle Medical Associates',
  'Lausd',
  'Lawndale Christian Health Center',
  'LBA Health Plans',
  "LCTA Workers' Comp",
  'League of Minnesota Cities Insurance Trust',
  'Leon Medical Center Health Plan',
  'LFP Corporation (Auto only)',
  'LFP Corporation (WC only)',
  'Liberty Advantage',
  'Liberty Health Advantage',
  'Liberty Mutual (Auto Only)',
  'Liberty Mutual (WC Only)',
  'Liberty Mutual (WC Only) (All States)',
  'Liberty Mutual Fire Insurance Co (MN,TX) (WC Only)',
  'Liberty Mutual Insurance Company (WC Only) (All States)',
  "Liberty Mutual Worker's Comp Only",
  'Life & Health Ins Co of America (NFL Plan Only)',
  'Life Gift Cards',
  'Life Investors Insurance',
  'LIFE Pittsburgh',
  'LIFE St. Joseph of The Pines',
  'Life Trac',
  'Lifecircles Pace',
  'LifeGuard',
  'Lifelong Medical Care',
  'Lifemap',
  'LifePath Hospice Inc',
  'Lifetime Benefit Solutions',
  'LifeWise - A Premera Health Plan(OR claims only)',
  'Link Snacks (Jacks Links) (Auto only)',
  'Link Snacks (Jacks Links) (WC only)',
  'Linkia - Aetna',
  'Linkia - Cigna',
  'Linkia - HealthNet of CA',
  'Linkia - UHC',
  'Linkia - UHC - Community',
  'Linkia - UHC - Oxford',
  'Lithonia-Acuity Lighting/Ontario',
  'Little Company of Mary',
  'LivHOME (ALL) [WC, Auto]',
  'LKQ Corporation (Auto Only) (TX,MN Only)',
  'Local 135 Health Benefits Fund (Indianapolis, IN)',
  'Local 137 Operating Engineers Welfare Fund',
  'Local 295/851 I. B. T. Employer Group Welfare Fund',
  'Lockheed Martin Corporation (WC Only)',
  'Loma Linda University Adventist Hlth Sciences Ctr',
  'Loma Linda University Healthcare - ManagedCare Claims',
  'Lone Star',
  'Lone Star National Ins. Co.',
  'Long Beach Unified School District (WC Only) (CA Only)',
  'Long Pherson Assoc (ALL States)',
  'Longs Drugs (WC Only) (All States)',
  'LOOMIS FARGO & CO./SD (MN, TX) (WC Only)',
  'LOUISIANA DEPARTMENT OF CORRECTIONS',
  'Louisiana State University (Auto only)',
  'Louisiana State University (WC  only)',
  "Louisiana Workers' Compensation Corporation (LWCC)",
  "Lowe's",
  'LOWER KUSKOKWIM SCHOOL DISTRICT',
  'Lowes Home Center',
  'LSG Sky Chefs International (TX, MN) (WC Only)',
  'LTC, ICF/DD, SNF, Hospice [.LTC] - Louisiana Medicaid',
  'Luba Casualty Insurance Company (LUBA)',
  'LUBA CASUALTY INSURANCE COMPANY (MN, TX)  WC ONLY',
  'Lucas & Mercer Construction Inc.',
  "Lumbermen's Underwriting All States",
  "Lumbermen's Underwriting Alliance (WC Only) (TX,MN,CA,IL,LA Only)",
  'LUTHER CARE',
  'Lutheran Preferred',
  'LWP Claims Solution, Inc',
  'LYNX (Auto only)',
  'LYNX (WC only)',
  'M&M Transport',
  'M.I.S. International',
  'Mackinaw Administrators',
  'Mackinaw Oakland County',
  'MacNeal Health Providers- CHS',
  'Macys  (Daly City) (WC Only)',
  'Macys (Auto Only)',
  'Macys (Newport Beach) (WC Only)',
  'Macys Corporate Services (MN Only) (WC Only)',
  'Madison Gas & Electric (ALL States)',
  'Magellan Behavioral Health',
  'Magellan Behavorial Health (IA providers only)',
  'Magellan Complete Health of Virginia',
  'Magnetic Imaging Services, Inc. (MIS) (MN, TX) [WC, Auto]',
  'Magnolia Health Plan',
  'Maine Community Health Options',
  'Mainstay Business Solutions (Folsom)',
  'Majestic Insurance Company',
  'MAJOR LEAGUE BASEBALL 8',
  'Major League Baseball 8 (TX, MN) (WC Only)',
  'Maksin Management Corporation (Pennsauken NJ)',
  'Managed Care Systems',
  'Managed Care Systems (Delano)',
  'MANAGED CARE SYSTEMS CDCR',
  'Managed Health Services Indiana (Medicaid HMO)',
  'Managed Health Services Wisconsin',
  'MANAGED HEALTHCARE ASSOC (MHCA)',
  'Managed Physical Network (MPN)',
  'Manor Care/F.V.',
  'Manpower (Auto Only) (TX,MN Only)',
  'Manpower/Hemet',
  'Manulife, W.J. Sutton Co. of Toronto, Ontario',
  'MAPFRE',
  'MARCH VISION CARE',
  'Maricopa Health Plan, managed by UPH',
  'Maricopa Orchards, Llc',
  'Marion Polk Community Health Plan (MPCHP)',
  'Marion Polk Community Health Plan Advantage',
  'Marisol Gomez Labor Agency',
  'Markel (Auto)',
  'Markel (WC)',
  'Marrick Medical Finanace, LLC.',
  'Marrick WRx',
  'Marriott',
  'Marriott Claims Service',
  'Marten Transport (ALL States)',
  "Martin's Point Health Care",
  'Maryland Behavioral Health',
  'Maryland Health Partners',
  'Maryland Physicians Care (Baltimore MD) (DOS 7/1/2017 and After)',
  'Mashantucket Pequot Tribal Nation',
  'Masonry Industry Trust',
  'Massachusetts Bay Insurance Company (Auto only)',
  'Massachusetts Bay Insurance Company (WC only)',
  'Massamont Insurance (ALL States)',
  'Master Mates and Pilot Plan',
  'Matrix Absence Management',
  'Matrix Absence Management (Austin, TX)',
  'Matrix Absence Management (Phoenix, AZ)',
  'Matrix Absence Management (Portland, OR)',
  'Matrix Absence Management (WC Only) (ALL States)',
  'Maxim Crane Works (TX, MN) (WC Only)',
  'Maxim Healthcare',
  'MAYO CLINIC (MN, TX) WC ONLY',
  'Mayo Clinic/Recovery and Claims Services (RCS)  (WC Only) (TX/MN/CA/LA Only)',
  'Mayo Clinic/Recovery and Claims Services (WC Only) (TX,MN,CA,LA Only)',
  'Mayo Management Services Inc',
  'MBA Benefit Administrators',
  'MBA of Wyoming',
  "MC DONALD'S-MCOPCO",
  'Mcclure & Associates',
  'McCreary Corporation',
  "McDonald's (Oakland #7681) (WC Only)",
  "McDonald's (San Bernandino #5619)",
  "McDonald's-Mcopco (TX, MN) (WC Only)",
  'McGregor PACE',
  'MCIT (MN, TX) (Auto Only)',
  'McKinley Medical Group',
  'McLaren Advantage (HMO SNP)',
  'McLaren Health Advantage',
  'McLaren Health Plan',
  'McLaren Health Plan Medicaid',
  'MCS Workforce Specialists (MN,TX) (WC Only)',
  'MD Care Health Plan',
  'MD Hawaii',
  'MDWise Hoosier Alliance DOS 12/31/17 and Prior',
  'MDWISE HOOSIER CARE CONNECT (DOS 1/1/17 and After)',
  'MDWISE HOOSIER HEALTHWISE (DOS 1/1/17 And After)',
  'MDWISE SELECT HEALTH NETWORK',
  'Meadowbrook Insurance Auto Only',
  'MEADOWBROOK INSURANCE GROUP  WC ALL STATES',
  'Meadowbrook Insurance Group (WC Only) (All States)',
  'MED PAY',
  'Med-Pay',
  'MED3000 CMS TITLE 19 REFORM',
  'MED3000 CMS TITLE 21',
  'MED3000 HEALTH SELECT IPABCBS',
  'MedAdmin Solutions',
  'MedCom',
  'MEDCORE HEALTH PLAN',
  'MedCost / Liberty Health Share',
  'MedCost Benefits Services',
  'MedCost Preferred (Subrogation Claims Only)',
  'Medfocus',
  'Medi-Pak Advantage',
  'Medica Health Plan - Fee for Service',
  'Medica Healthcare Plans (Florida)',
  'Medica2 IFB Claims Only',
  'Medicaid Alabama',
  'Medicaid Alabama - EDS Federal - Outpatient',
  'Medicaid Alabama - Outpatient',
  'Medicaid Alaska - First Health Services',
  'Medicaid Arizona (AHCCCS)',
  'Medicaid Arkansas',
  'Medicaid Arkansas (Encounters Only)',
  'Medicaid California',
  'Medicaid Colorado',
  'Medicaid Connecticut',
  'Medicaid Delaware - EDS',
  'Medicaid District of Columbia (DC)',
  'Medicaid Florida',
  'Medicaid Georgia',
  'Medicaid Hawaii',
  'Medicaid Idaho',
  'Medicaid Illinois',
  'Medicaid Indiana',
  'Medicaid Iowa',
  'Medicaid Kansas',
  'Medicaid Kentucky',
  'Medicaid Maine',
  'Medicaid Maryland - State Dept of Health and Mental Hygiene',
  'Medicaid Massachusetts',
  'Medicaid Michigan',
  'Medicaid Minnesota',
  'Medicaid Mississippi',
  'Medicaid Missouri',
  'Medicaid Montana',
  'Medicaid Nebraska - HHS of Lincoln, Nebraska',
  'Medicaid Nevada',
  'Medicaid New Hampshire',
  'Medicaid New Jersey',
  'Medicaid New Mexico',
  'Medicaid New York',
  'Medicaid New York Category of Service 0160/0 Institutional',
  'Medicaid New York Category of Service 0160/0287',
  'Medicaid New York Inpatient - Institutional',
  'Medicaid New York Outpatient - Institutional',
  'Medicaid New York Title X1X Institutional',
  'Medicaid North Carolina',
  'Medicaid North Carolina (Carolina Access Only)',
  'Medicaid North Dakota',
  'Medicaid of Colorado (CO)',
  'Medicaid Ohio',
  'Medicaid Oklahoma',
  'Medicaid Oregon',
  'MEDICAID PAPER',
  'Medicaid Pennsylvania',
  'Medicaid Rhode Island - EDS',
  'Medicaid South Carolina',
  'Medicaid South Dakota',
  'Medicaid Utah',
  'Medicaid Utah - Crossover Claims',
  'Medicaid Utah Atypical Providers Only',
  'Medicaid Vermont',
  'Medicaid Virginia',
  'Medicaid West Virginia',
  'Medicaid Wisconsin',
  'Medicaid Wyoming',
  'Medical Associates Health Plans',
  'Medical Benefit Administration, Inc (Grass Valley CA)',
  'Medical Benefits Companies (Newark, OH)',
  'Medical Mutual of Ohio (MMO)',
  'Medical Reimbursements of America,LLC (Franklin TN)',
  'MEDICAL SAFETY NET',
  'Medical Services Initiative',
  'Medicare A - Federally Qualified Health Centers (FQHC) only - not for AZ, MT, ND, SD, UT, WY',
  'Medicare A - RHHI - Home Health Hospice (REGION D, WI, MI, NY, NJ, MN, PR, VI)',
  'Medicare A - West Virginia UGS',
  'Medicare A Alabama',
  'Medicare A Alaska - Premera BC WA/AK',
  'Medicare A Arizona',
  'Medicare A Arkansas - BCBS AR',
  'Medicare A California',
  'Medicare A Colorado - Novitas',
  'Medicare A Connecticut - Empire BCBS NY',
  'Medicare A Delaware',
  'Medicare A Florida - FCSO BCBS FL',
  'Medicare A Georgia',
  'Medicare A Hawaii',
  'Medicare A Idaho',
  'Medicare A Illinois',
  'Medicare A Indiana',
  'Medicare A Iowa -',
  'Medicare A Kansas',
  'Medicare A Kentucky',
  'Medicare A Louisiana -',
  'Medicare A Maryland - CareFirst BCBS MD',
  'Medicare A Massachusetts',
  'Medicare A Michigan',
  'Medicare A Minnesota',
  'Medicare A Mississippi',
  'Medicare A Missouri',
  'Medicare A Nevada',
  'Medicare A New Hampshire',
  'Medicare A New Jersey - BC NJ',
  'Medicare A New Mexico',
  'Medicare A New York - Empire BCBS NY',
  'Medicare A North Carolina - Palmetto',
  'Medicare A Ohio',
  'Medicare A Oklahoma - BC OK',
  'Medicare A Oregon',
  'Medicare A Pennsylvania',
  'Medicare A RHHI - REGION B',
  'Medicare A Rhode Island',
  'Medicare A Tennessee',
  'Medicare A Texas - Novitas',
  'Medicare A Utah',
  'Medicare A Virginia - UGS',
  'Medicare A Washington - Premera BC WA/AK',
  'Medicare A Washington DC - Carefirst BCBS MD',
  'Medicare A Wisconsin - UGS',
  'Medicare A Wyoming',
  'Medicare Advantage (Private)',
  'Medicare Advantage Part A - Medicaid Louisiana (.XXA)',
  'Medicare Advantage Part B - Medicaid Louisiana (.XXB)',
  'Medicare Advantage- MT, OK, TX, IL, NM (BC)',
  'Medicare B Alabama',
  'Medicare B Alaska - Noridian',
  'Medicare B Arizona - Noridian',
  'Medicare B Arkansas',
  'Medicare B California Northern',
  'Medicare B California Southern',
  'Medicare B Colorado',
  'Medicare B Connecticut',
  'Medicare B Delaware',
  'Medicare B District Of Columbia (DC)',
  'Medicare B Florida - First Coast',
  'Medicare B Georgia',
  'Medicare B Hawaii',
  'Medicare B Idaho - NORIDIAN',
  'Medicare B Illinois',
  'Medicare B Indiana',
  'Medicare B Iowa',
  'Medicare B Kansas - WPS',
  'Medicare B Kentucky',
  'Medicare B Louisiana',
  'Medicare B Maine',
  'Medicare B Maryland',
  'Medicare B Massachusetts',
  'Medicare B Michigan - WPS',
  'Medicare B Minnesota',
  'Medicare B Mississippi',
  'Medicare B Missouri',
  'Medicare B Missouri (Johnson & Wyandotte County only)',
  'Medicare B Montana',
  'Medicare B Nebraska',
  'Medicare B Nevada',
  'Medicare B New Hampshire',
  'Medicare B New Jersey',
  'Medicare B New Mexico',
  'Medicare B New York - Empire',
  'Medicare B New York - Group Health Inc',
  'Medicare B New York Upstate',
  'Medicare B North Carolina',
  'Medicare B North Dakota - Noridian (ND)',
  'Medicare B Ohio',
  'Medicare B Oklahoma',
  'Medicare B Oregon - Noridian',
  'Medicare B Pennsylvania',
  'Medicare B Puerto Rico',
  'Medicare B Rhode Island',
  'Medicare B South Carolina - Palmetto GBA (SC)',
  'Medicare B South Dakota - Noridian',
  'Medicare B Tennessee',
  'Medicare B Texas',
  'Medicare B Utah - Regence BCBS UT',
  'Medicare B Vermont',
  'Medicare B Virgin Islands',
  'Medicare B Virginia',
  'Medicare B Washington - Noridian',
  'Medicare B West Virginia - Palmetto GBA (WV)',
  'Medicare B Wisconsin',
  'Medicare B Wyoming - Noridian',
  'Medicare Home Health & Hospice (J14 - NHIC)',
  'Medicare Maine Part A/HH & H (CT, MA, ME, NH, RI, and VT)',
  'Medicare Mucho Mas',
  'Medicare Part A of Puerto Rico',
  'Medicare Plus Blue (Michigan)',
  'Medicare Plus Blue of Michigan Institutional',
  'Medicare RHHI Jurisdiction M and South Carolina Part A',
  'MEDICARE TRUST FOR RETIRED EMPLOYEES-TMT',
  'MediChoice IPA',
  'Medigold Health Plans',
  'Medigold PPO',
  'Medova (Lifestyle Health Plans - Institutional)',
  'MedPartners',
  'MEDPARTNERS ADMIN SERVICES',
  'MEDPARTNERS ADMIN SERVICES (IN)',
  'MEDRISK',
  'MedSolutions Inc',
  'MedStar Family Choice',
  'Medstar Physician Partners',
  'Medstar Select/Medstar Medicare Choice',
  'MedView',
  'Mega Life & Health Insurance Company',
  'Meijer Stores',
  'Member Insurance Agency  Inc.',
  'Member Insurance Agency Inc.',
  'MEMIC Casualty Company',
  'MEMIC Casualty Company (Auto only)',
  'MEMIC Casualty Company (WC only)',
  'MEMIC Indemnity Company',
  'MEMIC Indemnity Company (Auto only)',
  'MEMIC Indemnity Company (WC only)',
  'Memorial Clinical Associates/Select Care of Texas MCA (Houston)',
  'Memorial Healthcare IPA',
  'Memorial Herman Health Network Providers',
  'MEMORIAL HOSPITAL OF GARDENA',
  'MEMORIAL HOSPITAL OF GARDENA (Workers Comp)',
  'Memorial Medical Center',
  'MemorialCare Medical Foundation',
  'MemorialCare Medical Foundation Cap Services',
  'MemorialCare Medical Foundation UCI',
  'MENDOTA INSURANCE COMPANY (MN, TX) AUTO ONLY',
  'Mennonite Mutual Aid',
  'Mennonite Mutual Aid Association and Affiliates (MMA)',
  'Merchants Benefit Administration',
  'Merchants Bldg. Maint. Calif.',
  'Mercy Accountable Care Plan',
  'Mercy Care(AHCCCS)',
  'Mercy Health Plan',
  'Mercy Maricopa Integrated Care',
  'Mercy Provider Network',
  'Meridian Health Plan',
  'Meritage Medical Network',
  'Meritain Health Minneapolis',
  'Meritain Health/Agency Services Inc. ( Amherst NY)',
  "Mervyn's",
  'Metro Council (St. Louis) (ALL) WC ONLY',
  'MetroPlus Health Plan',
  'Metropolitan Council',
  'Metropolitan Council (Auto only)',
  'Metropolitan Council (TX Only) (WC Only)',
  'Metropolitan Council (WC only)',
  'Metropolitan Health Plan',
  'Metropolitan Property and Casualty Insurance Company/Met Life (MN Only) (Auto Only)',
  'Metropolitan Transit Authority of Harris County (TX Only) (WC Only)',
  'Metropolitan Transit System (MTS) (San Diego, CA)',
  'METROWEST HEALTH PLAN PREFERRED',
  'Mettler - Toledo',
  'Mettler - Toledo (Auto)',
  'MHN-Managed Health Network (Richmond CA)',
  'MHNET',
  'MHP Northstar',
  'Michael Reese Physicans Group',
  'Michigan Blue Cross FEP',
  'Michigan Millers Mutual',
  'Mid America Leased PPO Network',
  'Mid Coast Care',
  'Mid-America Associates, Inc',
  'Mid-American Benefits',
  'Mid-American TPA: AAI, Inc. (UCS)',
  'Mid-Valley Behavioral Health Network',
  'Midland Management/MFC',
  'Midland National Life Ins Co (NFIC Plan Only)',
  'Midlands Choice Inc',
  'Midwest Behavioral Health',
  'Midwest Drywall (TX, MN) (WC Only)',
  'Midwest Family Mutual (WC Only)(MN,TX Only)',
  'Midwest Family Mutual Insurance Co',
  'Midwest Group Benefits',
  'Midwest Operating Engineers Welfare Fund',
  'MILITARY DELI & BAKERY (WC Only)',
  'Millard Refrigerated',
  "Miller'S Progressive Care",
  'Mills Peninsula Medical Group (SPS - Sutter)(for claims with DOS on or after 4/1/2014)',
  'Mills Peninsula Medical Group( for claims with DOS prior to 4/1/2014)',
  'Minneapolis Public Schools (Auto Only) (MN Only)',
  'Minnesota Counties Ins Trust (MCIT)',
  'Minnesota Counties Ins Trust (MCIT) (WC Only) (TX Only)',
  'Minnesota Insurance Guaranty Association (MIGA)',
  'Minuteman Health (MA, NH)',
  'Mission Hospital Regional',
  'Mississippi Physicians Care Network',
  'Missoula County Medical Benefits Plan',
  'Missouri Blue Cross - Kansas City, MO',
  'Mitchell Energy & Devel (MN, TX) (WC Only)',
  'Mitsui Sumitomo - (AUTO ONLY)',
  'Mitsui Sumitomo - (WC ONLY)',
  'Mitsui Sumitomo - Toyota ONLY - (WC ONLY)',
  'Mitsui Sumitomo - Toyota ONLY -(AUTO ONLY)',
  'ML Healthcare',
  'MMIC (Auto only)',
  'MMIC (WC only)',
  'MN Dept of Health',
  'MN-Department of Labor (WC ONLY)',
  'MO BLUE CHOICE',
  'Moda Health',
  'Mohawk Packing Co.',
  'Molina Health Care California',
  'Molina Healthcare',
  'Molina Healthcare of CA - Encounters only',
  'Molina Healthcare of Florida',
  'Molina Healthcare of Idaho',
  'Molina Healthcare of Michigan',
  'Molina Healthcare of Nevada',
  'Molina Healthcare of New Mexico',
  'Molina Healthcare of NM',
  'Molina Healthcare of OH',
  'Molina Healthcare of Puerto Rico',
  'Molina Healthcare of Texas',
  'Molina Healthcare of Texas (Commercial Claims only)',
  'Molina Healthcare of Utah',
  'MOLINA HEALTHCARE OF WA ENCOUNTERS ONLY',
  'Molina Healthcare of Washington',
  'Molina Healthcare of Wisconsin',
  'Molina Healthcare South Carolina DOS on or after 1/1/2014',
  'Molina Illinois',
  'Molina SCI',
  'Monarch Healthcare IPA',
  'Mondial Assistance',
  'Monitor Life Insurance',
  'MONROE CO (CA, MN, TX) (WC Only)',
  'Montana Medicare Part A',
  'Montefiore Contract Management Organization',
  'Monterey Bay IPA',
  'Montgomery (WC Only)',
  'Montgomery County Self-Insurance Program (MD) (Auto only)',
  'Montgomery County Self-Insurance Program (MD) (WC only)',
  'Montgomery County Texas (TX, MN,CA Ony) (WC Only)',
  'Montifiore HMO',
  'Monumental Life Insurance Company',
  'Morongo Basin Transit Authority (CA) (Auto only)',
  'Morongo Basin Transit Authority (CA) (WC only)',
  'Morris Associates',
  'Morris Material Handling (TX, MN) (WC Only)',
  'Morrison Health Care, Inc. (TX, MN) (WC Only)',
  'Motion Industries/Hayward',
  'Motion Industries/Oxnard',
  'Mountain Medical Affiliates',
  'Mountain State BCBS',
  'Mountain State FreedomBlue Medicare Advantage',
  'MPE Employee Benefit Services, Inc./MPEEBT',
  'MPM Prospect',
  'Mr Bults Inc (WC Only)',
  'MSA CareGuard',
  'MSI',
  'MSI MSMM-Richardson',
  'Mta Div.10 Transportation/#3210',
  'MTS (Auto only)',
  'MTS (WC only)',
  'MTS Staffing',
  'Multiplan Wisconsin Preferred Provider Network',
  'Multiplan/Basic Plus',
  'Multiquip',
  'Multnomah County Other',
  'Munford, Inc. (TX, MN) (WC Only)',
  'Municipal Health Benefit Fund',
  'Murphy & Bean Insurance',
  'Muskegon Care',
  'Mutual Benefit (Western Life- Fortis)',
  'Mutual of Omaha Medicare',
  'Mutual of Omaha Medicare (CA, NV, HI only)',
  'Mutual of Omaha Medicare (CO, NM, OK, TX only)',
  'Mutual of Omaha Medicare - DE, MD, NJ, PA, DC Only',
  'MVP Health Care',
  'My Choice IPA',
  'My Family Medical Group',
  'MyDecision HealthSmart',
  'MyNexus, Inc.',
  'NAHGA Inc.',
  'NAMCI/Global Care',
  'NAP Tools (TX, MN) (WC Only)',
  'Naphcare',
  'Nassco / General Dynamics',
  'National Allied Workers Union Local 831',
  'National American Insurance Co (NAICO) (Auto only)',
  'National American Insurance Co (NAICO) (WC only)',
  'National Association of Letter Carriers (NALC) (Medicare Primary ONLY)',
  'National Chiropractic Network',
  'National Envelope',
  'National Financial Insurance Company',
  'National Foundation Life Insurance Company',
  'National General',
  'NATIONAL HEALTCHARE CORPORATION ADVANTAGE',
  'National Health Benefit',
  'National Healthcare Exchange Services',
  'National Imaging Associates',
  'National Indemnity Group',
  'National Interstate (MN, TX) [WC, Auto]',
  'National Interstate (WC Only) (TX/MN/CA Only)',
  'NATIONAL INTERSTATE INSURANCE (Auto Only)',
  'NATIONAL LOSS PREVENTION, INC (MN and TX only) WC ONLY',
  'National Rural Electric Coop - DOS Prior to 1/1/2014 (NRECA)',
  'National Vision',
  'Nationwide Insurance-Gainesville (MN,TX) (Auto Only)',
  'Nationwide Insurance-Gainesville (MN,TX) (WC Only)',
  'Nationwide Mutual Insurance Company (TX,MN,CA and LA only)',
  'Nationwide/Allied (Auto Only) (MN Only)',
  'Native Care Health',
  'NBC Universal (WC Only)',
  'NBSIA-North Bay Schools Insurance Authority',
  'NC Department of Public Instruction',
  'NCLM - North Carolina League of Municipalities',
  'Nebraska Medicare Part A',
  'Neighborhood Health Partnership',
  'Neighborhood Health Partnership of Florida',
  'Neighborhood Health Plan (Boston, MA)',
  'Neighborhood Health Plan of Rhode Island',
  'Neighborhood Health Plan RI - Exchange, Unity, Integrity',
  'Nephrology Associates Medical Group',
  'Nestle USA (Auto Only) (TX,MN Only)',
  'Nestle Waters North America (Auto Only) (TX,MN Only)',
  'Netcare Life & Health Insurance',
  'Network Health Insurance Corp-Medicare',
  'Network Medical Management',
  'Network solutions IPA',
  'Nevada Preferred-GEHA',
  'NevadaCare',
  'NEW CENTURY HEALTH CAC CENTERS',
  'New Directions Behavioral Health UB',
  'New Era Life',
  'New Jersey Manufacturing (WC Only) (All States)',
  'New Jersey Manufacturing - Auto Only',
  'New Koosharem Corporation/Select Staffing (After 7/31/2014) (Auto only)',
  'New Koosharem Corporation/Select Staffing (After 7/31/2014) (WC only)',
  'New Mexico Health Connections',
  'New Mexico Public Schools Insurance Authority',
  'New Mexico Retiree Health Care Authority',
  'New West Health Plan',
  'New world Claims Services (Niles MI)',
  'New York Life Long Term Care',
  'New York Medical Imaging (NYMI) - AETNA Radiology Claims',
  'New York Medical Imaging (NYMI) Oxford',
  'New York Network Management',
  'New York State Insurance (NY Only) (WC Only)',
  'NewPage Corporation',
  'Next Level Health',
  'NGS American Inc',
  'NHI BILLING SERVICES, INC',
  'NIA - Magellan Health Services',
  'Nippon Life Insurance Company of America',
  'Non-Emergency Transportation [.NAM] - Medicaid Louisiana',
  'Nonprofit Insurance Trust',
  'Nonprofit Insurance Trust (Auto Only)',
  'Nonprofit Insurance Trust (WC Only)',
  'Nordstrom Regional Office',
  'Nordstrom, Inc. (WC Only)',
  'Norfolk Public Schools (VA)',
  'North American Medical Mgmt (Northern CA)',
  'North Carolina Department of Public Safety',
  'North Dakota Medicare Part A',
  'North Dakota Workforce Safety',
  'North Iowa Community Healthcare (NICH)',
  'North River Insurance Company (WC Only) (TX/MN/CA/LA Only)',
  'North Shore - LIJ',
  'North Shore - LIJ CareConnect Insurance Company, Inc.',
  'North Star Mutual Insurance Company',
  'North Texas Healthcare Network',
  'NorthCoast(Hospice and Home Health Claims Only)',
  'Northeast Georgia Health Services',
  'Northern CA Sheet Metal Workers Health Care Plan',
  'Northern California Advantage Medical Group',
  'Northern Claims Management',
  'Northern Health Plan',
  'Northern Illinois Health Plan (Freeport, IL)',
  'Northern Kentucky University (Auto only)',
  'Northern Kentucky University (WC only)',
  'Northern Nevada Trust Fund',
  'Northland Auto (Auto Only) (TX,MN,CA Only)',
  'Northridge Medical Group',
  'NORTHROP GRUMMAN (MCCLELLAN) (WC Only)',
  'NorthShore Physician Associates',
  'Northwest Diagnostic Clinic',
  'Northwest Insurance (Auto Only)',
  'Northwest Insurance (WC Only)',
  'Northwest National Life',
  "Northwest Physician's Network",
  'Northwest Suburban IPA (Illinois)',
  'Northwestern University (WC Only)',
  'Northwood',
  'Northwood, Inc. - BCN Michigan',
  'Northwood, Inc. - BMC Healthnet',
  'Northwood, Inc. - Security Health Plan DME',
  'Norwood (MN and TX only) (WC Only)',
  'Nova Healthcare Administrators Inc. (Grand Island, NY)',
  'Nova Pro Risk Solutions',
  'NOVA PRO RISK SOLUTIONS (CA,MN,TX) (Auto Only)',
  'NOVA PRO RISK SOLUTIONS (CA,MN,TX) (WC Only)',
  'NOVA PRO RISK SOLUTIONS (SAN DIEGO) (MN and TX only)(WC Only)',
  'Novanet',
  'NovaSys Health Network ( Little Rock, AR)',
  'NSLIJ Queens WTCHP',
  'NTCA',
  'NTCA Staff Members',
  'NX Health Network',
  'Nyhart',
  'NYSIF (NY Only) (WC Only)',
  "O'Reilly Auto Parts",
  "O'Reilly Auto Parts (Auto only)",
  "O'Reilly Auto Parts (WC only)",
  'Oak Hill Associates',
  'OAK STREET HEALTH',
  'Oak West Physician Association (DOS AFTER 6/01/2015)',
  'OCCUPATIONAL EYEWEAR NETWORK INC',
  'Ocular Benefits',
  'Ogden Benefits Administration',
  'Ohio AFSCME Care Plan',
  'Ohio BCMH (Bureau for Children with Medical Handicaps)',
  'Ohio Casualty Group (TX, MN Only) (WC Only)',
  'Ohio Casualty Group (WC Only) (TX,MN Only)',
  'OHIO CASUALTY INS-CINCINNATI (WC Only)',
  'Ohio Department of Aging',
  'OHIO FARMERS CORVEL',
  'Ohio Farmers Insurance Company - National',
  'Ohio Health Choice PPO',
  'Ohio PPO Connect',
  'OICW (WC Only)',
  'Oklahoma DRS Doc (DOS on or after 01/01/18)',
  'Old Republic Insurance Co (MN and TX only)(WC Only)',
  'Old Republic Insurance Company (Auto Only)',
  'OLD REPUBLIC INSURANCE COMPANY (MN, TX) (WC Only)',
  'Olympus Managed Health Care',
  'Omni-Trans',
  'OMNI/Medicore HP',
  'Omnicare Medical Group',
  'ON LOK SENIOR HEALTH SERVICES',
  'One Beacon (ALL) [WC, Auto]',
  'One Beacon (MN/TX/CAonly) (WC Only)',
  'One beacon Insurance (TX, MN, CA, TX) AUTO ONLY',
  'One Beacon Insurance - Auto (TX only) Auto Only',
  'One Call Diagnostics',
  'One Call Equipment and Devices',
  'One Call Physical Therapy',
  'ONE HOMECARE SOLUTIONS',
  'Operating Engineers Local 139 Health Benefit Fund',
  'OptaComp (WC Only) (All States)',
  'OptiCare Eye Health Network',
  'Opticare of Utah',
  'Optimum Choice of the Carolinas Inc (OCCI)',
  'Optimum Healthcare',
  'OptumHealth',
  'OPTUMHEALTH SALT LAKE COUNTY',
  'Oregon Health Management Services',
  'Orica, Inc. (MN and TX only)(WC Only)',
  'Orthonet',
  'OrthoNet Uniformed Services Family Health Plan',
  'Oscar Health',
  'Oscar Health (California and Texas)',
  'Oscar Health Plan Of New York',
  'OSI Group, LLC (Auto only)',
  'OSU Sooner Care',
  'OUR LADY OF THE LAKE REGIONAL MEDICAL CENTER(OLOLRMC)',
  "Owner Operator Services, Inc./McDonald's",
  'Oxnard Family Circle Adhc',
  'P.H.C.S. (MN ,TX) (WC Only)',
  'P2P: AAA MINNESOTA & IOWA (WORK COMP)',
  'P2P: ALIGN NETWORKS - (WORKERS COMP)',
  'P2P: ALLIANZ (WORK COMP)',
  'P2P: American Mining Ins Group - WC',
  'P2P: AMERICAN MOTORISTS INS CO - WC',
  'P2P: AMERIPRISE AUTO & HOME INS - WC',
  'P2P: AMERISAFE (WORKERS COMP)',
  'P2P: Anoka Hennepin-ISD 11 (Work Comp)',
  'P2P: AUTO-OWNERS INSURANCE CO - WC',
  'P2P: BRISTOL WEST (WORK COMP)',
  'P2P: BROADSPIRE (AUTO & P&C BILLS) - WC',
  'P2P: CAMBRIDGE INT SRV GRP (WORK COMP)',
  'P2P: CHURCH MUTUAL INS CO (WORK COMP)',
  'P2P: CONTRACOSTA CNTY SCHOOLS INS GROUP',
  'P2P: CONTRACOSTA RSK MGMT (WORKERS COMP)',
  'P2P: CONTRACOSTA WATER DISTRICT WC',
  'P2P: COTTINGHAM AND BUTLER (WORK COMP)',
  'P2P: Country Financial Mod Svc Corvel-WC',
  'P2P: DEPT OF ENERGY (WORKERS COMP)',
  'P2P: EMPLOYERS ASSURANCE COMP WORK COMP',
  'P2P: EMPLOYERS COMPENSATION INS CO - WC',
  'P2P: ESIS (Lockheed Martin Corp) - WC',
  'P2P: Esurance Insurance Co (Work Comp)',
  'P2P: FCCI (Workers Comp)',
  'P2P: FIRSTCOMP (WORKERS COMP)',
  'P2P: GRANGE MUTUAL CASUALTY (WC)',
  'P2P: GRINNELL REINSURANCE (WORK COMP)',
  'P2P: Hartford Accident & Indemnity - WC',
  'P2P: Ingles Markets (Workers Comp)',
  'P2P: iSurity (Workers Comp)',
  'P2P: KEMPER PREFERRED (WORK COMP)',
  'P2P: LIBERTY MUTUAL (WORKERS COMP)',
  'P2P: Macys (EK Health) - WC',
  'P2P: MACYS CORPORATE SERVICES INC - WC',
  'P2P: MARRIOTT CLAIMS SERVICES CORP - WC',
  'P2P: MEDRISK (WORKERS COMP)',
  'P2P: Mendota Insurance Company - WC',
  'P2P: Metropolitan Property & Casualty-WC',
  'P2P: Minnesota Nonprofits Employers (WC)',
  'P2P: NATIONAL INTERSTATE (WORK COMP)',
  'P2P: NATIONWIDE MUTUAL AUTO (WORK COMP)',
  'P2P: NORDSTROM INC (WORKERS COMP)',
  'P2P: PAPER OVERFLOW (WC & AUTO)',
  'P2P: Republic Indemnity Co of America-WC',
  'P2P: ROCKWOOD CASUALTY INSURANCE - WC',
  'P2P: RYDER SERVICES (WORKERS COMP)',
  'P2P: SAFECO INSURANCE AUTO (WORK COMP)',
  'P2P: Sedgwick Dignity Health (Work Comp)',
  'P2P: SENTRY INS A MUTUAL CO (WORK COMP)',
  'P2P: SENTRY INSURANCE (WORKERS COMP)',
  'P2P: SOCIETY INSURANCE (WORK COMP)',
  'P2P: SUMMIT HOLDINGS (WORKERS COMP)',
  'P2P: Technology Insurance Co - WC',
  'P2P: The General Insurance (Work Comp)',
  'P2P: TOWER GROUP INC - (WORKERS COMP)',
  'P2P: USC CBS COMPANIES (WKRS COMP)',
  'P2P: USC CHESTERFIELD SRVS (WKRS COMP)',
  'P2P: USC CRAWFORD (WORKERS COMP)',
  'P2P: USC SECURA INS (WORKERS COMP)',
  'P2P: USC WALMART (WORKERS COMP)',
  'P2P: Western National Assurance (WC)',
  'P2P: ZURICH (67101) (WORKERS COMP)',
  'P5 Health Plan of UT',
  'PACE Central Iowa',
  'PACE CNY',
  'PACE Greater New Orleans',
  'PACE Nebraska',
  'PACE of Southwest Michigan, Inc',
  'PACE Southeast Michigan',
  'PACE SouthWest Iowa',
  'Pacific Alliance/Western Alliance',
  'Pacific Coast Building Products',
  'Pacific Compensation Insurance Company',
  'Pacific Compensation Insurance Company (WC Only) (All States)',
  'Pacific Dental Services',
  'Pacific Gas & Electric - 115',
  'Pacific Healthcare IPA',
  'Pacific IPA',
  'Pacific Lumber Company- PALCO',
  'Pacific Motor Company',
  'Pacific Southwest Administrators',
  'Pacific Sunwear',
  'PacifiCare of Oregon - Encounters',
  'PacificSource Community Solutions',
  'PacificSource Health Plans',
  'PacificSource Medicare',
  'PAI California Secondary',
  'Paladin Managed Care Services, Inc.',
  'Palladian Muscular Skeletal Health',
  'Palo Alto Medical Foundation',
  'Palomar Enterprises, Inc.',
  'Pama Management',
  'PANAMERICAN PALIC PUERTO RICO',
  "Papa John's International Inc (MN and TX only) (WC Only)",
  'PAPER CLAIM - VERSION (02/12)',
  'Paper Claims for Anesthesia Minutes',
  'PAPER WITH ELEC ATTACHMENTS (Auto Only)',
  'PAPER WITH ELEC ATTACHMENTS (WC Only)',
  'Paradigm (WC Only) (TX,CA Only)',
  'Paradigm (WC) ONLY TX & CA ONLY',
  'Paragon Benefits',
  'Paramount Health',
  'Park District Risk Management Association (PDRMA)',
  'Parkland Community Health Plan',
  'Parsec',
  'PARTNERS IN HEALTH',
  'Partnership Health Plan of California',
  'Passport Advantage',
  'Passport Health Plan',
  'PATH Administrators',
  'Patient Advocates',
  'PATIENTPAY',
  'Patriot General Insurance Company (ALL) WC ONLY',
  'Patton State Hospital',
  'Pavers & Road Builders Welfare Fund',
  'PayerFusion Holdings, LLC',
  'PayerPro Solutions',
  'PayNet Inc',
  'Pcl Construction',
  'PCSHF',
  'Pdm Steel Service Centers',
  'PDRMA',
  'PDRMA LIB',
  'Peak Pace Solutions',
  'Peak Property & Casualty Ins Co. (Auto Only)',
  'Pediatric Services Holding Corp - Psa Healthcare (Auto only)',
  'Pediatric Services Holding Corp - Psa Healthcare (WC only)',
  'Peerless (WC Only)',
  'PEF Ltd',
  'PEG DISCOVER RE (MN and TX only)(WC Only)',
  'PEG DISCOVER RE(FOOOD MERCHANT) (MN and TX only)',
  'Pegasus Risk Management CA',
  'Pegi-Family Dining (MN and TX only)(WC Only)',
  'PEHP (Public Employees Health Program)',
  'Pekin Insurance',
  'Penn Behavioral Health',
  'Penn Millers Insurance Co (Auto only)',
  'Penn Millers Insurance Co (WC only)',
  'PENNSYLVANIA BLUE CROSS CENTRAL',
  'Pennsylvania Manufacturing Associates (WC Only) (All States)',
  'Pennsylvania Pace',
  'People 2.0',
  "People's Health Network",
  'PEPSI BEVERAGES COMPANY (MN, TX) AUTO ONLY',
  'Perfect Health Insurance Co.',
  'Performance Contracting Inc',
  'Performance Temps',
  'Perry Color Card',
  'Personal Insurance Administrators,  Inc. (Agoura Hills, CA)',
  'PetSmart Inc. (Auto Only) (TX,MN Only)',
  'PG&E Safety Health & Claims',
  'Pharmacist Mutual',
  'Pharmacist Mutual Insurance Company',
  'Pharmacist Mutual Insurance Company (WC Only)',
  'PHARMACISTS MUTUAL INS CO  (Auto Only)',
  'PHARMACISTS MUTUAL INS CO  (WC Only)',
  'PHCS Maxor Administrative Services',
  'PHH Fleetamerica (MN and TX only)(WC Only)',
  'PHIFER WIRE PRODUCTS INCORPORATED',
  'Philadelphia Hardware',
  'Phoenix Health Plan',
  'Phoenix Health Plan (Medicare)',
  'PHP TPA Services',
  'Physicans of Southwest Washington',
  'Physician Associates',
  'Physician Associates of Greater San Gabriel Valley (CA)',
  'Physician Health Plan of Mid Michigan',
  'Physician Management Group',
  'PHYSICIANS ACCOUNTABLE CARE ORGANIZATION',
  'Physicians Care Network (Rockford, IL only)',
  'Physicians Care Network / The Polyclinic',
  'Physicians Choice Medical Group of San Luis Obispo',
  'Physicians Health Association of Illinois',
  'Physicians Health Choice',
  'Physicians Health Network (PHN)',
  'Physicians Health Plan (PHP)',
  'Physicians Health Plan (SC)',
  'Physicians Health Plan of Northern Indiana (PHP)',
  'Physicians Health Plan PHP (Missouri Greater St Louis)',
  'Physicians Health Plan PHP (North Carolina)',
  'Physicians Medical Group of San Jose',
  'Physicians Medical Group of Santa Cruz (DOS 1/1/19 and After)',
  'Physicians Medical Group of Santa Cruz (DOS 12/31/18 and Prior)',
  'Physicians Mutual Insurance Company',
  'Physicians Plus Insurance Corporation',
  'Physicians United Plan',
  "Physicians' Healthways IPA",
  'Physicians, Pediatric Day Healthcare [.PHY] - Medicaid Louisiana',
  'Pier 1 Inc. USA (WC Only)',
  'Pinnacle Medical Group',
  'PINNACLE PHYSICIAN MANAGEMENT ORGANIZATION',
  'Pinnacol Assurance',
  'Pioneer Provider Network',
  'Pioneer Provider Network Medi-cal by MedPOINT',
  'Pipefitters 597',
  'PLAN DE SALUD MENONITA',
  'Planned Administrators',
  'Planned Administrators Inc of South Carolina',
  "Plasterers' & Cement Masons' Health & Welfare Fund",
  'PMA Insurance Group & PMA Management Corp (MN, TX) WC ONLY (MedRisk contracted providers ONLY)',
  'Polaris (MN ONLY) AUTO ONLY',
  'Polaris (MN ONLY) WC ONLY',
  'Poma Distribution',
  'POMCO',
  'Port of Oakland (CA) (Auto only)',
  'Port of Oakland (CA) (WC only)',
  'Portillos',
  'Ports America (National)',
  'Pozzi Hill, Inc.',
  'PPO One',
  'Prairie States Enterprises, Inc',
  'Praxair Inc. #260/Santa Ana',
  'Preferred Administrators',
  "PREFERRED ADMINISTRATORS - CHILDREN'S HOSPITAL",
  'Preferred Blue',
  'Preferred Blue South Carolina',
  'Preferred Care Partners (FL)',
  'Preferred Community Choice (OK)',
  'Preferred Community Choice/PCC Select/CompMed',
  'Preferred Employers (MN & TX) (WC Only)',
  'Preferred Employers Group (MN & TX) (WC Only)',
  'Preferred Employers Group (MN, TX) [WC, Auto]',
  'Preferred Employers Insurance Co.',
  'Preferred Employers Insurance Company (PEI)',
  'Preferred Health (PHP Kansas City)',
  'Preferred Health Plan (Louisville, KY)',
  'Preferred Health Plan of the Carolinas',
  'Preferred IPA',
  'Preferred Medical',
  'Preferred Medical Plan',
  'Preferred Medicare Choice',
  'Preferred Network Access',
  'Preferred One (CT), a Division of First Choice',
  'Preferred Personnel/Ranchocucamonga',
  'PreferredOne (MN)',
  'Premier Benefits Inc',
  'Premier Care IPA (ProCare MSO)',
  'Premier Eye Care',
  'Premier Health Plan',
  'Premier Health Systems, Inc (DOS prior to 04/01/2009)',
  'Premier HealthCare Exchange',
  'Premier Healthcare Exchange, Inc. (PHX)',
  'Premier Physician Network',
  'Premier Workcomp',
  'Presbyterian Health Plan',
  'Presbyterian Homes And Services (MN, TX) [WC ONLY]',
  'Presbyterian Salud(NM)',
  'Presence ERC',
  'Prestige Health Choice',
  'Primary Care Associates of California',
  'PRIMARY CARE OF JOLIET',
  'Primary Health Network',
  'Primary Provider Management Encounters',
  'Prime Community Care Central Valley',
  'PRIME HEALTHCARE',
  'Prime Source Floral',
  'Prime West Health Plan',
  'PrimeSource Health Network',
  'PrimeTime Health Plan (HMO Medicare)',
  'Primex Clinical Lab',
  "Prince George's County Government (MD) (Auto only)",
  "Prince George's County Government (MD) (WC only)",
  'PRINCETON PREMIER IPA',
  'Principal Financial Group',
  'Priority Health',
  'Prism Network, Inc.',
  'Prism-Univera, West Seneca, New York',
  'Priya Test',
  'PRN LINK-MLK',
  'Pro-Claim Plus Inc',
  'ProCare Health Plan Medicaid',
  'Productive Programming, Inc. (PPI)',
  'Professional Claims Management',
  'Professional Claims Service/Tpa (ALL) [WC, Auto]',
  'PROFESSIONAL DIAGNOSTICS MGMT. (WC Only)',
  'Professional Insurance Managers',
  'Progressive (MN ONLY)',
  'Progressive Casualty Insurance Company (Auto Only) (MN Only)',
  'Progressive Classic Insurance Company (MN Only)',
  'Progressive Commercial Casualty Company (MN ONLY)',
  'Progressive Direct Insurance Company',
  'PROGRESSIVE DIRECT INSURANCE COMPANY (MN Only) (AUTO Only)',
  'Progressive Max Insurance Company',
  'Progressive Max Insurance Company (Auto Only) (MN Only)',
  'Progressive Northern Insurance Company',
  'Progressive Northern Insurance Company (Auto Only) (MN Only)',
  'Progressive Northwestern Insurance Company',
  'Progressive Preferred Insurance Company',
  'Progressive Premier Insurance Company (Auto Only) (MN Only)',
  'Progressive Specialty Insurance Company',
  'Prominence Health Plan',
  'Prominence Health Plan of Nevada (Medicaid)',
  'Prominence Health Plan of Texas (Medicaid)',
  'PROSSAM (Asociacin de Maestros de PR)',
  'Protective Insurance Co (Auto only)',
  'Protective Insurance Co (WC only)',
  'PROTECTIVE LIFE INSURANCE COMPANY',
  'Providence Choice Option',
  'Providence Facility Claims',
  'Providence Health Plan',
  'Providence Health Services (WC) (TX, MN & CA only)',
  'Providence Insurance and Admin Service',
  'Providence Preferred',
  'Providence Preferred (PPO ,Select, Vantage, Vantage Select)',
  'Providence Preferred of Oregon',
  'Providence Property and Casualty',
  'ProviDRs Care Network',
  'Prudent Medical Group',
  'Prudential',
  'PRUDENTIAL OVERALL/IRVINE-ASTON (WC Only)',
  'Prudential Overall/Milpitas',
  'PSKW',
  'PSN - Florida Medicaid',
  'Puerto Rico Cruz Azul',
  'QBE - General Casualty - Eden Prairie (WC Only) (MN, TX, CA, LA Only)',
  'QBE - General Casualty - Farmers Union (TX. MN, CA, LA)',
  'QBE - General Casualty - Indianapolis (CA, LA, MN, TX)',
  'QBE - General Casualty - Simsbury (MN,CA, LA, TX)',
  'QBE - General Casualty - Sun Prairie (MN,CA, LA, TX)',
  'QBE - General Casualty - West Des Moines (MN,CA, LA, TX)',
  'QBE - General Casualty Co of Wisconsin (MN, TX, LA, CA)',
  'QBE - General Casualty Freeport (TX, MN, CA, LA)',
  'Quad City Community Healthcare (QCCH)',
  'Qual Choice of Arkansas',
  'QualCare (CA)',
  'QualCare, Inc. (dba QANI Administrators) A Cigna Company',
  'Qualchoice of Ohio',
  'Quality Care Partners',
  'QUALITY HEALTH PLANS OF NEW YORK',
  'Quality Plan Administrators, Inc.',
  'QuantumCare (We Care Health Plan)',
  'Quartz ASO',
  'QUESTCARE MEDICAL - USC',
  'QuikTrip Corporation',
  'Quincy Health Care Management Inc',
  'QVI Risk Solutions Inc (Bend OR)',
  'Radys Childrens Specialists of San Diego',
  'Railroad Medicare',
  "Raley's Family of Fine Stores",
  "Raley's Family of Fine Stores (Auto only)",
  "Raley's Family of Fine Stores (WC only)",
  'ralph lauren',
  'Ram Mutual Insurance Company (Auto Only)',
  'RAM MUTUAL INSURANCE COMPANY (AUTO) (TX,MN ONLY)',
  'Ram Mutual Insurance Company (WC Only)',
  'RAM MUTUAL INSURANCE COMPANY (WC) (TX,MN ONLY)',
  'Ramirez Farm Labor Contractor',
  'Rampart Insurance Company (MN & TX Only)(WC Only)',
  'Ramsey County',
  'Ramsey County (MN) (Auto Only)',
  'Ramsey County (MN) (WC Only)',
  'Rancho Santiago Community College District (CA) (Auto only)',
  'Rancho Santiago Community College District (CA) (WC only)',
  'Ravenswood Physician Associates',
  'Recology (Auto only)',
  'Recology (WC only)',
  'Red Oak Independent School District (MN,TX,CA Only) (WC Only)',
  'Redlands IPA (Synermed)',
  'Redlands-Yucaipa Medical Group',
  'REDWOOD COMMUNITY HEALTH COALITION',
  'Redwood Fire & Casualty',
  'Regal Medical Group',
  'REGENCE BLUECROSS BLUESHIELD (BCBS) OF OREGON',
  'Regence Group Administrators',
  'Regency Employee Benefits (Port Huron MI)',
  'Regis Brands',
  'Rehabilitation [.REH] - Medicaid Louisiana',
  'Rehn and Associates (Kanai Penisula Borough & School District)',
  'Renaissance Physicians Organization',
  'Republic Franklin Insurance (WC Only) (TX/MN/CA/LA Only)',
  'Republic Indemnity Company of America',
  'Republic Indemnity Company of America (WC Only)',
  'Republic Western Ins. Co (Auto only)',
  'Republic Western Ins. Co (WC only)',
  'Rescare, Inc. (WC Only)',
  'Reserve National Insurance',
  'Residential Services Group (MN & TX ) (WC Only)',
  'Resolute Forest Products (Auto only)',
  'Resolute Forest Products (WC only)',
  'RESOURCE STAFFING GROUP (MN,TX) (WC Only)',
  'Restaurant Reinsurance Limited (MN & TX) (WC Only)',
  'RESURRECTION PHYSICIAN PROVIDERS GROUP',
  'RETURN TO WORK (RTW)',
  'Return to Work (RTW) (MN Only) (WC Only)',
  'REVCLAIMS',
  'RHHI/Home Health/Hospice/Free Standing ESRD (AK,CA,HI,NV,OR,WA,ID,AZ)',
  'Rhode Island (RI) Blue Chip',
  'Rhone-Poulenc, Inc. (MN & TX) (WC Only)',
  'Richardson ISD (Tristar Risk Management)',
  'Richmond Township (Auto Only)',
  'Richmond Township (WC Only)',
  'Rieth-Riley Construction Compa (MN & TX only) (WC Only)',
  'Right Care from Scott & White',
  'Risk Administration Services',
  'Risk Transfer Technologies, Inc. (MN & TX) (WC Only)',
  'River City Medical Group',
  'Riverport Insurance (MN School Board Association)',
  'Riverport Insurance Company (WC Only) (MN, TX & LA)',
  'Riverside Advantage',
  'Riverside County Sheriff Admin.',
  'Riverside Family Health Medical Grp',
  'Riverside Medical Clinic',
  'RMSCO, INC.',
  'Road Carriers W&P Funds - Local 707 (NY) (ALL) [WC, Auto]',
  'Robert Half International Inc. (MN, TX) [WC, Auto]',
  'Rochester Midland Corp (ALL) [WC, Auto]',
  'Rockford Mutual Insurance Company (WC Only) (IL/WI Only)',
  'Rocky Mountain HMO',
  'Roofing Supply',
  'Rooney Life Inc (Golden Rule)',
  'Rooney Life Inc (Golden Rule) (Subrogation Claims Only)',
  'Roth Staffing Companies (MN & TX) (WC Only)',
  'Royal Healthcare on Behalf of Extended Care MTC(for INST claims with DOS prior to 12/1/13 use payer',
  'RSC Insurance Services, Ltd.  (MN & TX) (WC Only)',
  'Rsi Roofing',
  'Rural Health Medicare -  not for AZ, ND, SD, UT, WY',
  'Rural Insurance  (WC Only)',
  'Rural Insurance (Auto Only)',
  'Rural Mutual Ins Co. (WC Only)',
  'Rush Prudential Health Plans (HMO Only)',
  'Ryder Services',
  'Ryder Services, Inc. (MN & TX) (WC Only)',
  'Ryder Services, Inc. (WC Only) (TX,MN Only)',
  'S & S Healthcare Strategies TPA',
  'SA Recycling, LLC (Auto only)',
  'SA Recycling, LLC (WC only)',
  'SafeCo Insurance (WC Only) (All States)',
  'Safeco Insurance - AUTO ONLY',
  'SAFECO INSURANCE COMPANY OF AMERICA (AUTO Only)',
  'Safelite Auto Glass',
  'Safety-Kleen Corporation (MN & TX) (WC Only)',
  'Sagamore Health Network',
  'Sage Technologies',
  'Saint Anthony PHO',
  'Saint Johns Health Clinic',
  'Saint Joseph PACE of IN',
  'Salvation Army (San Bernandino, CA)',
  'Salvation Army (Stocton, CA)',
  'Samaritan Advantage',
  'Samaritan Choice Plans',
  'SAMBA/Special Agents Mutual Benefit Association',
  'San Bernardino City Unified School',
  'San Bernardino Risk Management',
  'San Diego Community College District (CA) (Auto only)',
  'San Diego Community College District (CA) (WC only)',
  'San Diego County Medical Services (CMS)',
  'SAN DIEGO COUNTY RYAN WHITE CARE ACT',
  'San Diego County Sheriffs Department',
  'San Diego PACE',
  'San Diego Physicians Group (Not for Arch)',
  'San Francisco Health Plan',
  'San Jose Medical Group',
  'Sandhills Center Behavioral Health',
  'Sanford Health Plan',
  'Santa Barbara Cottage Hospl/Cottage Hosp/CHS Claim',
  'Santa Barbara Regional Health Authority',
  'Santa Barbara Select IPA Medical Group',
  'Santa Clara County IPA Anthem Blue Cross PPO Claims',
  'Santa Clara Valley Tansportation Authority',
  'SANTE COMMUNITY PHYSICIANS',
  'SANTE COMMUNITY PHYSICIANS MEDICAL GROUP',
  'Sante Health System and Affiliates',
  'SATELLITE HEALTH PLAN',
  'Sbm Site Services, Llc',
  'SCAN ENCOUNTERS',
  'SCAN Health Plan',
  'Scan Health Plan - California',
  'Scan Health Plan Arizona DOS prior to 05/01/13',
  'Schertz/Cibolo/Universal City ISD (WC Only) (TX Only)',
  'Schlumberger Technology',
  'Schlumberger Technology (MN & TX) (WC Only)',
  'Schnuck Market, Inc',
  'SCHS Alta Pod by MedPOINT',
  'SCIF (STATE COMPENSATION INSURANCE FUND) (MN,TX) (WC Only)',
  'SCIF AZ',
  'Scott & White',
  'SCOTTS MIRACLE-GRO COMPANY (MN & TX) (WC Only)',
  'Scottsdale Insurance - National Casualty WC - TX/MN Only',
  'Scottsdale/Colonial (MN,TX ONLY) (Auto Only)',
  'SCRIPPS HEALTH PLAN MSO',
  'SCRIPPS HEALTH PLAN SERVICES',
  'SCRMA - Southern CA Risk Management Associates (Morgan H',
  'SCRMA - Southern CA Risk Management Associates (Riverside',
  'Seabright (SBIC) (WC Only) (TX/MN/CA Only)',
  'SEABRIGHT/TOTAL HEALTH MANAGER  (WC Only)',
  'Sears Logistics Service (ALL) [WC, Auto]',
  'Seaside Health Plan',
  'Seaview IPA',
  'SEBRH BTMG',
  'SEBRH Non Sutter Groups',
  'SECURA Insurance A Mutual Company (WC ONLY)',
  'Secure Health Plans of Georgia',
  'Securitas/San Mateo #08020',
  'Security Health Plan',
  'SECURITY INSURANCE COMPANY OF HARTFORD (AUTO Only)',
  'SEDGWICK CMS',
  'SeeChange Health Insurance',
  'Seedorff Masonry (Auto Only)',
  'Seedorff Masonry (WC Only)',
  'Select Administrative Services',
  'Select Benefit  Administrators (Des Moines, Iowa)',
  'Select Benefit Administrators, Inc.',
  'Select Benefits Administrators (aka PacificSource Administrators)',
  'Select Benefits Administrators of America (Ashland WI)',
  'Select Energy Services',
  'Select Health of South Carolina',
  'Select Staffing (Koosharem, Real Time Staffing, Remedy, Select/Remedy & Westaff (WC Only)(All States',
  'Selectcare',
  'SelectCare of Texas (HPN) Heritage Physicians Network',
  'SelectHealth of Utah',
  'Selective (MN Only) (WC Only)',
  'SELECTIVE INSURANCE (MN, TX) (WC Only)',
  'Self Ins. Schools Of Calif.',
  'Self Insured Benefit Administrators (Clearwater, FL)',
  'Self Insured Plans (Naples, FL)',
  'Self Insured Services Company (SISCO)',
  'Selman Tricare Supp',
  'Sempra Energy/Employee Care Services',
  'Sendero Health with DOS 1/1/17 and After',
  'Sendero STAR/CHIP (DOS 9/1/2017 and After)',
  'Senior Blue of PA (Medicare HMO)',
  'Senior Care Partners',
  'SENIOR WHOLE HEALTH',
  'Sentara Health Management',
  'Sentara Mental Health',
  'Sentinel Management Services',
  'Sentry Auto (Auto Only) (TX/MN/CA Only)',
  'SENTRY AUTO (AUTO ONLY) MN, TX & CA',
  'Sentry Insurance (WC Only)',
  'SENTRY INSURANCE (WC ONLY) TX,MN, & CA ONLY',
  'SENTRY INSURANCE MUTUAL (AUTO Only)',
  'Sentry Select Insurance Company',
  'Seoul Medical Group (CA)',
  'Sequoia Health IPA',
  'Service Lloyds Insurance Co (Auto only)',
  'Service Lloyds Insurance Co (WC only)',
  'Seton Employee Plan',
  'Seton Employee Plan DOS Prior to 1/1/2014',
  'SETON HEALTH PLAN',
  'Seton Medical Assistance',
  "SFN Group (Spherion, Technisource, Tatum, The Mergis Group, SourceRight Solutions, & Today's Office",
  'Share Health Plan - ILL/HMO',
  'Share Health Plan - ILL/PPO',
  'Sharp Community Medical Group',
  'Sharp Health Plan (DOS 1/1/18 and AFTER)',
  'Sharp Healthplan',
  'Sharp Rees-Stealy Medical Group',
  'Shasta Administrative Services',
  'Shaws/StarMarket',
  'Sheakley UNICOMP',
  'Sieba LTD',
  'Sierra Health Services Inc. Encounters Only',
  'Sierra Nevada Medical Assoc.',
  'Silver Cross Managed Care Organization',
  'Silver Star Pace',
  'Simply Healthcare',
  'Simply Staffing/All So.Ca.',
  'SIMPRA Advantage',
  'Sinclair Health Plan',
  'SISCO',
  'SISCO (MN,TX) (WC Only)',
  'Sisco/Self Insured Services',
  'Skilled Healthcare, LLC',
  'Sky Management - CAC United',
  'Sky Management - PCA Family Health Plans',
  'Sky Management - PCA Health Plans',
  'Sky Management - Prucare',
  'Sky Management - Sheridan',
  'Sky Mangement - Care Florida',
  "Sloan's Lake Managed Care",
  'Smith Administrators (Ft Worth TX)',
  'Smoky Mountain Center',
  'Snap-On Incorporated (MN & TX) (WC Only)',
  'SNAP-ON INCORPORATED (WC Only) (TX,MN Only)',
  'Solstice Benefits',
  'Solvay America Inc (MN & TX) (WC Only)',
  'SOMPO JAPAN INSURANCE CO OF AMERICA',
  'SOMPO JAPAN INSURANCE CO OF AMERICA (Any State) [WC only]',
  'Sonic Automotive Inc. (WC Only)',
  'SoundPath Health',
  'South Atlantic Medical Group',
  'South Carolina Blue Medicare PPO - C63',
  'South Central Preferred - PPO York, PA (IHS Gateway Payer)',
  'South Coast Area Transit (CA) (Auto only)',
  'South Coast Area Transit (CA) (WC only)',
  'South Dakota Group 1 Assigned Risk Plan',
  'South Dakota Medicare Part A',
  'South Florida Community Care Network - Commercial',
  'South Florida Community Care Network - Medicaid',
  'South Florida Musculoskeletal Care',
  'South Point Hotel and Casino',
  'Southeast Leasing',
  'Southeast Texas (Auto Only)',
  'Southeast Texas (WC Only)',
  'Southeastern Center Coastal Care',
  'Southeastern Service Employees International Union Health & Welfare',
  'Southern Benefit Services',
  'Southern CA Lumber',
  'Southern California Edison',
  'SOUTHERN CALIFORNIA EDISON (WC Only)',
  'Southern California Risk Management',
  'Southern Group Services',
  'Southern Illinois Health Care Association',
  'Southern Lumber',
  'Southern Textile Recycling, Inc. (CA) (Auto only)',
  'Southern Textile Recycling, Inc. (CA) (WC only)',
  'Southland Claims Service, Inc. (CA, MN, TX) [WC, Auto]',
  'Southland IPA',
  'Southland San Gabriel Valley Medical Group, Inc.',
  'Southwest Airlines (SWA)',
  'SOUTHWEST AIRLINES (WC Only)',
  'Southwest Physicians Group',
  'Southwest Service Life',
  'Space Exploration Technologies Corp (Auto only)',
  'Space Exploration Technologies Corp (WC only)',
  'Spartan Stores (Non-MAD) (Auto Only)',
  'Spartan Stores (Non-MAD) (WC Only)',
  'Special Compensation Fund, MN Department of Labor (WC Only)',
  'Specialty Manufacturing Inc.',
  'Specialty Risk Services - Albertsons (CA, MN, TX) [WC, Auto]',
  'Spectrum Administrators Inc. - TPA (Allentown PA)',
  'Spectrum Information Services',
  'Spencer Stuart (ARM, LTD)',
  'Spohn Health Network',
  'Springfield Insurance Co.',
  'Sprouts Farmers Market, Inc',
  'Sprouts Farmers Market, Inc. (Auto only)',
  'Sprouts Farmers Market, Inc. (WC Only)',
  'SRS - Hilton Worldwide, Inc (TX, MN Only) (WC Only)',
  'SRS / Cargill Inc. (Auto Only)',
  'SRS / Cargill, Inc.',
  'SRS / Cargill, Inc. (WC Only)',
  'St Barnabas System Health Plan DOS Prior to 1/1/2015',
  "St John's Claims Administration",
  'St Joseph Heritage Healthcare (CA)',
  'St Lawrance Co Healthcare Plan',
  'St Marys Duluth Clinic',
  'St Paul Insurance Co (WC Only) (All States)',
  'St. Croix County (WMMIC) (Auto Only)',
  'St. Croix County (WMMIC) (WC Only)',
  'St. James PHO',
  'St. Joe High Desert',
  'St. John Knits',
  "St. Mary's IPA",
  'St. Paul Fire & Marine',
  'St. Paul Fire & Marine C#',
  'St. Paul Insurance',
  'ST. PAUL INSURANCE COMPANY OF IL (WC Only)',
  'St. Paul Towers',
  'St. Therese Physician Association',
  "St.. Mary's Health Plan Encounters",
  'Staffchex/L.A.',
  'Staffsmart Solutions/All',
  'STANDARD FORWARDING CO (MN ONLY) [WC, Auto]',
  'Standard Life and Accident Insurance Company',
  'Standard Of Excellence',
  'Stanley Steemer International Inc',
  'Stanley Works, Inc. (WC Only)',
  'Stant Corporation (MN & TX) (WC Only)',
  'State Accident Insurance Fund (SAIF) Corporation',
  'State Auto Insurance Companies',
  'State Auto Mutual Insurance Company',
  'State Auto Mutual Insurance Company (Auto only)',
  'State Compensation Insurance Fund (SCIF) (WC Only) (All States)',
  'State Compensation Insurnace Fund (Oxnard)',
  'State Compensation Insurnace Fund (Oxnard, CA)',
  'State Compensation Insurnace Fund (Santa Ana)',
  'State Compensation Insurnace Fund (State Contract Srvcs)',
  'State Farm (Casualty & Property Claims)',
  'State Farm Auto Only All States',
  'State Farm Group Medical & Individual Health Insurance Companies',
  'State Farm Property & Casualty - Work Comp Only',
  'State Farm WC Only All States',
  'State Fund Mutual',
  'State Fund Mutual (WC Only)',
  'State Health Benefit Plan (GA) HMO and State Board of Regents (for dos prior to 01/01/06)',
  'State Health Plan of South Carolina',
  'State Of Calif/Dept Of Corrections',
  'State of Idaho Department of health & Welfare',
  'State of Minnesota  DOER',
  'State of Minnesota - DOER (WC Only)',
  'State of North Carolina',
  'State of Tennessee',
  'State of Texas Dental Plan',
  'State of Wyoming (Auto)',
  'State of Wyoming (WC)',
  'State Office of Risk Management',
  'Stonebridge Life Insurance Company',
  'Stoner & Associates',
  'STONES RIVER IPA - ALLIANCE HEALTHCARE',
  'Stones River IPA - Amerivantage',
  'STONES RIVER IPA - HUMANA',
  'Stones River Regional IPA - Windsor',
  'STRATEGIC OUTSOURCING, INC (ALL) WC ONLY',
  'STRICTLY TRAILER REPAIR (ALL)  WC ONLY',
  'STRICTLY TRAILER REPAIR (ALL) AUTO ONLY',
  'Student Insurance - Boston Mutual Life Insurance Company',
  'Sua Insurance Co.',
  'SUA INSURANCE CO. (WC Only)',
  'SUA Insurance Company (WC Only) (All States)',
  'SummaCare Health Plan',
  'Summit (Bridgefield Casualty Insurance Company) (ALL) WC ONLY',
  'Summit Administration Services, Inc.',
  'Summit Health Ltd (MN & TX only)',
  'SUMMIT HEALTH LTD (WC Only)',
  'Summit Holdings',
  'Sun Mar Healthcare (Auto only)',
  'Sun Mar Healthcare (WC only)',
  'SunAmerica Life Ins Company (NFIC Plan Only)',
  'Sunrise Advantage Plan of IL',
  'Sunrise Advantage Plan of NY',
  'Sunrise Advantage Plan of PA',
  'Sunrise Advantage Plan of VA',
  'Sunrise Senior Living Inc. (Auto Only) (TX,MN Only)',
  'Superior Administrators',
  'Superior Health Plan Texas',
  'SUPERIOR INSURANCE SERVICES',
  'SUPERIOR STAFFING (ALL) AUTO ONLY',
  'SUPERIOR STAFFING (ALL) WC ONLY',
  'Superior Vision Services',
  'Supreme Court of California',
  'SURGERY ONE IPA',
  'Surgical Assoc of South Florida (Cigna)',
  'Surgical Assoc of South Florida (Health Options)',
  'Surgical Assoc of South Florida (HIP)',
  'Sutter Connect - Central Valley Med Group (Encounters)',
  'Sutter Connect - Santa Rosa Network - Encounters',
  'Sutter Connect - SIP, SMG, SWMG - Encounters',
  'Sutter Connect - Solano Regional Medical Group - Encounters',
  'Sutter Connect - Sutter Gold Medical Foundation - Encounters',
  'Sutter East Bay Medical Foundation',
  'Sutter Gould Medical Foundation',
  'Sutter Health',
  'Sutter Health Aetna',
  'Sutter Medical Foundation',
  'Sutter Pacific Medical Foundation',
  'Sutter Senior Care',
  "Svenhard's Swedish Bakery (MO ONLY) [WC, Auto]",
  'Swedish Covenant Hospital',
  'Swift Glass Corporation',
  'Swift Transportation (MN & TX) (WC Only)',
  'Symantec Software/Mt. View',
  'Syngenta Corporation (Auto only)',
  'Syngenta Corporation (WC only)',
  'SYSCO FOOD SERVICES/VENTURA, INC. (WC Only)',
  'T.H.E. Insurance',
  'TakeCare Insurance Company',
  'Takeda America Holdings, Inc. (Auto only)',
  'Takeda America Holdings, Inc. (WC only)',
  'TALBERT MEDICAL GROUP',
  'Tall Trees Administrators',
  'Tansguard Insurance Company of America (WC Only)',
  'Target',
  'Target #2088/Coleman',
  'Target Corporation (Auto Only) (TX,MN Only)',
  'Tarrant Health Services (DOS 6/30/2018 and Prior)',
  'Tarrant Health Services (DOS 7/1/2018 and After)',
  'TAXI (ALL) (Auto Only)',
  'TAXI (ALL) WC ONLY',
  'Taylor Benefits',
  'TCC (Self-Funded)',
  'TCC Benefits Administrator',
  'Team Choice PPO',
  'Teamsters Benefit Trust',
  'Teamsters Miscellaneous Security Trust Fund',
  'Technology Insurance Co (WC Only) (TX,MN Only)',
  'Telamon',
  'Tencon Health Plan',
  'TennCare Select',
  'Tennessee Bluecare',
  'Tennessee Risk Management Trust (Auto)',
  'Tennessee Risk Management Trust (WC)',
  'test',
  'TETHYS HEALTH VENTURES',
  'Texan Plus (Houston)',
  'Texas A&M  (TX Only) (WC Only)',
  'Texas Agricultural Cooperative Trust (TACT)',
  'Texas Assoc. of School Boards (Work Comp)',
  'Texas Association of School Boards (WC Only)',
  'TEXAS ASSOCIATION OF SCHOOL BOARDS WC TX',
  'Texas Builders Insurance Co (Auto only)',
  'Texas Builders Insurance Co (WC only)',
  'Texas Childrens Health Plan',
  'Texas Childrens Star Medicaid',
  'Texas Christus',
  'Texas Construction Trust (MN & TX) (WC Only)',
  'Texas General Indemnity Co. (WC Only)',
  'Texas Health Aetna',
  'Texas Health Springs',
  'Texas HealthSpring',
  'Texas Hospital Insurance Exchange (WC Only)',
  'Texas Municipal League (TML) (WC Only) (TX Only)',
  'Texas Municipal League (TML) - Employees of IEBP Only (TX Only) (WC Only)',
  'Texas Municipal League Group - PHCS Network',
  'Texas Mutual Insurance (All  States) (Auto Only)',
  'Texas Mutual Insurance (All States) (WC Only)',
  'Texas Mutual Insurance (WC Only) (All States)',
  'Texas Political Subdivisions JSIF',
  'Texas Premier Plan',
  'Texas Roadhouse, Inc. (Auto only)',
  'Texas Roadhouse, Inc. (WC only)',
  'Texas Small Business Pool (MN & TX) (WC Only)',
  'TEXAS SMALL BUSINESS POOL (WC Only) (TX,MN Only)',
  'TexasFirst Health Plan (Dallas)',
  'The Benefit Group, Inc.',
  'The Boone Group',
  'The Brodart Company',
  'The Builders Group of MN (WC Only)',
  'The Calends Group',
  'The Care Network/The Savannah Business Group',
  'The City of Amarillo',
  'The Gap Inc. (Victoria Gardens)',
  'The Gap, Inc. (Auto only)',
  'The Gap, Inc. (WC only)',
  'The General Insurance',
  'THE HARTFORD (WC ONLY)',
  'THE HARTFORD INSURANCE GROUP (MN, TX) (WC Only)',
  'The Health Exchange (Cerner Corporation)',
  'The Health Plan',
  'The Health Plan - Upper Ohio Valley',
  'The Health Plan of Western Illinois (HOWI)',
  'The Healthcare Group',
  'The Integrity Benefit Network Inc (Marietta, GA)',
  'The Jones Financial Companies, LLP (Auto only)',
  'The Jones Financial Companies, LLP (WC only)',
  'The Loomis Company',
  'The Macaluso Group',
  'The Main Street America Group / Austin Mutual (Auto)',
  'The Main Street America Group / Austin Mutual (WC)',
  'The Main Street America Group / Grain Dealers Mutual (Auto)',
  'The Main Street America Group / Grain Dealers Mutual (WC ONLY) ALL STATES',
  'The Main Street America Group / Grain Dealers Mutual (WC)',
  'The Main Street America Group / Great Lakes Casualty (Auto)',
  'The Main Street America Group / Great Lakes Casualty (WC ONLY) ALL STATES',
  'The Main Street America Group / Great Lakes Casualty (WC)',
  'The Main Street America Group / Main Street America Assurance',
  'The Main Street America Group / Main Street America Assurance (WC ONLY) ALL STATES',
  'The Main Street America Group / Main Street America Assurance (WC)',
  'The Main Street America Group / MSA Insurance Protection (Auto)',
  'The Main Street America Group / MSA Insurance Protection (WC ONLY) ALL STATES',
  'The Main Street America Group / MSA Insurance Protection (WC)',
  'The Main Street America Group / MSAIC Surplus/Non-Admitted (Auto)',
  'The Main Street America Group / MSAIC Surplus/Non-Admitted (WC ONLY) ALL STATES',
  'The Main Street America Group / MSAIC Surplus/Non-Admitted (WC)',
  'The Main Street America Group / NGM (Auto)',
  'The Main Street America Group / NGM (WC ONLY) ALL STATES',
  'The Main Street America Group / NGM (WC)',
  'The Main Street America Group / Old Dominion Insurance Company (Auto)',
  'The Main Street America Group / Old Dominion Insurance Company (WC ONLY) ALL STATES',
  'The Main Street America Group / Old Dominion Insurance Company (WC)',
  'The Main Street America Group / Spring Valley Mutual (Auto)',
  'The Main Street America Group / Spring Valley Mutual (WC ONLY) ALL STATES',
  'The Main Street America Group / Spring Valley Mutual (WC)',
  'The Mega Life and Health Insurance Co (N. Richland Hills TX) (Subrogation Claims Only)',
  'The National Radiology Network (TNRN)',
  'The Reny Company',
  'The Salvation Army',
  'The Scotts Company (MN & TX) (WC Only)',
  'The Union Labor Life Insurance Company',
  'The Zenith (WC Only) (All States)',
  'Theraphysics-Colorado Only',
  'Therapy Direct',
  'Third Coast Underwriters (3CU)',
  'Third Party Claims Management / TPCM',
  'Thomas Cooper Agency',
  'Thomas McGee (Auto Only)',
  'Thomas McGee (WC Only)',
  'Three Rivers Preferred',
  'TIC International, Inc',
  'Tidewater Marine Western (Auto Only)',
  'Tidewater Marine Western (WC Only)(All States)',
  'TIFT REGIONAL',
  'TLC Advantage',
  'TLC BENEFIT SOLUTIONS',
  'TN IPA',
  "Today's Option(American Progressive and Pyramid Life)Houston",
  'Tongass Timber Trust',
  'TOPA Insurance Company',
  'Torrance Hospital IPA',
  'Torrance Memorial Medical Center',
  'Total Care',
  'Total Claims Solutions',
  'Total Community Care',
  'Total Healthcare, Inc.',
  'Total Petroleum, Inc. (MN & TX) (WC Only)',
  'Touchpoint Solutions CRM',
  'Touchstone  Health PSO',
  'Tower Energy Group (Auto only)',
  'Tower Energy Group (WC only)',
  'Tower Group (WC Only) (All States)',
  'Tower National Insurance Co',
  'Tower National Insurance Co. (Auto Only)',
  'Town of Colma (CA) (Auto only)',
  'Town of Colma (CA) (WC only)',
  'TPAC/The Physicians Assurance Corporation',
  'TPS Joint Self Insurance Fund (MN & TX) (WC Only)',
  'TR Paul Inc',
  'Tractor Supply Company',
  'TRANSACT RX PART D',
  'TransactRX Infusion and Specialty',
  'TransAmerica Assurance Company (TLINS)',
  'Transamerica Financial Life Insurance Company',
  'Transamerica Premier Life Insurance Company',
  'TransChoice-Key Benefit Administrators',
  'Transcontinental Insurance Co (Auto Only)',
  'Transwestern',
  'TRASH - ALL TRANSACTIONS WILL BE DISCARDED',
  'Travelers Auto (Auto Only) (TX/MN/CA Only)',
  'TRAVELERS CASUALTY AND SURETY COMPANY (AUTO Only)',
  'TRAVELERS CASUALTY AND SURETY COMPANY (WC Only)',
  'Travelers Casualty Ins. Co of Amer (WC Only) (All States)',
  'TRAVELERS INDEMNITY (AUTO Only)',
  'Tri-State Ins Co',
  'Tri-Valley Medical Group',
  'TRIAD Healthcare Inc (Plainville CT)',
  'TRIBAL FIRST INSURANCE (WC Only)',
  'Tribute Health Plan (Formerly Central Benefits Mutual)',
  'Tribute Health Plan of Oklahoma',
  'Tricare (Foreign Regions)',
  'Tricare East (Formerly Tricare North and South effective 1/1/18 DOS and after)',
  'Tricare for Life (Claims & Eligibility Only)',
  'TRICARE OVERSEAS',
  'Tricare West Region',
  'TriCities IPA',
  'TRIDENT INSURANCE (MN, TX) AUTO ONLY',
  'TriHealth Physician Solutions',
  'Trillium Staffing Solutions (Auto only)',
  'Trillium Staffing Solutions (WC only)',
  'Trinidad Rancheria',
  'Trinity Health Pace',
  'Trinity Universal Insurance (Auto Only) (MN Only)',
  'Triple A (MN Only) (Auto Only)',
  'TRIPLE S - PUERTO RICO',
  'Triplefin LLC',
  'TRISTAR (LA CNTY-SHERIFFS) (CA,TX,MN) (WC Only)',
  'TriStar Benefit Administration (PHCS Eagan, MN))',
  'Tristar Risk Management - Corpus Christi (Hidalgo County)',
  'Tristar Risk Management - Elk Grove',
  'Tristar Risk Management - Irving (Ft Worth ISD)',
  'Tristate Benefit Solutions (TPA)',
  'TRLHN/EB',
  'True Health New Mexico',
  'TRUGREEN LANDCARE (WC Only)',
  'Trusted Health Plan',
  'Trusteed Plans Management',
  'Trustmark',
  'TU Blue Shield Care 1st CMC',
  'TU Blue Shield Care 1st Medicare',
  'Tuality Health Alliance',
  'Tuality Health Select',
  'TUFTS',
  'TulareCare',
  'TX Premier Plan(Star HMO) Medicaid',
  'Tyson Foods Inc.',
  'U.S. Steel (MN Only) (WC Only)',
  'UC Davis Health System',
  'UCARE of Minnesota',
  'UCLA Medical Group',
  'UCS - BASI: Air Design Heating & Cooling',
  'UCS - BASI: Belue Trucking Company',
  'UCS - BASI: Big Horn Federal',
  'UCS - BASI: Boulder Administraton Services',
  'UCS - BASI: Ceiling Systems',
  'UCS - BASI: Dunham Rubber & Belting Corporation',
  'UCS - BASI: Golden Eagle Construction',
  'UCS - BASI: Hanson Trucking',
  'UCS - BASI: Idaho Asphalt Supply',
  'UCS - BASI: Inland Construction & Development Co.',
  'UCS - BASI: Innovative Health Care Concepts',
  'UCS - BASI: Knight Construction & Supply',
  'UCS - BASI: Nitro Green Helena',
  'UCS - BASI: Northwest River Supplies',
  'UCS - BASI: Plexis Healthcare Systems',
  'UCS - BASI: Raphael Health Center',
  'UCS - BASI: Reading Horizons',
  'UCS - BASI: Rehab Strategies',
  'UCS - BASI: Senior Suites at Woodside Village',
  'UCS - BASI: Somont Oil Company',
  'UCS - BASI: South State Trailer Supply',
  'UCS - BASI: Tempest Technologies',
  'UCS - BASI: Tenowo Inc.',
  'UCS - BASI: TrailWest Bank',
  "UCS - BASI: Van's Inc",
  'UCS - BASI: Whitefish Credit Union',
  'UCS - BASI: Williams Plumbing & Heating',
  'UCS - Electric Workers Insurance Fund',
  'UCS - Leonard Holding Company',
  'UCS - The City of East Chicago',
  'UCS - Winston Hospitality',
  'UCS BASI: Consolidated Turbine',
  'UCS Benefit Management Administrators',
  'UCS HEWITT COLEMAN',
  'UCS Kempton Group TPA: Shawnee Milling Co.',
  'UCS Maxor Administrative Services',
  'UCS-BASI: DC WELDING & CONSTRUCTION',
  'UCS-BASI: Meter Group USA',
  'UCT (Auto Only)',
  'UCT (WC Only)',
  'UDR, Inc.',
  'UDR, Inc. (Auto)',
  'UFCW Local 400-5205 - Dates of Service prior to 9/1/09',
  'UFCW Northern California & Drug Employees H&W Trust Fund',
  'UICI Administrators - Nevada',
  'UK University Health Service',
  'Ultimate Health Plan',
  'Ultra Benefits Inc',
  'UMC HEALTH PLAN',
  'Umpqua Health Alliance',
  'UMWA Health & Retirement Funds',
  'Underwriters Safety and Claims (MN & TX) (WC Only)',
  'UNICARE',
  'Unicare (Old John Hancock)',
  'Unified Group Services',
  'Unified Health Services',
  'Unified Health Services (WC Claims Only)',
  'UNIFIED IPA',
  'Unified Physicians Network, Inc.',
  'Uniformed Services Family Health Plan (USFHP) - St Vincent Catholic Medical Centers of New York',
  'Uniformed Services Family Health Plan Texas & Louisiana',
  'Union Friend Group (TX ONLY) [WC, Auto]',
  'Union Insurance (TX)',
  'Union Insurance Co (MN & TX) (WC Only)',
  'Union Insurance Company',
  'Union Insurance Company of Providence (WC Only) (All States)',
  'UNION PACIFIC RAIL/INJURIES (MN,TX) (WC Only)',
  'Union Pacific Railroad Employees',
  'Union Standard Insurance Company (MN & TX) (WC Only)',
  'United Care Medical Group',
  'United Dominion Realty Trust (MN & TX) (WC Only)',
  'United Financial Casualty Company',
  'United Financial Casualty Company (Auto Only) (MN Only)',
  'United Financial Casualty Company (WC Only)',
  'United Fire',
  'United Fire (All States) (Auto Only)',
  'United Fire (ANY STATE)  (Auto Only)',
  'United Fire (ANY STATE) (WC Only)',
  'UNITED FIRE WC ONLY ANY STATE',
  'United Food & Commerce Wrkrs Local 1529',
  'United Food and Commercial Workers Union and Food Employers (So. California, Cypress)',
  'United Group Programs',
  'United Health Care',
  'United Health Care (Subrogation Claims Only)',
  'United Health Care Community Plan',
  'United health Integrated Services',
  'United Health Integrated Services (Subrogation Claims Only)',
  'United Healthcare NDC Repricer',
  "United Heartland (Worker's Comp)",
  'UNITED PACIFIC INSURANCE CO',
  'United Physician International',
  'United Physicians of Northern Colorado',
  'United Security Life & Health',
  'United Self Insured Services - USIS',
  'United States Automobile Association (USAA) - Property & Casualty Only',
  'United States Cold Storage (MN & TX) (WC Only)',
  'UNITED STATES FIDELITY&GUARANTY CO',
  'United States Fire Insurance (Auto Only)',
  'United States Fire Insurance Co (MN & TX) (WC Only)',
  'United States Virgin Islands Medicaid (Hospital/Institutional Only)',
  'United States Virgin Islands Medicaid (Medical/Professional Only)',
  'United Wisconsin Insurance Company (WC Only)',
  'United Wisconsin Insurance Company/United Heartland (Auto Only)',
  'United Wisconsin Insurance Company/United Heartland (WC Only)',
  'UnitedHealth Group  (TX,MN ONLY) AUTO ONLY',
  'UnitedHealthcare Community Plan / NJ',
  'UnitedHealthcare Community Plan Kansas (KanCare)',
  'UnitedHealthcare Community Plan Missouri',
  'UnitedHealthcare Great Lakes Health Plan',
  'UnitedHealthcare Medicare Solutions / Care Improvement Plus (CIP), XLHealth',
  'UnitedHealthcare West / Encounters',
  'Unitrin Direct Property & Casualty Company (Auto Only) (MN Only)',
  'Unity Health Insurance',
  'Univera Healthcare - Managed Care',
  'Univera PPO',
  'Universal Care of California',
  'UNIVERSAL HEALTH SERVICES (TX,MN,CA Only) (WC Only)',
  'University Family Care',
  'University Health Alliance',
  'University Health Care Advantage',
  'University Healthcare Marketplace',
  'University of Kentucky Health Services (Auto only)',
  'University of Kentucky Health Services (WC only)',
  'University of Utah Health Plans',
  'University of Utah Health Plans (Healthy U)',
  'University Physicians Healthcare Group',
  'UPMC Health Plan',
  'UPMC Vision Advantage',
  'Upper Peninsula Health Group TPA',
  'Upper Peninsula Health Plan',
  'US Benefits - Portland, Oregon',
  'US Family Health Plan',
  'US Foodservice, Inc.',
  'US Foodservice, Inc. (MN & TX) (WC Only)',
  'US Imaging',
  'US NATIONAL RESOURCES (AIGRM)',
  'US National Resources (Aigrm) (MN & TX) (WC Only)',
  'US POST OFFICE/SANTA PAULA (WC Only)',
  'US SPECIALTY INSURANCE (MN, TX) (Auto Only)',
  'US Sugar Corporation (Auto only)',
  'US Sugar Corporation (WC only)',
  'USAA',
  'USAA - SACRAMENTO (Auto Only)',
  'USAA - SACRAMENTO (WC Only)',
  'USAble',
  'USC - Guarantee Insurance Limited WC - Any State',
  'USC Guarantee Insurance Limited (Auto Only) Any State',
  'USC Health Services',
  'USC Inservco (Limited) (WC)',
  'Usc-Amerihealth Insurance Co. (Limited)',
  'USS-POSCO Industries',
  'Utica (MN Only) (Auto Only)',
  'Utica Mutual Insurance Co (MN & TX)  (WC Only)',
  'UTICA MUTUAL INSURANCE CO (WC Only) (TX/MN/CA/LA Only)',
  'Utica Mutual Insurance Co of Texas (WC Only) (TX,MN,CA,LA Only)',
  'Utica National Insurance Co of Texas (WC Only) (TX,MN,CA,LA Only)',
  'UTMB 3 SHARE PROGRAM',
  'UTMB CARE',
  'VA DIALYSIS ONLY VA FSC',
  'VA Fee Basis Program',
  'Valir Pace (Formerly Via Christi Hope)',
  'Valitas Health Service, Inc. dba Corizon Health',
  'Valley Baptist Advantage',
  'Valley Care IPA',
  'VALLEY CARE SELECT IPA',
  'VALLEY HEALTH ADMINISTRATORS',
  'Valley Health Plan (Commercial)',
  'Valley Health Plan (Medi-Cal)',
  'Valley Mental Health',
  'Valley of the Moon (CA)',
  'Value Options',
  'VALUE OPTIONS PA BEHAVIORAL HEALTH',
  'Value Options PA Medicaid',
  'ValueOptions/MBHP',
  'Vanliner Insurance Co (Auto Only)',
  'Vanliner Insurance Co (WC only)',
  'Vantage Health Plan Inc',
  'Vantage Medical Group',
  'Variable Protection Administrators (VPA)',
  'Velocity Vehicle Group (Doi > 4/15/2012 Or Later) (Auto only)',
  'Velocity Vehicle Group (Doi > 4/15/2012 Or Later) (WC only)',
  'Vensure Employer Services',
  'Veolia Environmental Services (Auto Only) (TX,MN Only)',
  'Verdugo Hills Medical Group',
  'Verify',
  'Verify Plus',
  'Verity National Group',
  'Vestacare',
  'VGM Homelink',
  'VIAD CORP (MN)',
  'Vibra Health Plan',
  'Vicorp Restaurants, Inc. (MN & TX only) (WC Only)',
  'Victoria/Titan Ins (Auto Only) (MN Only)',
  'Vida Care (NY)',
  'VieCare LIFE Butler',
  'VILLAGE FAMILY PHYSICIAN',
  'Village MD',
  'VillageCareMAX',
  'Virgina Premier CompleteCare (DOS 12/31/2017 and PRIOR)',
  'VIRGINIA COORDINATED CARE',
  'Virginia Premier',
  'VIRGINIA PREMIER ELITE',
  'VIRGINIA PREMIER ELITE PLUS',
  'VIRGINIA PREMIER MEDALLION 4',
  'VIRGINIA PREMIER MEDICARE ADVANTAGE PART D',
  'Virginia Surety Company, Inc. (All States) (Auto Only)',
  'Virginia Surety Company, Inc. (All States) (WC Only)',
  'Vista360Health',
  'VITAS HEALTHCARE (CAMARILLO) (WC Only)',
  'Viva Health Plan',
  'VNA Homecare Options',
  'VNSNY CHOICE Medicare',
  'VOLUSIA HEALTH NETWORK',
  'Vought Aircraft Industries (WC Only)',
  'Vulcan Materials (AUTO ONLY)',
  'Vulcan Materials (WC ONLY)',
  'Vytra Healthcare',
  "WA Workers' Comp",
  "WA Workers' Comp - Outpatient",
  'Wabash Memorial Hospital Association',
  'Wachovia (Wells Fargo effective 1-1-09) (TX, MN ONLY) [WC ONLY]',
  'WAGNER MEINERT',
  'Wal-Mart',
  'Wal-mart (TX and MN Only) (WC Only)',
  'Wal-Mart Corporate (Workers Comp)',
  'Washington Apple Health (previously WA Medicaid)',
  'WASHINGTON COUNTY GENERAL FUND',
  'Washington County Health and Human Services',
  'Washington Workers Comp Crime Prevention',
  'Waterstone Benefit Administrators',
  'Watts Health Care',
  'WAUSAU (WC Only)',
  'WE Energies',
  'WE ENERGIES (ALL) WC ONLY',
  'Weiss Health Providers',
  'Well Done Property Maintenance',
  'WellCare Health Plan (Encounters Only)',
  'Wellcare HMO, Inc.',
  'WellCare of CT (Encounters Only)',
  'WellCare of FL (Encounters Only)',
  'WellCare of GA (Encounters Only)',
  'WellCare of HI (Encounters Only)',
  'WellCare of IL (Encounters Only)',
  'WellCare of IN (Encounters Only)',
  'Wellcare of Iowa, Inc.  (Encounters Only) (Effective 3/1/2016)',
  'WellCare of LA (Encounters Only)',
  'WellCare of MO (Encounters Only)',
  'WellCare of NY (Encounters Only)',
  'WellCare of OH (Encounters Only)',
  'Wellmark Administrators/IA providers only',
  'WELLMED',
  'WellMed (Encounters)',
  'WELLPOINT (WC Only)',
  'WELLS FARGO (AUTO) (TX,MN)',
  'WELLSPAN EMPLOYEE ASSISTANCE PROGRAM',
  'WellSystems LLC',
  "WENDY'S #8980/FONTANA (WC Only)",
  'Wesco Insurance Co (WC Only) (TX,MN,CA Only)',
  'WEST BEND MUTUAL INSURANCE COMPANY (MN, TX) (WC Only)',
  'West Suburban Health Providers',
  'West Virginia Family Health Plan',
  'Western Agricultural Insurance Company (Auto Only) (MN Only)',
  "Western Grower's Insurance Company",
  'Western Health Advantage',
  'Western Mutual Insurance / WMI-TPA',
  'Western National (Auto Only) (MN/TX/CA Only)',
  'Western National (WC Only) (TX/MN/CA Only)',
  'Western National Assurance (Auto only)',
  'Western National Assurance (WC only)',
  'Western National Insurance / Pioneer Specialties (Auto only)',
  'Western National Insurance / Pioneer Specialties (WC only)',
  'Western National Insurance Group (WC Only)(All States)',
  'WESTERN NATIONAL, INC. (CA,MN,TX) (WC Only)',
  'Western Oregon Advanced Health',
  'Western Southern Financial Group (Cincinnati, OH)',
  'Westfield Insurance (Auto only)',
  'Westfield Insurance (WC only)',
  'Westlake Financial Group, Inc',
  'Weyerhaeuser Co',
  'White Wave/Morning Star North',
  'WHOLE FOODS/LA JOLLA (Auto Only)',
  'WI Claim Management Services (CMS)',
  'Willamette Valley Community Health',
  'William C. Earhart',
  'Williams & Sonoma',
  'Willis Administrative Services Corporation/Fiserv',
  'Willow Health',
  'WILSON MUTUAL INSURANCE (MN & WI) (WC Only)',
  'Wilson Mutual Insurance (MN/WI ONLY) (Auto Only)',
  'WINDSOR GARDENS OF HAWTHORNE (Auto Only)',
  'WinHealth',
  'Winn-Dixie',
  'Wisconsin Auto & Truck Dealers',
  'Wisconsin Chronic Disease Program',
  'Wisconsin Department of Corrections - WDOC',
  'Wisconsin Physician Services-Midlands',
  'Wisconsin Physicians Service Group Health / WPS',
  'Wisconsin Well Woman Program',
  "Women's Integrated Network, Inc. (WIN Fertility)",
  'WOODLAND FARMS (Auto Only)',
  'WOODLAND FARMS (WC Only)',
  'Woodman Accident and Life Co (AICT Plans Only)',
  'Woodmen of the World/Omaha Woodmen Life Insurance Society',
  'Workers Comp of West Virginia',
  'Workforce Outsourcing/All',
  'Workforce Safety and Insurance (WSI)',
  'Worksite Benefit Services',
  'WPP-ElderCare Wisconsin',
  'WPS Dept of Veterans Affairs VA Program',
  'Wyman-Gordon Companies (TX and MN Only) (WC Only)',
  'Wyoming PACE',
  'Xcel Energy (Auto only)',
  'Xcel Energy (WC only)',
  'Xchanging, Inc (TX Only) (WC Only)',
  'Xl Environmental, Inc. (TX and MN only) (WC Only)',
  'YALE UNIVERSITY HEALTH PLAN',
  'Yamhill Co. Care Org.',
  'YAMHILL COUNTY CCO (MENTAL HEALTH)',
  'Yavapai County',
  'York Claim Services',
  'YORK CLAIM SERVICES (ANY STATE) AUTO ONLY (MUST HAVE CLAIMS ATTACHMENTS ON BILL PLAN)',
  'York Risk Services Group',
  'YourCare (formerly Monroe Plan for Medical Care)',
  'Zachry Construction (All States) (WC Only)',
  'Zebra Health HC',
  'Zenith Administrators',
  'ZENITH INS CO (WC Only)',
  'ZirMed Test Payer_',
  'ZNAT INSURANCE (ZENITH NATIONAL) (WC Only)',
  'Znat Insurance (Zenith National) (WC Only) (All States)',
  'ZURICH AMERICAN INSURANCE COMPANY (WC Only) (TX,CA,MN Only)',
  'ZURICH AMERICAN INSURANCE COMPANY (WC Only) (TX/MN/CA,LA,NM,NC Only)',
  'ZURICH FARMERS',
  'Zurich Farmers (CA,MN,TX,LA,NM,NC)',
  'Zurich Insurance N.A.  (WC Only) (TX/MN/CA Only)',
  'ZURICH LIFE (Auto Only)',
];

export default carrierNames;
